//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PARROT_API_BASE_URL = new InjectionToken<string>('PARROT_API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PARROT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/parrot_subscription";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCoordonneesComptesBancairesPrelevement(body: GetCoordonneesComptesBancairesPrelevementRequest | undefined): Observable<GetCoordonneesComptesBancairesPrelevementResponse> {
        let url_ = this.baseUrl + "/WsCoordonneesBancaires/getCoordonneesComptesBancairesPrelevement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordonneesComptesBancairesPrelevement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordonneesComptesBancairesPrelevement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCoordonneesComptesBancairesPrelevementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCoordonneesComptesBancairesPrelevementResponse>;
        }));
    }

    protected processGetCoordonneesComptesBancairesPrelevement(response: HttpResponseBase): Observable<GetCoordonneesComptesBancairesPrelevementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoordonneesComptesBancairesPrelevementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForNewSourcePrelevement(body: UpdateForNewSourcePrelevementRequest | undefined): Observable<UpdateForNewSourcePrelevementResponse> {
        let url_ = this.baseUrl + "/WsCoordonneesBancaires/updateForNewSourcePrelevement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForNewSourcePrelevement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForNewSourcePrelevement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateForNewSourcePrelevementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateForNewSourcePrelevementResponse>;
        }));
    }

    protected processUpdateForNewSourcePrelevement(response: HttpResponseBase): Observable<UpdateForNewSourcePrelevementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateForNewSourcePrelevementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCoordonneesComptesBancairesReglement(body: GetCoordonneesComptesBancairesReglementRequest | undefined): Observable<GetCoordonneesComptesBancairesReglementResponse> {
        let url_ = this.baseUrl + "/WsCoordonneesBancaires/getCoordonneesComptesBancairesReglement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordonneesComptesBancairesReglement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordonneesComptesBancairesReglement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCoordonneesComptesBancairesReglementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCoordonneesComptesBancairesReglementResponse>;
        }));
    }

    protected processGetCoordonneesComptesBancairesReglement(response: HttpResponseBase): Observable<GetCoordonneesComptesBancairesReglementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoordonneesComptesBancairesReglementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPays(body: GetAllPaysRequest | undefined): Observable<GetAllPaysResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getAllPays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPaysResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPaysResponse>;
        }));
    }

    protected processGetAllPays(response: HttpResponseBase): Observable<GetAllPaysResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPaysResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchClient(body: SearchClientRequest | undefined): Observable<SearchClientResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/searchClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchClientResponse>;
        }));
    }

    protected processSearchClient(response: HttpResponseBase): Observable<SearchClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getClientByNumeroClientA(body: GetClientByNumeroClientARequest | undefined): Observable<GetClientByNumeroClientAResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getClientByNumeroClientA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByNumeroClientA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByNumeroClientA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByNumeroClientAResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByNumeroClientAResponse>;
        }));
    }

    protected processGetClientByNumeroClientA(response: HttpResponseBase): Observable<GetClientByNumeroClientAResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByNumeroClientAResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMotifsCSP(body: GetMotifsCSPRequest | undefined): Observable<GetMotifsCSPResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getMotifsCSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotifsCSP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotifsCSP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMotifsCSPResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMotifsCSPResponse>;
        }));
    }

    protected processGetMotifsCSP(response: HttpResponseBase): Observable<GetMotifsCSPResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMotifsCSPResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllReference(body: GetAllReferenceRequest | undefined): Observable<GetAllReferenceResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getAllReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllReferenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllReferenceResponse>;
        }));
    }

    protected processGetAllReference(response: HttpResponseBase): Observable<GetAllReferenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllReferenceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFilleuls(body: GetFilleulsRequest | undefined): Observable<GetFilleulsResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getFilleuls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilleuls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilleuls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFilleulsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFilleulsResponse>;
        }));
    }

    protected processGetFilleuls(response: HttpResponseBase): Observable<GetFilleulsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFilleulsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMotifsPPE(body: GetMotifsPPERequest | undefined): Observable<GetMotifsPPEResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getMotifsPPE";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotifsPPE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotifsPPE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMotifsPPEResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMotifsPPEResponse>;
        }));
    }

    protected processGetMotifsPPE(response: HttpResponseBase): Observable<GetMotifsPPEResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMotifsPPEResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getClientByIdCrm(body: GetClientByIdCrmRequest | undefined): Observable<GetClientByIdCrmResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/getClientByIdCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByIdCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByIdCrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByIdCrmResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByIdCrmResponse>;
        }));
    }

    protected processGetClientByIdCrm(response: HttpResponseBase): Observable<GetClientByIdCrmResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByIdCrmResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    prospectToClient(body: ProspectToClientRequest | undefined): Observable<ProspetToClientResponse> {
        let url_ = this.baseUrl + "/WsCRMClient/prospectToClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProspectToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProspectToClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProspetToClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProspetToClientResponse>;
        }));
    }

    protected processProspectToClient(response: HttpResponseBase): Observable<ProspetToClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProspetToClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createResultatQuestionnaire(body: CreateResultatQuestionnaireRequest | undefined): Observable<CreateResultatQuestionnaireResponse> {
        let url_ = this.baseUrl + "/WsCRMQuestionnaire/createResultatQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateResultatQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateResultatQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResultatQuestionnaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResultatQuestionnaireResponse>;
        }));
    }

    protected processCreateResultatQuestionnaire(response: HttpResponseBase): Observable<CreateResultatQuestionnaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateResultatQuestionnaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getQuestionnaire(body: GetQuestionnaireRequest | undefined): Observable<GetQuestionnaireResponse> {
        let url_ = this.baseUrl + "/WsCRMQuestionnaire/getQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuestionnaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuestionnaireResponse>;
        }));
    }

    protected processGetQuestionnaire(response: HttpResponseBase): Observable<GetQuestionnaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuestionnaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getInfosProfilEpargnant(body: GetInfosProfilEpargnantRequest | undefined): Observable<GetInfosProfilEpargnantResponse> {
        let url_ = this.baseUrl + "/WsCRMQuestionnaire/getInfosProfilEpargnant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfosProfilEpargnant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfosProfilEpargnant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInfosProfilEpargnantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInfosProfilEpargnantResponse>;
        }));
    }

    protected processGetInfosProfilEpargnant(response: HttpResponseBase): Observable<GetInfosProfilEpargnantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInfosProfilEpargnantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheComplementAdresse(body: RechercheComplementAdresseRequest | undefined): Observable<RechercheComplementAdresseResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheComplementAdresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheComplementAdresse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheComplementAdresse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheComplementAdresseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheComplementAdresseResponse>;
        }));
    }

    protected processRechercheComplementAdresse(response: HttpResponseBase): Observable<RechercheComplementAdresseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheComplementAdresseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheAdresse(body: RechercheAdresseRequest | undefined): Observable<RechercheAdresseResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheAdresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheAdresse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheAdresse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheAdresseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheAdresseResponse>;
        }));
    }

    protected processRechercheAdresse(response: HttpResponseBase): Observable<RechercheAdresseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheAdresseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheVille(body: RechercheVilleRequest | undefined): Observable<RechercheVilleResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheVille";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheVille(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheVille(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheVilleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheVilleResponse>;
        }));
    }

    protected processRechercheVille(response: HttpResponseBase): Observable<RechercheVilleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheVilleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheSIRET(body: RechercheSIRETRequest | undefined): Observable<RechercheSIRETResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheSIRET";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheSIRET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheSIRET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheSIRETResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheSIRETResponse>;
        }));
    }

    protected processRechercheSIRET(response: HttpResponseBase): Observable<RechercheSIRETResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheSIRETResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheCodePostal(body: RechercheCodePostalRequest | undefined): Observable<RechercheCodePostalResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheCodePostal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheCodePostal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheCodePostal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheCodePostalResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheCodePostalResponse>;
        }));
    }

    protected processRechercheCodePostal(response: HttpResponseBase): Observable<RechercheCodePostalResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheCodePostalResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validationEmail(body: ValidationEmailRequest | undefined): Observable<ValidationEmailResponse> {
        let url_ = this.baseUrl + "/WsDQE/validationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationEmailResponse>;
        }));
    }

    protected processValidationEmail(response: HttpResponseBase): Observable<ValidationEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    controleFormulaire(body: ControleFormulaireRequest | undefined): Observable<ControleFormulaireResponse> {
        let url_ = this.baseUrl + "/WsDQE/controleFormulaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControleFormulaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControleFormulaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControleFormulaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControleFormulaireResponse>;
        }));
    }

    protected processControleFormulaire(response: HttpResponseBase): Observable<ControleFormulaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControleFormulaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheGeolocalisation(body: RechercheGeolocalisationRequest | undefined): Observable<RechercheGeolocalisationResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheGeolocalisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheGeolocalisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheGeolocalisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheGeolocalisationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheGeolocalisationResponse>;
        }));
    }

    protected processRechercheGeolocalisation(response: HttpResponseBase): Observable<RechercheGeolocalisationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheGeolocalisationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validationNumTel(body: ValidationNumTelRequest | undefined): Observable<ValidationNumTelResponse> {
        let url_ = this.baseUrl + "/WsDQE/validationNumTel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationNumTel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationNumTel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationNumTelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationNumTelResponse>;
        }));
    }

    protected processValidationNumTel(response: HttpResponseBase): Observable<ValidationNumTelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationNumTelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheComplementAdresseSaisie(body: RechercheComplementAdresseSaisieRequest | undefined): Observable<RechercheComplementAdresseSaisieResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheComplementAdresseSaisie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheComplementAdresseSaisie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheComplementAdresseSaisie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheComplementAdresseSaisieResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheComplementAdresseSaisieResponse>;
        }));
    }

    protected processRechercheComplementAdresseSaisie(response: HttpResponseBase): Observable<RechercheComplementAdresseSaisieResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheComplementAdresseSaisieResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    autoCompletionEmail(body: AutoCompletionEmailRequest | undefined): Observable<AutoCompletionEmailResponse> {
        let url_ = this.baseUrl + "/WsDQE/autoCompletionEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoCompletionEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoCompletionEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutoCompletionEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutoCompletionEmailResponse>;
        }));
    }

    protected processAutoCompletionEmail(response: HttpResponseBase): Observable<AutoCompletionEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutoCompletionEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercheRue(body: RechercheRueRequest | undefined): Observable<RechercheRueResponse> {
        let url_ = this.baseUrl + "/WsDQE/rechercheRue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheRue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheRue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheRueResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheRueResponse>;
        }));
    }

    protected processRechercheRue(response: HttpResponseBase): Observable<RechercheRueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheRueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPolices(body: GetPolicesRequest | undefined): Observable<GetPolicesResponse> {
        let url_ = this.baseUrl + "/WsGetPolices/getPolices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolicesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolicesResponse>;
        }));
    }

    protected processGetPolices(response: HttpResponseBase): Observable<GetPolicesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolicesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getContratsTransferablesFourgous(body: GetContratsTransferablesFourgousRequest | undefined): Observable<GetContratsTransferablesFourgousResponse> {
        let url_ = this.baseUrl + "/WsPolices/getContratsTransferablesFourgous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContratsTransferablesFourgous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContratsTransferablesFourgous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContratsTransferablesFourgousResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContratsTransferablesFourgousResponse>;
        }));
    }

    protected processGetContratsTransferablesFourgous(response: HttpResponseBase): Observable<GetContratsTransferablesFourgousResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContratsTransferablesFourgousResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSupportsContrat(body: GetSupportsContratRequest | undefined): Observable<GetSupportsContratResponse> {
        let url_ = this.baseUrl + "/WsPolices/getSupportsContrat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportsContrat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportsContrat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSupportsContratResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSupportsContratResponse>;
        }));
    }

    protected processGetSupportsContrat(response: HttpResponseBase): Observable<GetSupportsContratResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupportsContratResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getClientByNumeroContrat(body: GetClientByNumeroContratRequest | undefined): Observable<GetClientByNumeroContratResponse> {
        let url_ = this.baseUrl + "/WsPolices/getClientByNumeroContrat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByNumeroContrat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByNumeroContrat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByNumeroContratResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByNumeroContratResponse>;
        }));
    }

    protected processGetClientByNumeroContrat(response: HttpResponseBase): Observable<GetClientByNumeroContratResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByNumeroContratResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPolices2(body: GetPolicesRequest2 | undefined): Observable<GetPolicesResponse2> {
        let url_ = this.baseUrl + "/WsPolices/getPolices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolices2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolices2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolicesResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolicesResponse2>;
        }));
    }

    protected processGetPolices2(response: HttpResponseBase): Observable<GetPolicesResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolicesResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercherRachat(body: RechercheRachatRequest | undefined): Observable<RechercheRachatResponse> {
        let url_ = this.baseUrl + "/WsPolices/rechercherRachat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherRachat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherRachat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheRachatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheRachatResponse>;
        }));
    }

    protected processRechercherRachat(response: HttpResponseBase): Observable<RechercheRachatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheRachatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDemarchesEnCours(body: GetDemarchesEnCoursRequest | undefined): Observable<GetDemarchesEnCoursResponse> {
        let url_ = this.baseUrl + "/WsPolices/getDemarchesEnCours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDemarchesEnCours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDemarchesEnCours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDemarchesEnCoursResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDemarchesEnCoursResponse>;
        }));
    }

    protected processGetDemarchesEnCours(response: HttpResponseBase): Observable<GetDemarchesEnCoursResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDemarchesEnCoursResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRepartitionContratMultisupport(body: GetRepartitionContratMultisupportRequest | undefined): Observable<GetRepartitionContratMultisupportResponse> {
        let url_ = this.baseUrl + "/WsPolices/getRepartitionContratMultisupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepartitionContratMultisupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepartitionContratMultisupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRepartitionContratMultisupportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRepartitionContratMultisupportResponse>;
        }));
    }

    protected processGetRepartitionContratMultisupport(response: HttpResponseBase): Observable<GetRepartitionContratMultisupportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRepartitionContratMultisupportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rechercherAvenantNantissement(body: RechercheAvenantNantissementRequest | undefined): Observable<RechercheAvenantNantissementResponse> {
        let url_ = this.baseUrl + "/WsPolices/rechercherAvenantNantissement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherAvenantNantissement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherAvenantNantissement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheAvenantNantissementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheAvenantNantissementResponse>;
        }));
    }

    protected processRechercherAvenantNantissement(response: HttpResponseBase): Observable<RechercheAvenantNantissementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheAvenantNantissementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTarifsPrevoyanceGFD(body: GetTarifsPrevoyanceGFDRequest | undefined): Observable<GetTarifsPrevoyanceGFDResponse> {
        let url_ = this.baseUrl + "/WsPrevoyanceGFD/getTarifsPrevoyanceGFD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifsPrevoyanceGFD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifsPrevoyanceGFD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTarifsPrevoyanceGFDResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTarifsPrevoyanceGFDResponse>;
        }));
    }

    protected processGetTarifsPrevoyanceGFD(response: HttpResponseBase): Observable<GetTarifsPrevoyanceGFDResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTarifsPrevoyanceGFDResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTarifsPrevoyanceGPA(body: GetTarifsPrevoyanceGPARequest | undefined): Observable<GetTarifsPrevoyanceGPAResponse> {
        let url_ = this.baseUrl + "/WsPrevoyanceGPA/getTarifsPrevoyanceGPA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifsPrevoyanceGPA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifsPrevoyanceGPA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTarifsPrevoyanceGPAResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTarifsPrevoyanceGPAResponse>;
        }));
    }

    protected processGetTarifsPrevoyanceGPA(response: HttpResponseBase): Observable<GetTarifsPrevoyanceGPAResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTarifsPrevoyanceGPAResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTypePDFDocumentProduit(body: GetTypePDFDocumentProduitRequest | undefined): Observable<GetTypePDFDocumentProduitResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getTypePDFDocumentProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypePDFDocumentProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypePDFDocumentProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypePDFDocumentProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypePDFDocumentProduitResponse>;
        }));
    }

    protected processGetTypePDFDocumentProduit(response: HttpResponseBase): Observable<GetTypePDFDocumentProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypePDFDocumentProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProfils(body: GetProfils | undefined): Observable<GetProfilsResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getProfils";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfils(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfils(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilsResponse>;
        }));
    }

    protected processGetProfils(response: HttpResponseBase): Observable<GetProfilsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getTypesDocuments(body: GetTypesDocumentsRequest | undefined): Observable<GetTypesDocumentsResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getTypesDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypesDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypesDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypesDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypesDocumentsResponse>;
        }));
    }

    protected processGetTypesDocuments(response: HttpResponseBase): Observable<GetTypesDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypesDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFondsProduit(body: GetFondsProduitRequest | undefined): Observable<GetFondsProduitResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getFondsProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFondsProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFondsProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFondsProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFondsProduitResponse>;
        }));
    }

    protected processGetFondsProduit(response: HttpResponseBase): Observable<GetFondsProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFondsProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListeDocuments(body: GetListeDocumentsRequest | undefined): Observable<GetListeDocumentsResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getListeDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListeDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListeDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetListeDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetListeDocumentsResponse>;
        }));
    }

    protected processGetListeDocuments(response: HttpResponseBase): Observable<GetListeDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetListeDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDonneesRachat(body: GetDonneesRachatRequest | undefined): Observable<GetDonneesRachatResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDonneesRachat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesRachat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesRachat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesRachatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesRachatResponse>;
        }));
    }

    protected processGetDonneesRachat(response: HttpResponseBase): Observable<GetDonneesRachatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesRachatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDonneesArbitrage(body: GetDonneesArbitrageRequest | undefined): Observable<GetDonneesArbitrageResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDonneesArbitrage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesArbitrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesArbitrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesArbitrageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesArbitrageResponse>;
        }));
    }

    protected processGetDonneesArbitrage(response: HttpResponseBase): Observable<GetDonneesArbitrageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesArbitrageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFichierPDF(body: GetFichierPDFRequest | undefined): Observable<GetFichierPDFResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getFichierPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFichierPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFichierPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFichierPDFResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFichierPDFResponse>;
        }));
    }

    protected processGetFichierPDF(response: HttpResponseBase): Observable<GetFichierPDFResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFichierPDFResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getOrigineDemande(body: GetOrigineDemandeRequest | undefined): Observable<GetOrigineDemandeResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getOrigineDemande";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrigineDemande(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrigineDemande(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrigineDemandeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrigineDemandeResponse>;
        }));
    }

    protected processGetOrigineDemande(response: HttpResponseBase): Observable<GetOrigineDemandeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrigineDemandeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRecommandation(body: GetRecommandationRequest | undefined): Observable<GetRecommandationResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getRecommandation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecommandation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecommandation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecommandationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecommandationResponse>;
        }));
    }

    protected processGetRecommandation(response: HttpResponseBase): Observable<GetRecommandationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecommandationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReglesMetierProduit(body: GetReglesMetierProduitRequest | undefined): Observable<GetReglesMetierProduitResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getReglesMetierProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReglesMetierProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReglesMetierProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReglesMetierProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReglesMetierProduitResponse>;
        }));
    }

    protected processGetReglesMetierProduit(response: HttpResponseBase): Observable<GetReglesMetierProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReglesMetierProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGrilleDesensibilisationCERU(body: GetGrilleDesensibilisationCERURequest | undefined): Observable<GetGrilleDesensibilisationCERUResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getGrilleDesensibilisationCERU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrilleDesensibilisationCERU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrilleDesensibilisationCERU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGrilleDesensibilisationCERUResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGrilleDesensibilisationCERUResponse>;
        }));
    }

    protected processGetGrilleDesensibilisationCERU(response: HttpResponseBase): Observable<GetGrilleDesensibilisationCERUResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGrilleDesensibilisationCERUResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListeReferencesMetier(body: ListeReferencesMetierRequest | undefined): Observable<ListeReferencesMetierResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getListeReferencesMetier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListeReferencesMetier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListeReferencesMetier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeReferencesMetierResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeReferencesMetierResponse>;
        }));
    }

    protected processGetListeReferencesMetier(response: HttpResponseBase): Observable<ListeReferencesMetierResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeReferencesMetierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getCodeCommune(body: GetCodeCommuneRequest | undefined): Observable<GetCodeCommuneResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getCodeCommune";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodeCommune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodeCommune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCodeCommuneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCodeCommuneResponse>;
        }));
    }

    protected processGetCodeCommune(response: HttpResponseBase): Observable<GetCodeCommuneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCodeCommuneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDocumentsPackProduit(body: GetDocumentPackProduitRequest | undefined): Observable<GetDocumentPackProduitResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDocumentsPackProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsPackProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsPackProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentPackProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentPackProduitResponse>;
        }));
    }

    protected processGetDocumentsPackProduit(response: HttpResponseBase): Observable<GetDocumentPackProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentPackProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMentionsLegales(body: GetMentionsLegalesRequest | undefined): Observable<GetMentionsLegalesResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getMentionsLegales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMentionsLegales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMentionsLegales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMentionsLegalesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMentionsLegalesResponse>;
        }));
    }

    protected processGetMentionsLegales(response: HttpResponseBase): Observable<GetMentionsLegalesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMentionsLegalesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDonneesVersement(body: GetDonneesVersementRequest | undefined): Observable<GetDonneesVersementResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDonneesVersement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesVersement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesVersement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesVersementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesVersementResponse>;
        }));
    }

    protected processGetDonneesVersement(response: HttpResponseBase): Observable<GetDonneesVersementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesVersementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getFraisVersement(body: GetFraisVersementRequest | undefined): Observable<GetFraisVersementResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getFraisVersement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFraisVersement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFraisVersement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFraisVersementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFraisVersementResponse>;
        }));
    }

    protected processGetFraisVersement(response: HttpResponseBase): Observable<GetFraisVersementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFraisVersementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMandatGestion(body: MandatGestionRequest | undefined): Observable<MandatGestionResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getMandatGestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMandatGestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMandatGestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatGestionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatGestionResponse>;
        }));
    }

    protected processGetMandatGestion(response: HttpResponseBase): Observable<MandatGestionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatGestionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getProduits(body: GetProduitsRequest | undefined): Observable<GetProduitsResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getProduits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProduitsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProduitsResponse>;
        }));
    }

    protected processGetProduits(response: HttpResponseBase): Observable<GetProduitsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProduitsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDocumentsFichier(body: GetDocumentsFichierRequest | undefined): Observable<GetDocumentsFichierResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDocumentsFichier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFichier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFichier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsFichierResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsFichierResponse>;
        }));
    }

    protected processGetDocumentsFichier(response: HttpResponseBase): Observable<GetDocumentsFichierResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsFichierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDocumentsProduit(body: GetDocumentsProduitRequest | undefined): Observable<GetDocumentsProduitResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDocumentsProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsProduitResponse>;
        }));
    }

    protected processGetDocumentsProduit(response: HttpResponseBase): Observable<GetDocumentsProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDocumentsFonds(body: GetDocumentsFondsRequest | undefined): Observable<GetDocumentsFondsResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDocumentsFonds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFonds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFonds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsFondsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsFondsResponse>;
        }));
    }

    protected processGetDocumentsFonds(response: HttpResponseBase): Observable<GetDocumentsFondsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsFondsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDocumentsProduitSignatureSouscriptionEnLigne(body: DocumentsProduitSignatureSouscriptionEnLigneRequest | undefined): Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getDocumentsProduitSignatureSouscriptionEnLigne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsProduitSignatureSouscriptionEnLigne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsProduitSignatureSouscriptionEnLigne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse>;
        }));
    }

    protected processGetDocumentsProduitSignatureSouscriptionEnLigne(response: HttpResponseBase): Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentsProduitSignatureSouscriptionEnLigneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRUM(body: GetRUMRequest | undefined): Observable<GetRUMResponse> {
        let url_ = this.baseUrl + "/WsReferentielMetier/getRUM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRUM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRUM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRUMResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRUMResponse>;
        }));
    }

    protected processGetRUM(response: HttpResponseBase): Observable<GetRUMResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRUMResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMandat(body: CreateMandatRequest | undefined): Observable<CreateMandatResponse> {
        let url_ = this.baseUrl + "/WsSepalia/createMandat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMandat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMandat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMandatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMandatResponse>;
        }));
    }

    protected processCreateMandat(response: HttpResponseBase): Observable<CreateMandatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMandatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getBICFromIBAN(body: GetBICFromIBANRequest | undefined): Observable<GetBICFromIBANResponse> {
        let url_ = this.baseUrl + "/WsSepalia/getBICFromIBAN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBICFromIBAN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBICFromIBAN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBICFromIBANResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBICFromIBANResponse>;
        }));
    }

    protected processGetBICFromIBAN(response: HttpResponseBase): Observable<GetBICFromIBANResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBICFromIBANResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchMandat(body: SearchMandatRequest | undefined): Observable<SearchMandatResponse> {
        let url_ = this.baseUrl + "/WsSepalia/searchMandat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMandat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMandat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMandatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMandatResponse>;
        }));
    }

    protected processSearchMandat(response: HttpResponseBase): Observable<SearchMandatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchMandatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CSP implements ICSP {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    professions?: Professions[] | undefined;

    constructor(data?: ICSP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(Professions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CSP {
        data = typeof data === 'object' ? data : {};
        let result = new CSP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICSP {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    professions?: Professions[] | undefined;
}

export class AdressePrincipale implements IAdressePrincipale {
    adresseFR?: boolean;
    codeCommune?: string | undefined;
    codePostal?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    nomVille?: string | undefined;
    npai?: boolean;
    npaiCommentaire?: string | undefined;
    paysId?: number;
    paysLibelle?: string | undefined;
    type?: number;
    voie?: string | undefined;
    pays?: Pays;

    constructor(data?: IAdressePrincipale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adresseFR = _data["adresseFR"];
            this.codeCommune = _data["codeCommune"];
            this.codePostal = _data["codePostal"];
            this.codeVoie = _data["codeVoie"];
            this.complement = _data["complement"];
            this.complement2 = _data["complement2"];
            this.lieudit = _data["lieudit"];
            this.nomVille = _data["nomVille"];
            this.npai = _data["npai"];
            this.npaiCommentaire = _data["npaiCommentaire"];
            this.paysId = _data["paysId"];
            this.paysLibelle = _data["paysLibelle"];
            this.type = _data["type"];
            this.voie = _data["voie"];
            this.pays = _data["pays"] ? Pays.fromJS(_data["pays"]) : undefined as any;
        }
    }

    static fromJS(data: any): AdressePrincipale {
        data = typeof data === 'object' ? data : {};
        let result = new AdressePrincipale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresseFR"] = this.adresseFR;
        data["codeCommune"] = this.codeCommune;
        data["codePostal"] = this.codePostal;
        data["codeVoie"] = this.codeVoie;
        data["complement"] = this.complement;
        data["complement2"] = this.complement2;
        data["lieudit"] = this.lieudit;
        data["nomVille"] = this.nomVille;
        data["npai"] = this.npai;
        data["npaiCommentaire"] = this.npaiCommentaire;
        data["paysId"] = this.paysId;
        data["paysLibelle"] = this.paysLibelle;
        data["type"] = this.type;
        data["voie"] = this.voie;
        data["pays"] = this.pays ? this.pays.toJSON() : undefined as any;
        return data;
    }
}

export interface IAdressePrincipale {
    adresseFR?: boolean;
    codeCommune?: string | undefined;
    codePostal?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    nomVille?: string | undefined;
    npai?: boolean;
    npaiCommentaire?: string | undefined;
    paysId?: number;
    paysLibelle?: string | undefined;
    type?: number;
    voie?: string | undefined;
    pays?: Pays;
}

export class Beneficiaires implements IBeneficiaires {
    noSocietaireInterne?: string | undefined;
    mail?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    civilite?: string | undefined;
    dateParrainage?: Date | undefined;

    constructor(data?: IBeneficiaires) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.mail = _data["mail"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.civilite = _data["civilite"];
            this.dateParrainage = _data["dateParrainage"] ? new Date(_data["dateParrainage"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Beneficiaires {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiaires();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["mail"] = this.mail;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["civilite"] = this.civilite;
        data["dateParrainage"] = this.dateParrainage ? this.dateParrainage.toISOString() : undefined as any;
        return data;
    }
}

export interface IBeneficiaires {
    noSocietaireInterne?: string | undefined;
    mail?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    civilite?: string | undefined;
    dateParrainage?: Date | undefined;
}

export class ClientInfos implements IClientInfos {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: string | undefined;
    numeroClientCRM?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    nomNaissance?: string | undefined;
    dateNaissance?: Date;
    email?: string | undefined;
    villeNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    telephoneMobile?: string | undefined;
    statut?: string | undefined;
    sousStatut?: string | undefined;
    personneMorale?: boolean | undefined;

    constructor(data?: IClientInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.numeroClientInterne = _data["numeroClientInterne"];
            this.numeroClientCRM = _data["numeroClientCRM"];
            this.prenom = _data["prenom"];
            this.nom = _data["nom"];
            this.nomNaissance = _data["nomNaissance"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
            this.email = _data["email"];
            this.villeNaissance = _data["villeNaissance"];
            this.departementNaissance = _data["departementNaissance"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.statut = _data["statut"];
            this.sousStatut = _data["sousStatut"];
            this.personneMorale = _data["personneMorale"];
        }
    }

    static fromJS(data: any): ClientInfos {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["numeroClientInterne"] = this.numeroClientInterne;
        data["numeroClientCRM"] = this.numeroClientCRM;
        data["prenom"] = this.prenom;
        data["nom"] = this.nom;
        data["nomNaissance"] = this.nomNaissance;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["email"] = this.email;
        data["villeNaissance"] = this.villeNaissance;
        data["departementNaissance"] = this.departementNaissance;
        data["telephoneMobile"] = this.telephoneMobile;
        data["statut"] = this.statut;
        data["sousStatut"] = this.sousStatut;
        data["personneMorale"] = this.personneMorale;
        return data;
    }
}

export interface IClientInfos {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: string | undefined;
    numeroClientCRM?: string | undefined;
    prenom?: string | undefined;
    nom?: string | undefined;
    nomNaissance?: string | undefined;
    dateNaissance?: Date;
    email?: string | undefined;
    villeNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    telephoneMobile?: string | undefined;
    statut?: string | undefined;
    sousStatut?: string | undefined;
    personneMorale?: boolean | undefined;
}

export class Complement implements IComplement {
    autreContrat?: number;
    compositionPatrimoines?: CompositionPatrimoines;
    exerciceFiscal?: number | undefined;
    matricule?: string | undefined;
    mifInfo?: number;
    motifSouscription?: number;
    nbEnfants16AnsOuPlus?: number | undefined;
    nbEnfantsACharge?: number | undefined;
    nbEnfantsMoins16Ans?: number | undefined;
    notificationOperation?: number;
    numeroClientB?: number;
    regimeMatrimonial?: number;
    revenuFiscal?: number | undefined;
    revenuMensuelNetFoyer?: number;
    secteurActivite?: number;
    sectionMIF?: number;
    situationFamiliale?: number;
    situationFamilialeFiscale?: number;
    situationFinanciere?: number;
    situationPatrimoniale?: number;
    situationProfessionnelle?: number;
    profession?: number | undefined;
    cSP?: number;
    sollicitationCourrier?: boolean | undefined;
    sollicitationEmail?: boolean | undefined;
    sollicitationSMS?: boolean | undefined;
    sollicitationPartenaire?: boolean | undefined;
    source?: number;
    sourceAnnee?: number;
    statutCommercial?: number;
    statutInstitutionnel?: number;
    statutSncf?: string | undefined;
    strCompositionPatrimoine?: string | undefined;
    typeClient?: string | undefined;
    typeMatricule?: string | undefined;
    motifSouscriptionLibelle?: string | undefined;
    regimeMatrimonialLibelle?: string | undefined;
    situationFamilialeLibelle?: string | undefined;
    situationFamilialeFiscaleLibelle?: string | undefined;
    situationFinanciereLibelle?: string | undefined;
    situationPatrimonialeLibelle?: string | undefined;
    situationProfessionnelleLibelle?: string | undefined;
    professionLibelle?: string | undefined;
    cSPLibelle?: string | undefined;
    revenuMensuelNetFoyerLibelle?: string | undefined;
    secteurActiviteLibelle?: string | undefined;
    notificationOperationLibelle?: string | undefined;
    abonnePerformance?: boolean | undefined;
    abonneActualite?: boolean | undefined;
    canalPrefereNotificationOperation?: string | undefined;
    canalPrefereMifInfos?: string | undefined;
    relations?: Relation[] | undefined;

    constructor(data?: IComplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autreContrat = _data["autreContrat"];
            this.compositionPatrimoines = _data["compositionPatrimoines"] ? CompositionPatrimoines.fromJS(_data["compositionPatrimoines"]) : undefined as any;
            this.exerciceFiscal = _data["exerciceFiscal"];
            this.matricule = _data["matricule"];
            this.mifInfo = _data["mifInfo"];
            this.motifSouscription = _data["motifSouscription"];
            this.nbEnfants16AnsOuPlus = _data["nbEnfants16AnsOuPlus"];
            this.nbEnfantsACharge = _data["nbEnfantsACharge"];
            this.nbEnfantsMoins16Ans = _data["nbEnfantsMoins16Ans"];
            this.notificationOperation = _data["notificationOperation"];
            this.numeroClientB = _data["numeroClientB"];
            this.regimeMatrimonial = _data["regimeMatrimonial"];
            this.revenuFiscal = _data["revenuFiscal"];
            this.revenuMensuelNetFoyer = _data["revenuMensuelNetFoyer"];
            this.secteurActivite = _data["secteurActivite"];
            this.sectionMIF = _data["sectionMIF"];
            this.situationFamiliale = _data["situationFamiliale"];
            this.situationFamilialeFiscale = _data["situationFamilialeFiscale"];
            this.situationFinanciere = _data["situationFinanciere"];
            this.situationPatrimoniale = _data["situationPatrimoniale"];
            this.situationProfessionnelle = _data["situationProfessionnelle"];
            this.profession = _data["profession"];
            this.cSP = _data["CSP"];
            this.sollicitationCourrier = _data["sollicitationCourrier"];
            this.sollicitationEmail = _data["sollicitationEmail"];
            this.sollicitationSMS = _data["sollicitationSMS"];
            this.sollicitationPartenaire = _data["sollicitationPartenaire"];
            this.source = _data["source"];
            this.sourceAnnee = _data["sourceAnnee"];
            this.statutCommercial = _data["statutCommercial"];
            this.statutInstitutionnel = _data["statutInstitutionnel"];
            this.statutSncf = _data["statutSncf"];
            this.strCompositionPatrimoine = _data["strCompositionPatrimoine"];
            this.typeClient = _data["typeClient"];
            this.typeMatricule = _data["typeMatricule"];
            this.motifSouscriptionLibelle = _data["motifSouscriptionLibelle"];
            this.regimeMatrimonialLibelle = _data["regimeMatrimonialLibelle"];
            this.situationFamilialeLibelle = _data["situationFamilialeLibelle"];
            this.situationFamilialeFiscaleLibelle = _data["situationFamilialeFiscaleLibelle"];
            this.situationFinanciereLibelle = _data["situationFinanciereLibelle"];
            this.situationPatrimonialeLibelle = _data["situationPatrimonialeLibelle"];
            this.situationProfessionnelleLibelle = _data["situationProfessionnelleLibelle"];
            this.professionLibelle = _data["professionLibelle"];
            this.cSPLibelle = _data["CSPLibelle"];
            this.revenuMensuelNetFoyerLibelle = _data["revenuMensuelNetFoyerLibelle"];
            this.secteurActiviteLibelle = _data["secteurActiviteLibelle"];
            this.notificationOperationLibelle = _data["notificationOperationLibelle"];
            this.abonnePerformance = _data["abonnePerformance"];
            this.abonneActualite = _data["abonneActualite"];
            this.canalPrefereNotificationOperation = _data["canalPrefereNotificationOperation"];
            this.canalPrefereMifInfos = _data["canalPrefereMifInfos"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(Relation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Complement {
        data = typeof data === 'object' ? data : {};
        let result = new Complement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autreContrat"] = this.autreContrat;
        data["compositionPatrimoines"] = this.compositionPatrimoines ? this.compositionPatrimoines.toJSON() : undefined as any;
        data["exerciceFiscal"] = this.exerciceFiscal;
        data["matricule"] = this.matricule;
        data["mifInfo"] = this.mifInfo;
        data["motifSouscription"] = this.motifSouscription;
        data["nbEnfants16AnsOuPlus"] = this.nbEnfants16AnsOuPlus;
        data["nbEnfantsACharge"] = this.nbEnfantsACharge;
        data["nbEnfantsMoins16Ans"] = this.nbEnfantsMoins16Ans;
        data["notificationOperation"] = this.notificationOperation;
        data["numeroClientB"] = this.numeroClientB;
        data["regimeMatrimonial"] = this.regimeMatrimonial;
        data["revenuFiscal"] = this.revenuFiscal;
        data["revenuMensuelNetFoyer"] = this.revenuMensuelNetFoyer;
        data["secteurActivite"] = this.secteurActivite;
        data["sectionMIF"] = this.sectionMIF;
        data["situationFamiliale"] = this.situationFamiliale;
        data["situationFamilialeFiscale"] = this.situationFamilialeFiscale;
        data["situationFinanciere"] = this.situationFinanciere;
        data["situationPatrimoniale"] = this.situationPatrimoniale;
        data["situationProfessionnelle"] = this.situationProfessionnelle;
        data["profession"] = this.profession;
        data["CSP"] = this.cSP;
        data["sollicitationCourrier"] = this.sollicitationCourrier;
        data["sollicitationEmail"] = this.sollicitationEmail;
        data["sollicitationSMS"] = this.sollicitationSMS;
        data["sollicitationPartenaire"] = this.sollicitationPartenaire;
        data["source"] = this.source;
        data["sourceAnnee"] = this.sourceAnnee;
        data["statutCommercial"] = this.statutCommercial;
        data["statutInstitutionnel"] = this.statutInstitutionnel;
        data["statutSncf"] = this.statutSncf;
        data["strCompositionPatrimoine"] = this.strCompositionPatrimoine;
        data["typeClient"] = this.typeClient;
        data["typeMatricule"] = this.typeMatricule;
        data["motifSouscriptionLibelle"] = this.motifSouscriptionLibelle;
        data["regimeMatrimonialLibelle"] = this.regimeMatrimonialLibelle;
        data["situationFamilialeLibelle"] = this.situationFamilialeLibelle;
        data["situationFamilialeFiscaleLibelle"] = this.situationFamilialeFiscaleLibelle;
        data["situationFinanciereLibelle"] = this.situationFinanciereLibelle;
        data["situationPatrimonialeLibelle"] = this.situationPatrimonialeLibelle;
        data["situationProfessionnelleLibelle"] = this.situationProfessionnelleLibelle;
        data["professionLibelle"] = this.professionLibelle;
        data["CSPLibelle"] = this.cSPLibelle;
        data["revenuMensuelNetFoyerLibelle"] = this.revenuMensuelNetFoyerLibelle;
        data["secteurActiviteLibelle"] = this.secteurActiviteLibelle;
        data["notificationOperationLibelle"] = this.notificationOperationLibelle;
        data["abonnePerformance"] = this.abonnePerformance;
        data["abonneActualite"] = this.abonneActualite;
        data["canalPrefereNotificationOperation"] = this.canalPrefereNotificationOperation;
        data["canalPrefereMifInfos"] = this.canalPrefereMifInfos;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComplement {
    autreContrat?: number;
    compositionPatrimoines?: CompositionPatrimoines;
    exerciceFiscal?: number | undefined;
    matricule?: string | undefined;
    mifInfo?: number;
    motifSouscription?: number;
    nbEnfants16AnsOuPlus?: number | undefined;
    nbEnfantsACharge?: number | undefined;
    nbEnfantsMoins16Ans?: number | undefined;
    notificationOperation?: number;
    numeroClientB?: number;
    regimeMatrimonial?: number;
    revenuFiscal?: number | undefined;
    revenuMensuelNetFoyer?: number;
    secteurActivite?: number;
    sectionMIF?: number;
    situationFamiliale?: number;
    situationFamilialeFiscale?: number;
    situationFinanciere?: number;
    situationPatrimoniale?: number;
    situationProfessionnelle?: number;
    profession?: number | undefined;
    cSP?: number;
    sollicitationCourrier?: boolean | undefined;
    sollicitationEmail?: boolean | undefined;
    sollicitationSMS?: boolean | undefined;
    sollicitationPartenaire?: boolean | undefined;
    source?: number;
    sourceAnnee?: number;
    statutCommercial?: number;
    statutInstitutionnel?: number;
    statutSncf?: string | undefined;
    strCompositionPatrimoine?: string | undefined;
    typeClient?: string | undefined;
    typeMatricule?: string | undefined;
    motifSouscriptionLibelle?: string | undefined;
    regimeMatrimonialLibelle?: string | undefined;
    situationFamilialeLibelle?: string | undefined;
    situationFamilialeFiscaleLibelle?: string | undefined;
    situationFinanciereLibelle?: string | undefined;
    situationPatrimonialeLibelle?: string | undefined;
    situationProfessionnelleLibelle?: string | undefined;
    professionLibelle?: string | undefined;
    cSPLibelle?: string | undefined;
    revenuMensuelNetFoyerLibelle?: string | undefined;
    secteurActiviteLibelle?: string | undefined;
    notificationOperationLibelle?: string | undefined;
    abonnePerformance?: boolean | undefined;
    abonneActualite?: boolean | undefined;
    canalPrefereNotificationOperation?: string | undefined;
    canalPrefereMifInfos?: string | undefined;
    relations?: Relation[] | undefined;
}

export class CompositionPatrimoines implements ICompositionPatrimoines {
    id?: number | undefined;
    libelleCourt?: string | undefined;

    constructor(data?: ICompositionPatrimoines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
        }
    }

    static fromJS(data: any): CompositionPatrimoines {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionPatrimoines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        return data;
    }
}

export interface ICompositionPatrimoines {
    id?: number | undefined;
    libelleCourt?: string | undefined;
}

export class Erreur implements IErreur {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetAllPaysRequest implements IGetAllPaysRequest {

    constructor(data?: IGetAllPaysRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllPaysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllPaysRequest {
}

export class GetAllPaysResponse implements IGetAllPaysResponse {
    return?: Pays[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetAllPaysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["return"])) {
                this.return = [] as any;
                for (let item of _data["return"])
                    this.return!.push(Pays.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPaysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.return)) {
            data["return"] = [];
            for (let item of this.return)
                data["return"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllPaysResponse {
    return?: Pays[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetAllReferenceRequest implements IGetAllReferenceRequest {

    constructor(data?: IGetAllReferenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllReferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllReferenceRequest {
}

export class GetAllReferenceResponse implements IGetAllReferenceResponse {
    informations?: Informations[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetAllReferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["informations"])) {
                this.informations = [] as any;
                for (let item of _data["informations"])
                    this.informations!.push(Informations.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllReferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.informations)) {
            data["informations"] = [];
            for (let item of this.informations)
                data["informations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllReferenceResponse {
    informations?: Informations[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetClientByIdCrmRequest implements IGetClientByIdCrmRequest {
    numeroClientCRM?: string | undefined;

    constructor(data?: IGetClientByIdCrmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientCRM = _data["numeroClientCRM"];
        }
    }

    static fromJS(data: any): GetClientByIdCrmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByIdCrmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientCRM"] = this.numeroClientCRM;
        return data;
    }
}

export interface IGetClientByIdCrmRequest {
    numeroClientCRM?: string | undefined;
}

export class GetClientByIdCrmResponse implements IGetClientByIdCrmResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetClientByIdCrmResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.return = _data["return"] ? GetIdentite.fromJS(_data["return"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByIdCrmResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByIdCrmResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["return"] = this.return ? this.return.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetClientByIdCrmResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
}

export class GetClientByNumeroClientARequest implements IGetClientByNumeroClientARequest {
    numeroClientA?: string | undefined;

    constructor(data?: IGetClientByNumeroClientARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientA = _data["numeroClientA"];
        }
    }

    static fromJS(data: any): GetClientByNumeroClientARequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroClientARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientA"] = this.numeroClientA;
        return data;
    }
}

export interface IGetClientByNumeroClientARequest {
    numeroClientA?: string | undefined;
}

export class GetClientByNumeroClientAResponse implements IGetClientByNumeroClientAResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
    warnings?: Warning[] | undefined;

    constructor(data?: IGetClientByNumeroClientAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.return = _data["return"] ? GetIdentite.fromJS(_data["return"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByNumeroClientAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroClientAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["return"] = this.return ? this.return.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetClientByNumeroClientAResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
    warnings?: Warning[] | undefined;
}

export class GetFilleulsRequest implements IGetFilleulsRequest {
    noSocietaireInterne?: string | undefined;

    constructor(data?: IGetFilleulsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
        }
    }

    static fromJS(data: any): GetFilleulsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilleulsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        return data;
    }
}

export interface IGetFilleulsRequest {
    noSocietaireInterne?: string | undefined;
}

export class GetFilleulsResponse implements IGetFilleulsResponse {
    beneficiaires?: Beneficiaires[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetFilleulsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["beneficiaires"])) {
                this.beneficiaires = [] as any;
                for (let item of _data["beneficiaires"])
                    this.beneficiaires!.push(Beneficiaires.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilleulsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilleulsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.beneficiaires)) {
            data["beneficiaires"] = [];
            for (let item of this.beneficiaires)
                data["beneficiaires"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFilleulsResponse {
    beneficiaires?: Beneficiaires[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetIdentite implements IGetIdentite {
    id?: string | undefined;
    consultationDate?: Date;
    consultationUtilisateurId?: string | undefined;
    creationDate?: Date;
    creationUtilisateurId?: string | undefined;
    desactivationDate?: Date;
    desactivationUtilisateurId?: string | undefined;
    desactive?: boolean;
    majDate?: Date;
    majUtilisateurId?: string | undefined;
    anneeNaissance?: number;
    autresPrenoms?: string | undefined;
    codeCommuneNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    commentaire?: string | undefined;
    contribuableAmericain?: boolean;
    dateDeces?: Date;
    dateNaissance?: Date;
    departementNaissance?: string | undefined;
    email?: string | undefined;
    fonctionPPE?: number;
    fonctionPPELibelle?: string | undefined;
    motifPPE?: number;
    motifPPELibelle?: string | undefined;
    inseeVilleNaissance?: string | undefined;
    isEmailValide?: boolean;
    jourNaissance?: number;
    mesureProtectionJuridique?: number;
    mesureProtectionJuridiqueLibelle?: string | undefined;
    moisNaissance?: number;
    nationalite?: number;
    nationaliteLibelle?: string | undefined;
    nom?: string | undefined;
    nomJeuneFille?: string | undefined;
    numero?: string | undefined;
    numeroClientA?: string | undefined;
    numeroClientB?: string | undefined;
    nIR?: string | undefined;
    paysNaissance?: string | undefined;
    paysResidenceFiscaleId?: number;
    paysResidenceFiscaleLibelle?: string | undefined;
    personneMorale?: boolean;
    politiquementExposee?: boolean;
    prenom?: string | undefined;
    sexe?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    titre?: string | undefined;
    type?: string | undefined;
    villeNaissance?: string | undefined;
    associationClientId?: number;
    associationPrincipale?: boolean;
    lastConsultationDateByClient?: Date;
    typeClient?: string | undefined;
    adressePrincipale?: AdressePrincipale;
    complement?: Complement;

    constructor(data?: IGetIdentite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : undefined as any;
            this.consultationUtilisateurId = _data["consultationUtilisateurId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined as any;
            this.creationUtilisateurId = _data["creationUtilisateurId"];
            this.desactivationDate = _data["desactivationDate"] ? new Date(_data["desactivationDate"].toString()) : undefined as any;
            this.desactivationUtilisateurId = _data["desactivationUtilisateurId"];
            this.desactive = _data["desactive"];
            this.majDate = _data["majDate"] ? new Date(_data["majDate"].toString()) : undefined as any;
            this.majUtilisateurId = _data["majUtilisateurId"];
            this.anneeNaissance = _data["anneeNaissance"];
            this.autresPrenoms = _data["autresPrenoms"];
            this.codeCommuneNaissance = _data["codeCommuneNaissance"];
            this.codePostalNaissance = _data["codePostalNaissance"];
            this.commentaire = _data["commentaire"];
            this.contribuableAmericain = _data["contribuableAmericain"];
            this.dateDeces = _data["dateDeces"] ? new Date(_data["dateDeces"].toString()) : undefined as any;
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
            this.departementNaissance = _data["departementNaissance"];
            this.email = _data["email"];
            this.fonctionPPE = _data["fonctionPPE"];
            this.fonctionPPELibelle = _data["fonctionPPELibelle"];
            this.motifPPE = _data["motifPPE"];
            this.motifPPELibelle = _data["motifPPELibelle"];
            this.inseeVilleNaissance = _data["inseeVilleNaissance"];
            this.isEmailValide = _data["isEmailValide"];
            this.jourNaissance = _data["jourNaissance"];
            this.mesureProtectionJuridique = _data["mesureProtectionJuridique"];
            this.mesureProtectionJuridiqueLibelle = _data["mesureProtectionJuridiqueLibelle"];
            this.moisNaissance = _data["moisNaissance"];
            this.nationalite = _data["nationalite"];
            this.nationaliteLibelle = _data["nationaliteLibelle"];
            this.nom = _data["nom"];
            this.nomJeuneFille = _data["nomJeuneFille"];
            this.numero = _data["numero"];
            this.numeroClientA = _data["numeroClientA"];
            this.numeroClientB = _data["numeroClientB"];
            this.nIR = _data["NIR"];
            this.paysNaissance = _data["paysNaissance"];
            this.paysResidenceFiscaleId = _data["paysResidenceFiscaleId"];
            this.paysResidenceFiscaleLibelle = _data["paysResidenceFiscaleLibelle"];
            this.personneMorale = _data["personneMorale"];
            this.politiquementExposee = _data["politiquementExposee"];
            this.prenom = _data["prenom"];
            this.sexe = _data["sexe"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneProfessionnel = _data["telephoneProfessionnel"];
            this.titre = _data["titre"];
            this.type = _data["type"];
            this.villeNaissance = _data["villeNaissance"];
            this.associationClientId = _data["associationClientId"];
            this.associationPrincipale = _data["associationPrincipale"];
            this.lastConsultationDateByClient = _data["lastConsultationDateByClient"] ? new Date(_data["lastConsultationDateByClient"].toString()) : undefined as any;
            this.typeClient = _data["typeClient"];
            this.adressePrincipale = _data["adressePrincipale"] ? AdressePrincipale.fromJS(_data["adressePrincipale"]) : undefined as any;
            this.complement = _data["complement"] ? Complement.fromJS(_data["complement"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetIdentite {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdentite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : undefined as any;
        data["consultationUtilisateurId"] = this.consultationUtilisateurId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["creationUtilisateurId"] = this.creationUtilisateurId;
        data["desactivationDate"] = this.desactivationDate ? this.desactivationDate.toISOString() : undefined as any;
        data["desactivationUtilisateurId"] = this.desactivationUtilisateurId;
        data["desactive"] = this.desactive;
        data["majDate"] = this.majDate ? this.majDate.toISOString() : undefined as any;
        data["majUtilisateurId"] = this.majUtilisateurId;
        data["anneeNaissance"] = this.anneeNaissance;
        data["autresPrenoms"] = this.autresPrenoms;
        data["codeCommuneNaissance"] = this.codeCommuneNaissance;
        data["codePostalNaissance"] = this.codePostalNaissance;
        data["commentaire"] = this.commentaire;
        data["contribuableAmericain"] = this.contribuableAmericain;
        data["dateDeces"] = this.dateDeces ? this.dateDeces.toISOString() : undefined as any;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["departementNaissance"] = this.departementNaissance;
        data["email"] = this.email;
        data["fonctionPPE"] = this.fonctionPPE;
        data["fonctionPPELibelle"] = this.fonctionPPELibelle;
        data["motifPPE"] = this.motifPPE;
        data["motifPPELibelle"] = this.motifPPELibelle;
        data["inseeVilleNaissance"] = this.inseeVilleNaissance;
        data["isEmailValide"] = this.isEmailValide;
        data["jourNaissance"] = this.jourNaissance;
        data["mesureProtectionJuridique"] = this.mesureProtectionJuridique;
        data["mesureProtectionJuridiqueLibelle"] = this.mesureProtectionJuridiqueLibelle;
        data["moisNaissance"] = this.moisNaissance;
        data["nationalite"] = this.nationalite;
        data["nationaliteLibelle"] = this.nationaliteLibelle;
        data["nom"] = this.nom;
        data["nomJeuneFille"] = this.nomJeuneFille;
        data["numero"] = this.numero;
        data["numeroClientA"] = this.numeroClientA;
        data["numeroClientB"] = this.numeroClientB;
        data["NIR"] = this.nIR;
        data["paysNaissance"] = this.paysNaissance;
        data["paysResidenceFiscaleId"] = this.paysResidenceFiscaleId;
        data["paysResidenceFiscaleLibelle"] = this.paysResidenceFiscaleLibelle;
        data["personneMorale"] = this.personneMorale;
        data["politiquementExposee"] = this.politiquementExposee;
        data["prenom"] = this.prenom;
        data["sexe"] = this.sexe;
        data["telephoneFixe"] = this.telephoneFixe;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneProfessionnel"] = this.telephoneProfessionnel;
        data["titre"] = this.titre;
        data["type"] = this.type;
        data["villeNaissance"] = this.villeNaissance;
        data["associationClientId"] = this.associationClientId;
        data["associationPrincipale"] = this.associationPrincipale;
        data["lastConsultationDateByClient"] = this.lastConsultationDateByClient ? this.lastConsultationDateByClient.toISOString() : undefined as any;
        data["typeClient"] = this.typeClient;
        data["adressePrincipale"] = this.adressePrincipale ? this.adressePrincipale.toJSON() : undefined as any;
        data["complement"] = this.complement ? this.complement.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetIdentite {
    id?: string | undefined;
    consultationDate?: Date;
    consultationUtilisateurId?: string | undefined;
    creationDate?: Date;
    creationUtilisateurId?: string | undefined;
    desactivationDate?: Date;
    desactivationUtilisateurId?: string | undefined;
    desactive?: boolean;
    majDate?: Date;
    majUtilisateurId?: string | undefined;
    anneeNaissance?: number;
    autresPrenoms?: string | undefined;
    codeCommuneNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    commentaire?: string | undefined;
    contribuableAmericain?: boolean;
    dateDeces?: Date;
    dateNaissance?: Date;
    departementNaissance?: string | undefined;
    email?: string | undefined;
    fonctionPPE?: number;
    fonctionPPELibelle?: string | undefined;
    motifPPE?: number;
    motifPPELibelle?: string | undefined;
    inseeVilleNaissance?: string | undefined;
    isEmailValide?: boolean;
    jourNaissance?: number;
    mesureProtectionJuridique?: number;
    mesureProtectionJuridiqueLibelle?: string | undefined;
    moisNaissance?: number;
    nationalite?: number;
    nationaliteLibelle?: string | undefined;
    nom?: string | undefined;
    nomJeuneFille?: string | undefined;
    numero?: string | undefined;
    numeroClientA?: string | undefined;
    numeroClientB?: string | undefined;
    nIR?: string | undefined;
    paysNaissance?: string | undefined;
    paysResidenceFiscaleId?: number;
    paysResidenceFiscaleLibelle?: string | undefined;
    personneMorale?: boolean;
    politiquementExposee?: boolean;
    prenom?: string | undefined;
    sexe?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    titre?: string | undefined;
    type?: string | undefined;
    villeNaissance?: string | undefined;
    associationClientId?: number;
    associationPrincipale?: boolean;
    lastConsultationDateByClient?: Date;
    typeClient?: string | undefined;
    adressePrincipale?: AdressePrincipale;
    complement?: Complement;
}

export class GetMotifsCSPRequest implements IGetMotifsCSPRequest {

    constructor(data?: IGetMotifsCSPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMotifsCSPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsCSPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMotifsCSPRequest {
}

export class GetMotifsCSPResponse implements IGetMotifsCSPResponse {
    cSP?: CSP[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetMotifsCSPResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CSP"])) {
                this.cSP = [] as any;
                for (let item of _data["CSP"])
                    this.cSP!.push(CSP.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMotifsCSPResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsCSPResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cSP)) {
            data["CSP"] = [];
            for (let item of this.cSP)
                data["CSP"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMotifsCSPResponse {
    cSP?: CSP[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetMotifsPPERequest implements IGetMotifsPPERequest {

    constructor(data?: IGetMotifsPPERequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMotifsPPERequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsPPERequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMotifsPPERequest {
}

export class GetMotifsPPEResponse implements IGetMotifsPPEResponse {
    motifs?: Motifs[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetMotifsPPEResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["motifs"])) {
                this.motifs = [] as any;
                for (let item of _data["motifs"])
                    this.motifs!.push(Motifs.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMotifsPPEResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsPPEResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.motifs)) {
            data["motifs"] = [];
            for (let item of this.motifs)
                data["motifs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMotifsPPEResponse {
    motifs?: Motifs[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class Informations implements IInformations {
    id?: number;
    actif?: boolean;
    code?: string | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.code = _data["code"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Informations {
        data = typeof data === 'object' ? data : {};
        let result = new Informations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["code"] = this.code;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IInformations {
    id?: number;
    actif?: boolean;
    code?: string | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class Motifs implements IMotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    sousmotifs?: Sousmotifs[] | undefined;

    constructor(data?: IMotifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["sousmotifs"])) {
                this.sousmotifs = [] as any;
                for (let item of _data["sousmotifs"])
                    this.sousmotifs!.push(Sousmotifs.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Motifs {
        data = typeof data === 'object' ? data : {};
        let result = new Motifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.sousmotifs)) {
            data["sousmotifs"] = [];
            for (let item of this.sousmotifs)
                data["sousmotifs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    sousmotifs?: Sousmotifs[] | undefined;
}

export class Pays implements IPays {
    id?: number;
    langFR?: string | undefined;
    alpha2?: string | undefined;
    alpha3?: string | undefined;

    constructor(data?: IPays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.langFR = _data["langFR"];
            this.alpha2 = _data["alpha2"];
            this.alpha3 = _data["alpha3"];
        }
    }

    static fromJS(data: any): Pays {
        data = typeof data === 'object' ? data : {};
        let result = new Pays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["langFR"] = this.langFR;
        data["alpha2"] = this.alpha2;
        data["alpha3"] = this.alpha3;
        return data;
    }
}

export interface IPays {
    id?: number;
    langFR?: string | undefined;
    alpha2?: string | undefined;
    alpha3?: string | undefined;
}

export class Professions implements IProfessions {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IProfessions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Professions {
        data = typeof data === 'object' ? data : {};
        let result = new Professions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IProfessions {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class ProspectToClientRequest implements IProspectToClientRequest {
    idPersonne?: string | undefined;

    constructor(data?: IProspectToClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPersonne = _data["idPersonne"];
        }
    }

    static fromJS(data: any): ProspectToClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectToClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPersonne"] = this.idPersonne;
        return data;
    }
}

export interface IProspectToClientRequest {
    idPersonne?: string | undefined;
}

export class ProspetToClientResponse implements IProspetToClientResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: number;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IProspetToClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.numeroClientInterne = _data["numeroClientInterne"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProspetToClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProspetToClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["numeroClientInterne"] = this.numeroClientInterne;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProspetToClientResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: number;
    erreurs?: Erreur[] | undefined;
}

export class Relation implements IRelation {
    numeroSocietaireInterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    idTypeRelation?: number;
    libelleTypeRelation?: string | undefined;

    constructor(data?: IRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.idTypeRelation = _data["idTypeRelation"];
            this.libelleTypeRelation = _data["libelleTypeRelation"];
        }
    }

    static fromJS(data: any): Relation {
        data = typeof data === 'object' ? data : {};
        let result = new Relation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["idTypeRelation"] = this.idTypeRelation;
        data["libelleTypeRelation"] = this.libelleTypeRelation;
        return data;
    }
}

export interface IRelation {
    numeroSocietaireInterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    idTypeRelation?: number;
    libelleTypeRelation?: string | undefined;
}

export class SearchClientRequest implements ISearchClientRequest {
    numeroClientExterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date;
    villeNaissance?: string | undefined;
    departementNaissance?: string | undefined;

    constructor(data?: ISearchClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
            this.villeNaissance = _data["villeNaissance"];
            this.departementNaissance = _data["departementNaissance"];
        }
    }

    static fromJS(data: any): SearchClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["villeNaissance"] = this.villeNaissance;
        data["departementNaissance"] = this.departementNaissance;
        return data;
    }
}

export interface ISearchClientRequest {
    numeroClientExterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date;
    villeNaissance?: string | undefined;
    departementNaissance?: string | undefined;
}

export class SearchClientResponse implements ISearchClientResponse {
    clients?: ClientInfos[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: ISearchClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientInfos.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchClientResponse {
    clients?: ClientInfos[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class Sousmotifs implements ISousmotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISousmotifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Sousmotifs {
        data = typeof data === 'object' ? data : {};
        let result = new Sousmotifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ISousmotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class Warning implements IWarning {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning {
        data = typeof data === 'object' ? data : {};
        let result = new Warning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class CreateResultatQuestionnaireRequest implements ICreateResultatQuestionnaireRequest {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
    reponsesDonnees?: ReponseDonnee[] | undefined;

    constructor(data?: ICreateResultatQuestionnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCRM = _data["numeroCRM"];
            this.dateQuestionnaire = _data["dateQuestionnaire"] ? new Date(_data["dateQuestionnaire"].toString()) : undefined as any;
            this.lieuQuestionnaire = _data["lieuQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.score = _data["score"];
            this.profil = _data["profil"];
            this.descriptionProfil = _data["descriptionProfil"];
            this.codeContratCible = _data["codeContratCible"];
            this.libelleContratCible = _data["libelleContratCible"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.codeContratRecommande = _data["codeContratRecommande"];
            this.libelleContratRecommande = _data["libelleContratRecommande"];
            this.recommandation = _data["recommandation"];
            this.identifiantChoix = _data["identifiantChoix"];
            this.choixPersonne = _data["choixPersonne"];
            if (Array.isArray(_data["reponsesDonnees"])) {
                this.reponsesDonnees = [] as any;
                for (let item of _data["reponsesDonnees"])
                    this.reponsesDonnees!.push(ReponseDonnee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateResultatQuestionnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultatQuestionnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCRM"] = this.numeroCRM;
        data["dateQuestionnaire"] = this.dateQuestionnaire ? this.dateQuestionnaire.toISOString() : undefined as any;
        data["lieuQuestionnaire"] = this.lieuQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["score"] = this.score;
        data["profil"] = this.profil;
        data["descriptionProfil"] = this.descriptionProfil;
        data["codeContratCible"] = this.codeContratCible;
        data["libelleContratCible"] = this.libelleContratCible;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["echeancePrecise"] = this.echeancePrecise;
        data["codeContratRecommande"] = this.codeContratRecommande;
        data["libelleContratRecommande"] = this.libelleContratRecommande;
        data["recommandation"] = this.recommandation;
        data["identifiantChoix"] = this.identifiantChoix;
        data["choixPersonne"] = this.choixPersonne;
        if (Array.isArray(this.reponsesDonnees)) {
            data["reponsesDonnees"] = [];
            for (let item of this.reponsesDonnees)
                data["reponsesDonnees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateResultatQuestionnaireRequest {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
    reponsesDonnees?: ReponseDonnee[] | undefined;
}

export class CreateResultatQuestionnaireResponse implements ICreateResultatQuestionnaireResponse {
    messageRetour?: string | undefined;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;

    constructor(data?: ICreateResultatQuestionnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageRetour = _data["messageRetour"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateResultatQuestionnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultatQuestionnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageRetour"] = this.messageRetour;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateResultatQuestionnaireResponse {
    messageRetour?: string | undefined;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;
}

export class Erreur2 implements IErreur2 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur2 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur2 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetInfosProfilEpargnantRequest implements IGetInfosProfilEpargnantRequest {
    numeroExterne?: string | undefined;

    constructor(data?: IGetInfosProfilEpargnantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroExterne = _data["numeroExterne"];
        }
    }

    static fromJS(data: any): GetInfosProfilEpargnantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfosProfilEpargnantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroExterne"] = this.numeroExterne;
        return data;
    }
}

export interface IGetInfosProfilEpargnantRequest {
    numeroExterne?: string | undefined;
}

export class GetInfosProfilEpargnantResponse implements IGetInfosProfilEpargnantResponse {
    infosProfilEpargnant?: InfosProfilEpargnant;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;

    constructor(data?: IGetInfosProfilEpargnantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infosProfilEpargnant = _data["infosProfilEpargnant"] ? InfosProfilEpargnant.fromJS(_data["infosProfilEpargnant"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInfosProfilEpargnantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfosProfilEpargnantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infosProfilEpargnant"] = this.infosProfilEpargnant ? this.infosProfilEpargnant.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInfosProfilEpargnantResponse {
    infosProfilEpargnant?: InfosProfilEpargnant;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;
}

export class GetQuestionnaireRequest implements IGetQuestionnaireRequest {
    identifiantDemarche?: number | undefined;

    constructor(data?: IGetQuestionnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiantDemarche = _data["identifiantDemarche"];
        }
    }

    static fromJS(data: any): GetQuestionnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiantDemarche"] = this.identifiantDemarche;
        return data;
    }
}

export interface IGetQuestionnaireRequest {
    identifiantDemarche?: number | undefined;
}

export class GetQuestionnaireResponse implements IGetQuestionnaireResponse {
    questionnaire?: Questionnaire;
    erreurs?: Erreur2[] | undefined;

    constructor(data?: IGetQuestionnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetQuestionnaireResponse {
    questionnaire?: Questionnaire;
    erreurs?: Erreur2[] | undefined;
}

export class InfosProfilEpargnant implements IInfosProfilEpargnant {
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;

    constructor(data?: IInfosProfilEpargnant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateQuestionnaire = _data["dateQuestionnaire"] ? new Date(_data["dateQuestionnaire"].toString()) : undefined as any;
            this.lieuQuestionnaire = _data["lieuQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.score = _data["score"];
            this.profil = _data["profil"];
            this.descriptionProfil = _data["descriptionProfil"];
            this.codeContratCible = _data["codeContratCible"];
            this.libelleContratCible = _data["libelleContratCible"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.codeContratRecommande = _data["codeContratRecommande"];
            this.libelleContratRecommande = _data["libelleContratRecommande"];
            this.recommandation = _data["recommandation"];
            this.identifiantChoix = _data["identifiantChoix"];
            this.choixPersonne = _data["choixPersonne"];
        }
    }

    static fromJS(data: any): InfosProfilEpargnant {
        data = typeof data === 'object' ? data : {};
        let result = new InfosProfilEpargnant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateQuestionnaire"] = this.dateQuestionnaire ? this.dateQuestionnaire.toISOString() : undefined as any;
        data["lieuQuestionnaire"] = this.lieuQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["score"] = this.score;
        data["profil"] = this.profil;
        data["descriptionProfil"] = this.descriptionProfil;
        data["codeContratCible"] = this.codeContratCible;
        data["libelleContratCible"] = this.libelleContratCible;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["echeancePrecise"] = this.echeancePrecise;
        data["codeContratRecommande"] = this.codeContratRecommande;
        data["libelleContratRecommande"] = this.libelleContratRecommande;
        data["recommandation"] = this.recommandation;
        data["identifiantChoix"] = this.identifiantChoix;
        data["choixPersonne"] = this.choixPersonne;
        return data;
    }
}

export interface IInfosProfilEpargnant {
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
}

export class Question implements IQuestion {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    reponsesMultiples?: boolean | undefined;
    ordre?: number | undefined;
    reponses?: Reponse[] | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.reponsesMultiples = _data["reponsesMultiples"];
            this.ordre = _data["ordre"];
            if (Array.isArray(_data["reponses"])) {
                this.reponses = [] as any;
                for (let item of _data["reponses"])
                    this.reponses!.push(Reponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["reponsesMultiples"] = this.reponsesMultiples;
        data["ordre"] = this.ordre;
        if (Array.isArray(this.reponses)) {
            data["reponses"] = [];
            for (let item of this.reponses)
                data["reponses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestion {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    reponsesMultiples?: boolean | undefined;
    ordre?: number | undefined;
    reponses?: Reponse[] | undefined;
}

export class Questionnaire implements IQuestionnaire {
    etat?: string | undefined;
    version?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLongDescription?: string | undefined;
    dateCreation?: Date | undefined;
    dateModification?: Date | undefined;
    identifiantQuestionnaire?: number | undefined;
    identifiantDemarche?: number | undefined;
    dateDebutIndicative?: Date | undefined;
    dateFinIndicative?: Date | undefined;
    themes?: Theme[] | undefined;

    constructor(data?: IQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.etat = _data["etat"];
            this.version = _data["version"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLongDescription = _data["libelleLongDescription"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : undefined as any;
            this.dateModification = _data["dateModification"] ? new Date(_data["dateModification"].toString()) : undefined as any;
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.dateDebutIndicative = _data["dateDebutIndicative"] ? new Date(_data["dateDebutIndicative"].toString()) : undefined as any;
            this.dateFinIndicative = _data["dateFinIndicative"] ? new Date(_data["dateFinIndicative"].toString()) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(Theme.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Questionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etat"] = this.etat;
        data["version"] = this.version;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLongDescription"] = this.libelleLongDescription;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["dateModification"] = this.dateModification ? this.dateModification.toISOString() : undefined as any;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["dateDebutIndicative"] = this.dateDebutIndicative ? this.dateDebutIndicative.toISOString() : undefined as any;
        data["dateFinIndicative"] = this.dateFinIndicative ? this.dateFinIndicative.toISOString() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionnaire {
    etat?: string | undefined;
    version?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLongDescription?: string | undefined;
    dateCreation?: Date | undefined;
    dateModification?: Date | undefined;
    identifiantQuestionnaire?: number | undefined;
    identifiantDemarche?: number | undefined;
    dateDebutIndicative?: Date | undefined;
    dateFinIndicative?: Date | undefined;
    themes?: Theme[] | undefined;
}

export class Reponse implements IReponse {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    points?: number | undefined;
    ordre?: number | undefined;

    constructor(data?: IReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.points = _data["points"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Reponse {
        data = typeof data === 'object' ? data : {};
        let result = new Reponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["points"] = this.points;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IReponse {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    points?: number | undefined;
    ordre?: number | undefined;
}

export class ReponseDonnee implements IReponseDonnee {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;

    constructor(data?: IReponseDonnee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiantQuestion = _data["identifiantQuestion"];
            this.identifiantReponse = _data["identifiantReponse"];
        }
    }

    static fromJS(data: any): ReponseDonnee {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseDonnee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiantQuestion"] = this.identifiantQuestion;
        data["identifiantReponse"] = this.identifiantReponse;
        return data;
    }
}

export interface IReponseDonnee {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;
}

export class Theme implements ITheme {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    ordre?: number | undefined;
    questions?: Question[] | undefined;

    constructor(data?: ITheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.ordre = _data["ordre"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Theme {
        data = typeof data === 'object' ? data : {};
        let result = new Theme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["ordre"] = this.ordre;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITheme {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    ordre?: number | undefined;
    questions?: Question[] | undefined;
}

export class Warning2 implements IWarning2 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning2 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning2 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class CoordonneesCompteBancairePrelevement implements ICoordonneesCompteBancairePrelevement {
    iBAN?: string | undefined;
    bIC?: string | undefined;
    nomBanque?: string | undefined;
    numeroContrat?: (number | undefined)[] | undefined;
    dateCreation?: Date | undefined;
    rUM?: string | undefined;

    constructor(data?: ICoordonneesCompteBancairePrelevement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iBAN = _data["IBAN"];
            this.bIC = _data["BIC"];
            this.nomBanque = _data["nomBanque"];
            if (Array.isArray(_data["numeroContrat"])) {
                this.numeroContrat = [] as any;
                for (let item of _data["numeroContrat"])
                    this.numeroContrat!.push(item);
            }
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : undefined as any;
            this.rUM = _data["RUM"];
        }
    }

    static fromJS(data: any): CoordonneesCompteBancairePrelevement {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesCompteBancairePrelevement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.iBAN;
        data["BIC"] = this.bIC;
        data["nomBanque"] = this.nomBanque;
        if (Array.isArray(this.numeroContrat)) {
            data["numeroContrat"] = [];
            for (let item of this.numeroContrat)
                data["numeroContrat"].push(item);
        }
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["RUM"] = this.rUM;
        return data;
    }
}

export interface ICoordonneesCompteBancairePrelevement {
    iBAN?: string | undefined;
    bIC?: string | undefined;
    nomBanque?: string | undefined;
    numeroContrat?: (number | undefined)[] | undefined;
    dateCreation?: Date | undefined;
    rUM?: string | undefined;
}

export class CoordonneesCompteBancaireReglement implements ICoordonneesCompteBancaireReglement {
    iBAN?: string | undefined;
    bIC?: string | undefined;
    nomBanque?: string | undefined;
    dateCreation?: Date | undefined;
    typeCompte?: string | undefined;

    constructor(data?: ICoordonneesCompteBancaireReglement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iBAN = _data["IBAN"];
            this.bIC = _data["BIC"];
            this.nomBanque = _data["nomBanque"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : undefined as any;
            this.typeCompte = _data["typeCompte"];
        }
    }

    static fromJS(data: any): CoordonneesCompteBancaireReglement {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesCompteBancaireReglement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.iBAN;
        data["BIC"] = this.bIC;
        data["nomBanque"] = this.nomBanque;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["typeCompte"] = this.typeCompte;
        return data;
    }
}

export interface ICoordonneesCompteBancaireReglement {
    iBAN?: string | undefined;
    bIC?: string | undefined;
    nomBanque?: string | undefined;
    dateCreation?: Date | undefined;
    typeCompte?: string | undefined;
}

export class Erreur3 implements IErreur3 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur3 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur3 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetCoordonneesComptesBancairesPrelevementRequest implements IGetCoordonneesComptesBancairesPrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesPrelevementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesPrelevementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesPrelevementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesPrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class GetCoordonneesComptesBancairesPrelevementResponse implements IGetCoordonneesComptesBancairesPrelevementResponse {
    coordonneesCompteBancairePrelevement?: CoordonneesCompteBancairePrelevement[] | undefined;
    erreurs?: Erreur3[] | undefined;
    warnings?: Warning3[] | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesPrelevementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesCompteBancairePrelevement"])) {
                this.coordonneesCompteBancairePrelevement = [] as any;
                for (let item of _data["coordonneesCompteBancairePrelevement"])
                    this.coordonneesCompteBancairePrelevement!.push(CoordonneesCompteBancairePrelevement.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur3.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesPrelevementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesPrelevementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesCompteBancairePrelevement)) {
            data["coordonneesCompteBancairePrelevement"] = [];
            for (let item of this.coordonneesCompteBancairePrelevement)
                data["coordonneesCompteBancairePrelevement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesPrelevementResponse {
    coordonneesCompteBancairePrelevement?: CoordonneesCompteBancairePrelevement[] | undefined;
    erreurs?: Erreur3[] | undefined;
    warnings?: Warning3[] | undefined;
}

export class GetCoordonneesComptesBancairesReglementRequest implements IGetCoordonneesComptesBancairesReglementRequest {
    numeroInterne?: number | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesReglementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesReglementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesReglementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesReglementRequest {
    numeroInterne?: number | undefined;
}

export class GetCoordonneesComptesBancairesReglementResponse implements IGetCoordonneesComptesBancairesReglementResponse {
    coordonneesCompteBancaireReglement?: CoordonneesCompteBancaireReglement[] | undefined;
    erreurs?: Erreur3[] | undefined;
    warnings?: Warning3[] | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesReglementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesCompteBancaireReglement"])) {
                this.coordonneesCompteBancaireReglement = [] as any;
                for (let item of _data["coordonneesCompteBancaireReglement"])
                    this.coordonneesCompteBancaireReglement!.push(CoordonneesCompteBancaireReglement.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur3.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesReglementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesReglementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesCompteBancaireReglement)) {
            data["coordonneesCompteBancaireReglement"] = [];
            for (let item of this.coordonneesCompteBancaireReglement)
                data["coordonneesCompteBancaireReglement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesReglementResponse {
    coordonneesCompteBancaireReglement?: CoordonneesCompteBancaireReglement[] | undefined;
    erreurs?: Erreur3[] | undefined;
    warnings?: Warning3[] | undefined;
}

export class UpdateForNewSourcePrelevementRequest implements IUpdateForNewSourcePrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IUpdateForNewSourcePrelevementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): UpdateForNewSourcePrelevementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForNewSourcePrelevementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IUpdateForNewSourcePrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class UpdateForNewSourcePrelevementResponse implements IUpdateForNewSourcePrelevementResponse {
    erreurs?: Erreur3[] | undefined;

    constructor(data?: IUpdateForNewSourcePrelevementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateForNewSourcePrelevementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForNewSourcePrelevementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateForNewSourcePrelevementResponse {
    erreurs?: Erreur3[] | undefined;
}

export class Warning3 implements IWarning3 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning3 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning3 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class AutoCompletionEmail implements IAutoCompletionEmail {
    instance?: number | undefined;
    suggest?: string[] | undefined;
    syntaxe?: string | undefined;

    constructor(data?: IAutoCompletionEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instance = _data["Instance"];
            if (Array.isArray(_data["suggest"])) {
                this.suggest = [] as any;
                for (let item of _data["suggest"])
                    this.suggest!.push(item);
            }
            this.syntaxe = _data["syntaxe"];
        }
    }

    static fromJS(data: any): AutoCompletionEmail {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Instance"] = this.instance;
        if (Array.isArray(this.suggest)) {
            data["suggest"] = [];
            for (let item of this.suggest)
                data["suggest"].push(item);
        }
        data["syntaxe"] = this.syntaxe;
        return data;
    }
}

export interface IAutoCompletionEmail {
    instance?: number | undefined;
    suggest?: string[] | undefined;
    syntaxe?: string | undefined;
}

export class AutoCompletionEmailRequest implements IAutoCompletionEmailRequest {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IAutoCompletionEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.email = _data["email"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): AutoCompletionEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["email"] = this.email;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IAutoCompletionEmailRequest {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class AutoCompletionEmailResponse implements IAutoCompletionEmailResponse {
    autoCompletion?: AutoCompletionEmail;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IAutoCompletionEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoCompletion = _data["autoCompletion"] ? AutoCompletionEmail.fromJS(_data["autoCompletion"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoCompletionEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoCompletion"] = this.autoCompletion ? this.autoCompletion.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAutoCompletionEmailResponse {
    autoCompletion?: AutoCompletionEmail;
    erreurs?: Erreur4[] | undefined;
}

export class ControleFormulaireRequest implements IControleFormulaireRequest {
    saisie?: string | undefined;
    taille?: number | undefined;
    proposition?: boolean | undefined;
    modification?: boolean | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IControleFormulaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saisie = _data["saisie"];
            this.taille = _data["taille"];
            this.proposition = _data["proposition"];
            this.modification = _data["modification"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ControleFormulaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ControleFormulaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saisie"] = this.saisie;
        data["taille"] = this.taille;
        data["proposition"] = this.proposition;
        data["modification"] = this.modification;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IControleFormulaireRequest {
    saisie?: string | undefined;
    taille?: number | undefined;
    proposition?: boolean | undefined;
    modification?: boolean | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class ControleFormulaireResponse implements IControleFormulaireResponse {
    controleFormulaire?: ResponseDQE4[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IControleFormulaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["controleFormulaire"])) {
                this.controleFormulaire = [] as any;
                for (let item of _data["controleFormulaire"])
                    this.controleFormulaire!.push(ResponseDQE4.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControleFormulaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControleFormulaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.controleFormulaire)) {
            data["controleFormulaire"] = [];
            for (let item of this.controleFormulaire)
                data["controleFormulaire"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IControleFormulaireResponse {
    controleFormulaire?: ResponseDQE4[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class Erreur4 implements IErreur4 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur4 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur4 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class RechercheAdresseRequest implements IRechercheAdresseRequest {
    adresse?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheAdresseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adresse = _data["adresse"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheAdresseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAdresseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresse"] = this.adresse;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheAdresseRequest {
    adresse?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheAdresseResponse implements IRechercheAdresseResponse {
    rechercheAdresse?: ResponseDQE6[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheAdresseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheAdresse"])) {
                this.rechercheAdresse = [] as any;
                for (let item of _data["rechercheAdresse"])
                    this.rechercheAdresse!.push(ResponseDQE6.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheAdresseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAdresseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheAdresse)) {
            data["rechercheAdresse"] = [];
            for (let item of this.rechercheAdresse)
                data["rechercheAdresse"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheAdresseResponse {
    rechercheAdresse?: ResponseDQE6[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheCodePostalRequest implements IRechercheCodePostalRequest {
    date?: Date | undefined;
    iNSEE?: string | undefined;
    codePostal?: string | undefined;
    nomVille?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheCodePostalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.iNSEE = _data["INSEE"];
            this.codePostal = _data["codePostal"];
            this.nomVille = _data["nomVille"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheCodePostalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheCodePostalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["INSEE"] = this.iNSEE;
        data["codePostal"] = this.codePostal;
        data["nomVille"] = this.nomVille;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheCodePostalRequest {
    date?: Date | undefined;
    iNSEE?: string | undefined;
    codePostal?: string | undefined;
    nomVille?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheCodePostalResponse implements IRechercheCodePostalResponse {
    rechercheCodePostal?: ResponseDQE8[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheCodePostalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheCodePostal"])) {
                this.rechercheCodePostal = [] as any;
                for (let item of _data["rechercheCodePostal"])
                    this.rechercheCodePostal!.push(ResponseDQE8.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheCodePostalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheCodePostalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheCodePostal)) {
            data["rechercheCodePostal"] = [];
            for (let item of this.rechercheCodePostal)
                data["rechercheCodePostal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheCodePostalResponse {
    rechercheCodePostal?: ResponseDQE8[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheComplementAdresseRequest implements IRechercheComplementAdresseRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheComplementAdresseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheComplementAdresseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheComplementAdresseRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheComplementAdresseResponse implements IRechercheComplementAdresseResponse {
    rechercheComplementAdresse?: ResponseDQE2[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheComplementAdresseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheComplementAdresse"])) {
                this.rechercheComplementAdresse = [] as any;
                for (let item of _data["rechercheComplementAdresse"])
                    this.rechercheComplementAdresse!.push(ResponseDQE2.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheComplementAdresseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheComplementAdresse)) {
            data["rechercheComplementAdresse"] = [];
            for (let item of this.rechercheComplementAdresse)
                data["rechercheComplementAdresse"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheComplementAdresseResponse {
    rechercheComplementAdresse?: ResponseDQE2[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheComplementAdresseSaisie implements IRechercheComplementAdresseSaisie {
    informations?: ResponseDQE3;

    constructor(data?: IRechercheComplementAdresseSaisie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.informations = _data["informations"] ? ResponseDQE3.fromJS(_data["informations"]) : undefined as any;
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisie {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informations"] = this.informations ? this.informations.toJSON() : undefined as any;
        return data;
    }
}

export interface IRechercheComplementAdresseSaisie {
    informations?: ResponseDQE3;
}

export class RechercheComplementAdresseSaisieRequest implements IRechercheComplementAdresseSaisieRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheComplementAdresseSaisieRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisieRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheComplementAdresseSaisieRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheComplementAdresseSaisieResponse implements IRechercheComplementAdresseSaisieResponse {
    rechercheComplementAdresseSaisie?: RechercheComplementAdresseSaisie;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheComplementAdresseSaisieResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rechercheComplementAdresseSaisie = _data["rechercheComplementAdresseSaisie"] ? RechercheComplementAdresseSaisie.fromJS(_data["rechercheComplementAdresseSaisie"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisieResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rechercheComplementAdresseSaisie"] = this.rechercheComplementAdresseSaisie ? this.rechercheComplementAdresseSaisie.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheComplementAdresseSaisieResponse {
    rechercheComplementAdresseSaisie?: RechercheComplementAdresseSaisie;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheGeolocalisationRequest implements IRechercheGeolocalisationRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheGeolocalisationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheGeolocalisationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheGeolocalisationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheGeolocalisationRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheGeolocalisationResponse implements IRechercheGeolocalisationResponse {
    rechercheGeolocalisation?: ResponseDQE7[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheGeolocalisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheGeolocalisation"])) {
                this.rechercheGeolocalisation = [] as any;
                for (let item of _data["rechercheGeolocalisation"])
                    this.rechercheGeolocalisation!.push(ResponseDQE7.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheGeolocalisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheGeolocalisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheGeolocalisation)) {
            data["rechercheGeolocalisation"] = [];
            for (let item of this.rechercheGeolocalisation)
                data["rechercheGeolocalisation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheGeolocalisationResponse {
    rechercheGeolocalisation?: ResponseDQE7[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheRueRequest implements IRechercheRueRequest {
    idVille?: number | undefined;
    adresse?: string | undefined;
    taille?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheRueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVille = _data["idVille"];
            this.adresse = _data["adresse"];
            this.taille = _data["taille"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheRueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVille"] = this.idVille;
        data["adresse"] = this.adresse;
        data["taille"] = this.taille;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheRueRequest {
    idVille?: number | undefined;
    adresse?: string | undefined;
    taille?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheRueResponse implements IRechercheRueResponse {
    rechercheRue?: ResponseDQE5[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheRueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheRue"])) {
                this.rechercheRue = [] as any;
                for (let item of _data["rechercheRue"])
                    this.rechercheRue!.push(ResponseDQE5.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheRueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheRue)) {
            data["rechercheRue"] = [];
            for (let item of this.rechercheRue)
                data["rechercheRue"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheRueResponse {
    rechercheRue?: ResponseDQE5[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheSIRETRequest implements IRechercheSIRETRequest {
    nomEntreprise?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheSIRETRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomEntreprise = _data["nomEntreprise"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheSIRETRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheSIRETRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomEntreprise"] = this.nomEntreprise;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheSIRETRequest {
    nomEntreprise?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheSIRETResponse implements IRechercheSIRETResponse {
    rechercheSIRET?: ResponseDQE9[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheSIRETResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheSIRET"])) {
                this.rechercheSIRET = [] as any;
                for (let item of _data["rechercheSIRET"])
                    this.rechercheSIRET!.push(ResponseDQE9.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheSIRETResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheSIRETResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheSIRET)) {
            data["rechercheSIRET"] = [];
            for (let item of this.rechercheSIRET)
                data["rechercheSIRET"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheSIRETResponse {
    rechercheSIRET?: ResponseDQE9[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class RechercheVilleRequest implements IRechercheVilleRequest {
    nomVille?: string | undefined;
    codePostal?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheVilleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomVille = _data["nomVille"];
            this.codePostal = _data["codePostal"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheVilleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheVilleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomVille"] = this.nomVille;
        data["codePostal"] = this.codePostal;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheVilleRequest {
    nomVille?: string | undefined;
    codePostal?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheVilleResponse implements IRechercheVilleResponse {
    rechercheVille?: ResponseDQE[] | undefined;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IRechercheVilleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheVille"])) {
                this.rechercheVille = [] as any;
                for (let item of _data["rechercheVille"])
                    this.rechercheVille!.push(ResponseDQE.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheVilleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheVilleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheVille)) {
            data["rechercheVille"] = [];
            for (let item of this.rechercheVille)
                data["rechercheVille"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheVilleResponse {
    rechercheVille?: ResponseDQE[] | undefined;
    erreurs?: Erreur4[] | undefined;
}

export class ResponseDQE implements IResponseDQE {
    province?: string | undefined;
    iDLocalite?: string | undefined;
    nbNumero?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    cedex?: string | undefined;
    numero?: string | undefined;
    typeVoie?: string | undefined;
    instance?: string | undefined;
    listeNumero?: string | undefined;
    codePostal?: string | undefined;
    sousLocalite?: string | undefined;
    lieuDit?: string | undefined;
    latitude?: string | undefined;
    localite?: string | undefined;
    longitude?: string | undefined;
    complement?: string | undefined;
    entreprise?: string | undefined;

    constructor(data?: IResponseDQE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.province = _data["Province"];
            this.iDLocalite = _data["IDLocalite"];
            this.nbNumero = _data["NbNumero"];
            this.pays = _data["Pays"];
            this.iDVoie = _data["IDVoie"];
            this.cedex = _data["Cedex"];
            this.numero = _data["Numero"];
            this.typeVoie = _data["TypeVoie"];
            this.instance = _data["Instance"];
            this.listeNumero = _data["ListeNumero"];
            this.codePostal = _data["CodePostal"];
            this.sousLocalite = _data["SousLocalite"];
            this.lieuDit = _data["LieuDit"];
            this.latitude = _data["Latitude"];
            this.localite = _data["Localite"];
            this.longitude = _data["Longitude"];
            this.complement = _data["Complement"];
            this.entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Province"] = this.province;
        data["IDLocalite"] = this.iDLocalite;
        data["NbNumero"] = this.nbNumero;
        data["Pays"] = this.pays;
        data["IDVoie"] = this.iDVoie;
        data["Cedex"] = this.cedex;
        data["Numero"] = this.numero;
        data["TypeVoie"] = this.typeVoie;
        data["Instance"] = this.instance;
        data["ListeNumero"] = this.listeNumero;
        data["CodePostal"] = this.codePostal;
        data["SousLocalite"] = this.sousLocalite;
        data["LieuDit"] = this.lieuDit;
        data["Latitude"] = this.latitude;
        data["Localite"] = this.localite;
        data["Longitude"] = this.longitude;
        data["Complement"] = this.complement;
        data["Entreprise"] = this.entreprise;
        return data;
    }
}

export interface IResponseDQE {
    province?: string | undefined;
    iDLocalite?: string | undefined;
    nbNumero?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    cedex?: string | undefined;
    numero?: string | undefined;
    typeVoie?: string | undefined;
    instance?: string | undefined;
    listeNumero?: string | undefined;
    codePostal?: string | undefined;
    sousLocalite?: string | undefined;
    lieuDit?: string | undefined;
    latitude?: string | undefined;
    localite?: string | undefined;
    longitude?: string | undefined;
    complement?: string | undefined;
    entreprise?: string | undefined;
}

export class ResponseDQE2 implements IResponseDQE2 {
    batiment?: string | undefined;

    constructor(data?: IResponseDQE2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batiment = _data["Batiment"];
        }
    }

    static fromJS(data: any): ResponseDQE2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Batiment"] = this.batiment;
        return data;
    }
}

export interface IResponseDQE2 {
    batiment?: string | undefined;
}

export class ResponseDQE3 implements IResponseDQE3 {
    longitude?: string | undefined;
    latitude?: string | undefined;
    batiment?: string[] | undefined;

    constructor(data?: IResponseDQE3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["Longitude"];
            this.latitude = _data["Latitude"];
            if (Array.isArray(_data["Batiment"])) {
                this.batiment = [] as any;
                for (let item of _data["Batiment"])
                    this.batiment!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseDQE3 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Longitude"] = this.longitude;
        data["Latitude"] = this.latitude;
        if (Array.isArray(this.batiment)) {
            data["Batiment"] = [];
            for (let item of this.batiment)
                data["Batiment"].push(item);
        }
        return data;
    }
}

export interface IResponseDQE3 {
    longitude?: string | undefined;
    latitude?: string | undefined;
    batiment?: string[] | undefined;
}

export class ResponseDQE4 implements IResponseDQE4 {
    roudis?: string | undefined;
    dQECompte?: string | undefined;
    instance?: string | undefined;
    codePostal?: string | undefined;
    status_IrisIlot?: string | undefined;
    latitude?: string | undefined;
    localite?: string | undefined;
    province?: string | undefined;
    nbNumero?: string | undefined;
    complement?: string | undefined;
    voie?: string | undefined;
    adresse?: string | undefined;
    cedex?: string | undefined;
    numero?: string | undefined;
    listeNumero?: string | undefined;
    iDHexaposte?: string | undefined;
    iDCle?: string | undefined;
    lieuDit?: string | undefined;
    ilot?: string | undefined;
    typeVoie?: string | undefined;
    dQECodeDetail?: string | undefined;
    dQELibErreur?: string | undefined;
    longitude?: string | undefined;
    compNum?: string | undefined;
    iris?: string | undefined;
    iDLocalite?: string | undefined;
    dQECodeErreur?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    numSeul?: string | undefined;
    ligne2?: string | undefined;
    dQEPourcentErreur?: string | undefined;
    status_Modification?: string | undefined;
    code_Modification?: string | undefined;

    constructor(data?: IResponseDQE4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roudis = _data["Roudis"];
            this.dQECompte = _data["DQECompte"];
            this.instance = _data["Instance"];
            this.codePostal = _data["CodePostal"];
            this.status_IrisIlot = _data["Status_IrisIlot"];
            this.latitude = _data["Latitude"];
            this.localite = _data["Localite"];
            this.province = _data["Province"];
            this.nbNumero = _data["NbNumero"];
            this.complement = _data["Complement"];
            this.voie = _data["Voie"];
            this.adresse = _data["Adresse"];
            this.cedex = _data["Cedex"];
            this.numero = _data["Numero"];
            this.listeNumero = _data["ListeNumero"];
            this.iDHexaposte = _data["IDHexaposte"];
            this.iDCle = _data["IDCle"];
            this.lieuDit = _data["LieuDit"];
            this.ilot = _data["ilot"];
            this.typeVoie = _data["TypeVoie"];
            this.dQECodeDetail = _data["DQECodeDetail"];
            this.dQELibErreur = _data["DQELibErreur"];
            this.longitude = _data["Longitude"];
            this.compNum = _data["CompNum"];
            this.iris = _data["iris"];
            this.iDLocalite = _data["IDLocalite"];
            this.dQECodeErreur = _data["DQECodeErreur"];
            this.pays = _data["Pays"];
            this.iDVoie = _data["IDVoie"];
            this.numSeul = _data["NumSeul"];
            this.ligne2 = _data["Ligne2"];
            this.dQEPourcentErreur = _data["DQEPourcentErreur"];
            this.status_Modification = _data["Status_Modification"];
            this.code_Modification = _data["Code_Modification"];
        }
    }

    static fromJS(data: any): ResponseDQE4 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Roudis"] = this.roudis;
        data["DQECompte"] = this.dQECompte;
        data["Instance"] = this.instance;
        data["CodePostal"] = this.codePostal;
        data["Status_IrisIlot"] = this.status_IrisIlot;
        data["Latitude"] = this.latitude;
        data["Localite"] = this.localite;
        data["Province"] = this.province;
        data["NbNumero"] = this.nbNumero;
        data["Complement"] = this.complement;
        data["Voie"] = this.voie;
        data["Adresse"] = this.adresse;
        data["Cedex"] = this.cedex;
        data["Numero"] = this.numero;
        data["ListeNumero"] = this.listeNumero;
        data["IDHexaposte"] = this.iDHexaposte;
        data["IDCle"] = this.iDCle;
        data["LieuDit"] = this.lieuDit;
        data["ilot"] = this.ilot;
        data["TypeVoie"] = this.typeVoie;
        data["DQECodeDetail"] = this.dQECodeDetail;
        data["DQELibErreur"] = this.dQELibErreur;
        data["Longitude"] = this.longitude;
        data["CompNum"] = this.compNum;
        data["iris"] = this.iris;
        data["IDLocalite"] = this.iDLocalite;
        data["DQECodeErreur"] = this.dQECodeErreur;
        data["Pays"] = this.pays;
        data["IDVoie"] = this.iDVoie;
        data["NumSeul"] = this.numSeul;
        data["Ligne2"] = this.ligne2;
        data["DQEPourcentErreur"] = this.dQEPourcentErreur;
        data["Status_Modification"] = this.status_Modification;
        data["Code_Modification"] = this.code_Modification;
        return data;
    }
}

export interface IResponseDQE4 {
    roudis?: string | undefined;
    dQECompte?: string | undefined;
    instance?: string | undefined;
    codePostal?: string | undefined;
    status_IrisIlot?: string | undefined;
    latitude?: string | undefined;
    localite?: string | undefined;
    province?: string | undefined;
    nbNumero?: string | undefined;
    complement?: string | undefined;
    voie?: string | undefined;
    adresse?: string | undefined;
    cedex?: string | undefined;
    numero?: string | undefined;
    listeNumero?: string | undefined;
    iDHexaposte?: string | undefined;
    iDCle?: string | undefined;
    lieuDit?: string | undefined;
    ilot?: string | undefined;
    typeVoie?: string | undefined;
    dQECodeDetail?: string | undefined;
    dQELibErreur?: string | undefined;
    longitude?: string | undefined;
    compNum?: string | undefined;
    iris?: string | undefined;
    iDLocalite?: string | undefined;
    dQECodeErreur?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    numSeul?: string | undefined;
    ligne2?: string | undefined;
    dQEPourcentErreur?: string | undefined;
    status_Modification?: string | undefined;
    code_Modification?: string | undefined;
}

export class ResponseDQE5 implements IResponseDQE5 {
    iDLocalite?: string | undefined;
    saisie?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    voie?: string | undefined;
    roudis?: string | undefined;
    listeNumero?: string | undefined;
    numero?: string | undefined;
    typeVoie?: string | undefined;
    instance?: string | undefined;
    cedex?: string | undefined;
    num?: string | undefined;
    codePostal?: string | undefined;
    nbNumero?: string | undefined;
    lieuDit?: string | undefined;
    localite?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    entreprise?: string | undefined;

    constructor(data?: IResponseDQE5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iDLocalite = _data["IDLocalite"];
            this.saisie = _data["Saisie"];
            this.pays = _data["Pays"];
            this.iDVoie = _data["IDVoie"];
            this.voie = _data["Voie"];
            this.roudis = _data["Roudis"];
            this.listeNumero = _data["ListeNumero"];
            this.numero = _data["Numero"];
            this.typeVoie = _data["TypeVoie"];
            this.instance = _data["Instance"];
            this.cedex = _data["Cedex"];
            this.num = _data["Num"];
            this.codePostal = _data["CodePostal"];
            this.nbNumero = _data["NbNumero"];
            this.lieuDit = _data["LieuDit"];
            this.localite = _data["Localite"];
            this.codeVoie = _data["CodeVoie"];
            this.complement = _data["Complement"];
            this.entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE5 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IDLocalite"] = this.iDLocalite;
        data["Saisie"] = this.saisie;
        data["Pays"] = this.pays;
        data["IDVoie"] = this.iDVoie;
        data["Voie"] = this.voie;
        data["Roudis"] = this.roudis;
        data["ListeNumero"] = this.listeNumero;
        data["Numero"] = this.numero;
        data["TypeVoie"] = this.typeVoie;
        data["Instance"] = this.instance;
        data["Cedex"] = this.cedex;
        data["Num"] = this.num;
        data["CodePostal"] = this.codePostal;
        data["NbNumero"] = this.nbNumero;
        data["LieuDit"] = this.lieuDit;
        data["Localite"] = this.localite;
        data["CodeVoie"] = this.codeVoie;
        data["Complement"] = this.complement;
        data["Entreprise"] = this.entreprise;
        return data;
    }
}

export interface IResponseDQE5 {
    iDLocalite?: string | undefined;
    saisie?: string | undefined;
    pays?: string | undefined;
    iDVoie?: string | undefined;
    voie?: string | undefined;
    roudis?: string | undefined;
    listeNumero?: string | undefined;
    numero?: string | undefined;
    typeVoie?: string | undefined;
    instance?: string | undefined;
    cedex?: string | undefined;
    num?: string | undefined;
    codePostal?: string | undefined;
    nbNumero?: string | undefined;
    lieuDit?: string | undefined;
    localite?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    entreprise?: string | undefined;
}

export class ResponseDQE6 implements IResponseDQE6 {
    instance?: string | undefined;
    province?: string | undefined;
    iDLocalite?: string | undefined;
    codePostal?: string | undefined;
    localite?: string | undefined;
    pays?: string | undefined;
    lieuDit?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    iDVoie?: string | undefined;
    codeVoie?: string | undefined;
    label?: string | undefined;
    region3?: string | undefined;
    region2?: string | undefined;
    region1?: string | undefined;
    region4?: string | undefined;
    numero?: string | undefined;
    num?: string | undefined;
    nbNumero?: string | undefined;
    nbnumero?: string | undefined;
    valid_num?: string | undefined;
    numSeul?: string | undefined;
    listeNumero?: string | undefined;
    typeVoie?: string | undefined;
    voie?: string | undefined;
    suburb?: string | undefined;
    sousLocalite?: string | undefined;
    complement?: string | undefined;
    saisie?: string | undefined;
    entreprise?: string | undefined;

    constructor(data?: IResponseDQE6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instance = _data["Instance"];
            this.province = _data["Province"];
            this.iDLocalite = _data["IDLocalite"];
            this.codePostal = _data["CodePostal"];
            this.localite = _data["Localite"];
            this.pays = _data["Pays"];
            this.lieuDit = _data["LieuDit"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.iDVoie = _data["IDVoie"];
            this.codeVoie = _data["CodeVoie"];
            this.label = _data["label"];
            this.region3 = _data["Region3"];
            this.region2 = _data["Region2"];
            this.region1 = _data["Region1"];
            this.region4 = _data["Region4"];
            this.numero = _data["Numero"];
            this.num = _data["Num"];
            this.nbNumero = _data["NbNumero"];
            this.nbnumero = _data["Nbnumero"];
            this.valid_num = _data["valid_num"];
            this.numSeul = _data["NumSeul"];
            this.listeNumero = _data["ListeNumero"];
            this.typeVoie = _data["TypeVoie"];
            this.voie = _data["Voie"];
            this.suburb = _data["Suburb"];
            this.sousLocalite = _data["SousLocalite"];
            this.complement = _data["Complement"];
            this.saisie = _data["Saisie"];
            this.entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE6 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Instance"] = this.instance;
        data["Province"] = this.province;
        data["IDLocalite"] = this.iDLocalite;
        data["CodePostal"] = this.codePostal;
        data["Localite"] = this.localite;
        data["Pays"] = this.pays;
        data["LieuDit"] = this.lieuDit;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["IDVoie"] = this.iDVoie;
        data["CodeVoie"] = this.codeVoie;
        data["label"] = this.label;
        data["Region3"] = this.region3;
        data["Region2"] = this.region2;
        data["Region1"] = this.region1;
        data["Region4"] = this.region4;
        data["Numero"] = this.numero;
        data["Num"] = this.num;
        data["NbNumero"] = this.nbNumero;
        data["Nbnumero"] = this.nbnumero;
        data["valid_num"] = this.valid_num;
        data["NumSeul"] = this.numSeul;
        data["ListeNumero"] = this.listeNumero;
        data["TypeVoie"] = this.typeVoie;
        data["Voie"] = this.voie;
        data["Suburb"] = this.suburb;
        data["SousLocalite"] = this.sousLocalite;
        data["Complement"] = this.complement;
        data["Saisie"] = this.saisie;
        data["Entreprise"] = this.entreprise;
        return data;
    }
}

export interface IResponseDQE6 {
    instance?: string | undefined;
    province?: string | undefined;
    iDLocalite?: string | undefined;
    codePostal?: string | undefined;
    localite?: string | undefined;
    pays?: string | undefined;
    lieuDit?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    iDVoie?: string | undefined;
    codeVoie?: string | undefined;
    label?: string | undefined;
    region3?: string | undefined;
    region2?: string | undefined;
    region1?: string | undefined;
    region4?: string | undefined;
    numero?: string | undefined;
    num?: string | undefined;
    nbNumero?: string | undefined;
    nbnumero?: string | undefined;
    valid_num?: string | undefined;
    numSeul?: string | undefined;
    listeNumero?: string | undefined;
    typeVoie?: string | undefined;
    voie?: string | undefined;
    suburb?: string | undefined;
    sousLocalite?: string | undefined;
    complement?: string | undefined;
    saisie?: string | undefined;
    entreprise?: string | undefined;
}

export class ResponseDQE7 implements IResponseDQE7 {
    latitude?: string | undefined;
    longitude?: string | undefined;
    libelleQualiteGeo?: string | undefined;
    codeQualiteGeo?: string | undefined;

    constructor(data?: IResponseDQE7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.libelleQualiteGeo = _data["LibelleQualiteGeo"];
            this.codeQualiteGeo = _data["CodeQualiteGeo"];
        }
    }

    static fromJS(data: any): ResponseDQE7 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["LibelleQualiteGeo"] = this.libelleQualiteGeo;
        data["CodeQualiteGeo"] = this.codeQualiteGeo;
        return data;
    }
}

export interface IResponseDQE7 {
    latitude?: string | undefined;
    longitude?: string | undefined;
    libelleQualiteGeo?: string | undefined;
    codeQualiteGeo?: string | undefined;
}

export class ResponseDQE8 implements IResponseDQE8 {
    localite?: string | undefined;
    pays?: string | undefined;
    insee?: string | undefined;
    codePostal?: string | undefined;
    status?: string | undefined;

    constructor(data?: IResponseDQE8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localite = _data["Localite"];
            this.pays = _data["Pays"];
            this.insee = _data["Insee"];
            this.codePostal = _data["CodePostal"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ResponseDQE8 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Localite"] = this.localite;
        data["Pays"] = this.pays;
        data["Insee"] = this.insee;
        data["CodePostal"] = this.codePostal;
        data["Status"] = this.status;
        return data;
    }
}

export interface IResponseDQE8 {
    localite?: string | undefined;
    pays?: string | undefined;
    insee?: string | undefined;
    codePostal?: string | undefined;
    status?: string | undefined;
}

export class ResponseDQE9 implements IResponseDQE9 {
    sEARCH_REF?: string | undefined;
    companyCName?: string | undefined;
    companyAddress1?: string | undefined;
    incorporationDate?: Date | undefined;
    legalStructureLabel?: string | undefined;
    companyStatus?: string | undefined;
    companyName?: string | undefined;
    companyAddress2?: string | undefined;
    companyAddress3?: string | undefined;
    locality?: string | undefined;
    dissolutionDate?: Date | undefined;
    phone?: string | undefined;
    mainCompanyFlag?: string | undefined;
    staffCount?: string | undefined;
    companySIC?: string | undefined;
    legalStructureCode?: string | undefined;
    intraNumber?: string | undefined;
    zIP_Code?: string | undefined;
    turnOver?: string | undefined;
    companyNumber?: string | undefined;
    sIREN?: string | undefined;

    constructor(data?: IResponseDQE9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sEARCH_REF = _data["SEARCH_REF"];
            this.companyCName = _data["CompanyCName"];
            this.companyAddress1 = _data["CompanyAddress1"];
            this.incorporationDate = _data["IncorporationDate"] ? new Date(_data["IncorporationDate"].toString()) : undefined as any;
            this.legalStructureLabel = _data["LegalStructureLabel"];
            this.companyStatus = _data["CompanyStatus"];
            this.companyName = _data["CompanyName"];
            this.companyAddress2 = _data["CompanyAddress2"];
            this.companyAddress3 = _data["CompanyAddress3"];
            this.locality = _data["Locality"];
            this.dissolutionDate = _data["DissolutionDate"] ? new Date(_data["DissolutionDate"].toString()) : undefined as any;
            this.phone = _data["Phone"];
            this.mainCompanyFlag = _data["MainCompanyFlag"];
            this.staffCount = _data["StaffCount"];
            this.companySIC = _data["CompanySIC"];
            this.legalStructureCode = _data["LegalStructureCode"];
            this.intraNumber = _data["IntraNumber"];
            this.zIP_Code = _data["ZIP_Code"];
            this.turnOver = _data["TurnOver"];
            this.companyNumber = _data["CompanyNumber"];
            this.sIREN = _data["SIREN"];
        }
    }

    static fromJS(data: any): ResponseDQE9 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SEARCH_REF"] = this.sEARCH_REF;
        data["CompanyCName"] = this.companyCName;
        data["CompanyAddress1"] = this.companyAddress1;
        data["IncorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : undefined as any;
        data["LegalStructureLabel"] = this.legalStructureLabel;
        data["CompanyStatus"] = this.companyStatus;
        data["CompanyName"] = this.companyName;
        data["CompanyAddress2"] = this.companyAddress2;
        data["CompanyAddress3"] = this.companyAddress3;
        data["Locality"] = this.locality;
        data["DissolutionDate"] = this.dissolutionDate ? this.dissolutionDate.toISOString() : undefined as any;
        data["Phone"] = this.phone;
        data["MainCompanyFlag"] = this.mainCompanyFlag;
        data["StaffCount"] = this.staffCount;
        data["CompanySIC"] = this.companySIC;
        data["LegalStructureCode"] = this.legalStructureCode;
        data["IntraNumber"] = this.intraNumber;
        data["ZIP_Code"] = this.zIP_Code;
        data["TurnOver"] = this.turnOver;
        data["CompanyNumber"] = this.companyNumber;
        data["SIREN"] = this.sIREN;
        return data;
    }
}

export interface IResponseDQE9 {
    sEARCH_REF?: string | undefined;
    companyCName?: string | undefined;
    companyAddress1?: string | undefined;
    incorporationDate?: Date | undefined;
    legalStructureLabel?: string | undefined;
    companyStatus?: string | undefined;
    companyName?: string | undefined;
    companyAddress2?: string | undefined;
    companyAddress3?: string | undefined;
    locality?: string | undefined;
    dissolutionDate?: Date | undefined;
    phone?: string | undefined;
    mainCompanyFlag?: string | undefined;
    staffCount?: string | undefined;
    companySIC?: string | undefined;
    legalStructureCode?: string | undefined;
    intraNumber?: string | undefined;
    zIP_Code?: string | undefined;
    turnOver?: string | undefined;
    companyNumber?: string | undefined;
    sIREN?: string | undefined;
}

export class ValidationEmail implements IValidationEmail {
    redressement?: number | undefined;
    eMailOrigine?: string | undefined;
    idError?: number | undefined;
    eMail?: string | undefined;

    constructor(data?: IValidationEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redressement = _data["Redressement"];
            this.eMailOrigine = _data["eMailOrigine"];
            this.idError = _data["IdError"];
            this.eMail = _data["eMail"];
        }
    }

    static fromJS(data: any): ValidationEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Redressement"] = this.redressement;
        data["eMailOrigine"] = this.eMailOrigine;
        data["IdError"] = this.idError;
        data["eMail"] = this.eMail;
        return data;
    }
}

export interface IValidationEmail {
    redressement?: number | undefined;
    eMailOrigine?: string | undefined;
    idError?: number | undefined;
    eMail?: string | undefined;
}

export class ValidationEmailRequest implements IValidationEmailRequest {
    email?: string | undefined;
    isRectify?: boolean | undefined;
    isExtendedSyntax?: boolean | undefined;
    isCheckUser?: boolean | undefined;
    idCanal?: number | undefined;

    constructor(data?: IValidationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.isRectify = _data["isRectify"];
            this.isExtendedSyntax = _data["isExtendedSyntax"];
            this.isCheckUser = _data["isCheckUser"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ValidationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isRectify"] = this.isRectify;
        data["isExtendedSyntax"] = this.isExtendedSyntax;
        data["isCheckUser"] = this.isCheckUser;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IValidationEmailRequest {
    email?: string | undefined;
    isRectify?: boolean | undefined;
    isExtendedSyntax?: boolean | undefined;
    isCheckUser?: boolean | undefined;
    idCanal?: number | undefined;
}

export class ValidationEmailResponse implements IValidationEmailResponse {
    validation?: ValidationEmail;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IValidationEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"] ? ValidationEmail.fromJS(_data["validation"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationEmailResponse {
    validation?: ValidationEmail;
    erreurs?: Erreur4[] | undefined;
}

export class ValidationNumTel implements IValidationNumTel {
    telOrigine?: string | undefined;
    geolocation?: string | undefined;
    tel?: string | undefined;
    ported?: string | undefined;
    operator?: string | undefined;
    idError?: number | undefined;
    oldOperator?: string | undefined;
    type?: string | undefined;

    constructor(data?: IValidationNumTel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telOrigine = _data["TelOrigine"];
            this.geolocation = _data["Geolocation"];
            this.tel = _data["Tel"];
            this.ported = _data["Ported"];
            this.operator = _data["Operator"];
            this.idError = _data["IdError"];
            this.oldOperator = _data["OldOperator"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): ValidationNumTel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TelOrigine"] = this.telOrigine;
        data["Geolocation"] = this.geolocation;
        data["Tel"] = this.tel;
        data["Ported"] = this.ported;
        data["Operator"] = this.operator;
        data["IdError"] = this.idError;
        data["OldOperator"] = this.oldOperator;
        data["Type"] = this.type;
        return data;
    }
}

export interface IValidationNumTel {
    telOrigine?: string | undefined;
    geolocation?: string | undefined;
    tel?: string | undefined;
    ported?: string | undefined;
    operator?: string | undefined;
    idError?: number | undefined;
    oldOperator?: string | undefined;
    type?: string | undefined;
}

export class ValidationNumTelRequest implements IValidationNumTelRequest {
    numTel?: string | undefined;
    codePaysISO?: string | undefined;
    format?: number | undefined;
    idCanal?: number | undefined;

    constructor(data?: IValidationNumTelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numTel = _data["numTel"];
            this.codePaysISO = _data["codePaysISO"];
            this.format = _data["format"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ValidationNumTelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numTel"] = this.numTel;
        data["codePaysISO"] = this.codePaysISO;
        data["format"] = this.format;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IValidationNumTelRequest {
    numTel?: string | undefined;
    codePaysISO?: string | undefined;
    format?: number | undefined;
    idCanal?: number | undefined;
}

export class ValidationNumTelResponse implements IValidationNumTelResponse {
    validation?: ValidationNumTel;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IValidationNumTelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"] ? ValidationNumTel.fromJS(_data["validation"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationNumTelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationNumTelResponse {
    validation?: ValidationNumTel;
    erreurs?: Erreur4[] | undefined;
}

export class ContratInformations implements IContratInformations {
    numeroPolice?: number | undefined;
    codeProduit?: string | undefined;
    categorieContrat?: string | undefined;
    libelleContrat?: string | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    idModeGestion?: number | undefined;
    libelleModeGestion?: string | undefined;
    cotisation?: number | undefined;
    capital?: number | undefined;
    montantCapitalDeces?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatContrat?: number | undefined;
    libelleCategorieEtatContrat?: string | undefined;
    idEtatContratSocietaire?: number | undefined;
    libelleEtatContratSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateEffetFiscale?: Date | undefined;
    dateCloture?: Date | undefined;
    dateModificationCB?: Date | undefined;
    supports?: Support[] | undefined;

    constructor(data?: IContratInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroPolice = _data["numeroPolice"];
            this.codeProduit = _data["codeProduit"];
            this.categorieContrat = _data["categorieContrat"];
            this.libelleContrat = _data["libelleContrat"];
            this.montantValeurRT = _data["montantValeurRT"];
            this.montantValeurRP = _data["montantValeurRP"];
            this.idModeGestion = _data["idModeGestion"];
            this.libelleModeGestion = _data["libelleModeGestion"];
            this.cotisation = _data["cotisation"];
            this.capital = _data["capital"];
            this.montantCapitalDeces = _data["montantCapitalDeces"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.idCategorieEtatContrat = _data["idCategorieEtatContrat"];
            this.libelleCategorieEtatContrat = _data["libelleCategorieEtatContrat"];
            this.idEtatContratSocietaire = _data["idEtatContratSocietaire"];
            this.libelleEtatContratSocietaire = _data["libelleEtatContratSocietaire"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : undefined as any;
            this.dateEffetFiscale = _data["dateEffetFiscale"] ? new Date(_data["dateEffetFiscale"].toString()) : undefined as any;
            this.dateCloture = _data["dateCloture"] ? new Date(_data["dateCloture"].toString()) : undefined as any;
            this.dateModificationCB = _data["dateModificationCB"] ? new Date(_data["dateModificationCB"].toString()) : undefined as any;
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContratInformations {
        data = typeof data === 'object' ? data : {};
        let result = new ContratInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroPolice"] = this.numeroPolice;
        data["codeProduit"] = this.codeProduit;
        data["categorieContrat"] = this.categorieContrat;
        data["libelleContrat"] = this.libelleContrat;
        data["montantValeurRT"] = this.montantValeurRT;
        data["montantValeurRP"] = this.montantValeurRP;
        data["idModeGestion"] = this.idModeGestion;
        data["libelleModeGestion"] = this.libelleModeGestion;
        data["cotisation"] = this.cotisation;
        data["capital"] = this.capital;
        data["montantCapitalDeces"] = this.montantCapitalDeces;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["idCategorieEtatContrat"] = this.idCategorieEtatContrat;
        data["libelleCategorieEtatContrat"] = this.libelleCategorieEtatContrat;
        data["idEtatContratSocietaire"] = this.idEtatContratSocietaire;
        data["libelleEtatContratSocietaire"] = this.libelleEtatContratSocietaire;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : undefined as any;
        data["dateEffetFiscale"] = this.dateEffetFiscale ? this.dateEffetFiscale.toISOString() : undefined as any;
        data["dateCloture"] = this.dateCloture ? this.dateCloture.toISOString() : undefined as any;
        data["dateModificationCB"] = this.dateModificationCB ? this.dateModificationCB.toISOString() : undefined as any;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContratInformations {
    numeroPolice?: number | undefined;
    codeProduit?: string | undefined;
    categorieContrat?: string | undefined;
    libelleContrat?: string | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    idModeGestion?: number | undefined;
    libelleModeGestion?: string | undefined;
    cotisation?: number | undefined;
    capital?: number | undefined;
    montantCapitalDeces?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatContrat?: number | undefined;
    libelleCategorieEtatContrat?: string | undefined;
    idEtatContratSocietaire?: number | undefined;
    libelleEtatContratSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateEffetFiscale?: Date | undefined;
    dateCloture?: Date | undefined;
    dateModificationCB?: Date | undefined;
    supports?: Support[] | undefined;
}

export class Erreur5 implements IErreur5 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur5 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur5 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetPolicesRequest implements IGetPolicesRequest {
    noSocietaireInterne?: number | undefined;
    proposition?: Proposition;
    police?: Police;

    constructor(data?: IGetPolicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.proposition = _data["proposition"] ? Proposition.fromJS(_data["proposition"]) : undefined as any;
            this.police = _data["police"] ? Police.fromJS(_data["police"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPolicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["proposition"] = this.proposition ? this.proposition.toJSON() : undefined as any;
        data["police"] = this.police ? this.police.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPolicesRequest {
    noSocietaireInterne?: number | undefined;
    proposition?: Proposition;
    police?: Police;
}

export class GetPolicesResponse implements IGetPolicesResponse {
    propositions?: Proposition2[] | undefined;
    police?: Police2;
    erreurs?: Erreur5[] | undefined;

    constructor(data?: IGetPolicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propositions"])) {
                this.propositions = [] as any;
                for (let item of _data["propositions"])
                    this.propositions!.push(Proposition2.fromJS(item));
            }
            this.police = _data["police"] ? Police2.fromJS(_data["police"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPolicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propositions)) {
            data["propositions"] = [];
            for (let item of this.propositions)
                data["propositions"].push(item ? item.toJSON() : undefined as any);
        }
        data["police"] = this.police ? this.police.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPolicesResponse {
    propositions?: Proposition2[] | undefined;
    police?: Police2;
    erreurs?: Erreur5[] | undefined;
}

export class Police implements IPolice {
    getContrats?: boolean | undefined;
    getSupportsContrats?: boolean | undefined;
    getRentes?: boolean | undefined;

    constructor(data?: IPolice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getContrats = _data["getContrats"];
            this.getSupportsContrats = _data["getSupportsContrats"];
            this.getRentes = _data["getRentes"];
        }
    }

    static fromJS(data: any): Police {
        data = typeof data === 'object' ? data : {};
        let result = new Police();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getContrats"] = this.getContrats;
        data["getSupportsContrats"] = this.getSupportsContrats;
        data["getRentes"] = this.getRentes;
        return data;
    }
}

export interface IPolice {
    getContrats?: boolean | undefined;
    getSupportsContrats?: boolean | undefined;
    getRentes?: boolean | undefined;
}

export class Police2 implements IPolice2 {
    contratInformations?: ContratInformations[] | undefined;
    renteInformations?: RenteInformations[] | undefined;

    constructor(data?: IPolice2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contratInformations"])) {
                this.contratInformations = [] as any;
                for (let item of _data["contratInformations"])
                    this.contratInformations!.push(ContratInformations.fromJS(item));
            }
            if (Array.isArray(_data["renteInformations"])) {
                this.renteInformations = [] as any;
                for (let item of _data["renteInformations"])
                    this.renteInformations!.push(RenteInformations.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Police2 {
        data = typeof data === 'object' ? data : {};
        let result = new Police2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contratInformations)) {
            data["contratInformations"] = [];
            for (let item of this.contratInformations)
                data["contratInformations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.renteInformations)) {
            data["renteInformations"] = [];
            for (let item of this.renteInformations)
                data["renteInformations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPolice2 {
    contratInformations?: ContratInformations[] | undefined;
    renteInformations?: RenteInformations[] | undefined;
}

export class Proposition implements IProposition {
    getPropositions?: boolean | undefined;

    constructor(data?: IProposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getPropositions = _data["getPropositions"];
        }
    }

    static fromJS(data: any): Proposition {
        data = typeof data === 'object' ? data : {};
        let result = new Proposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getPropositions"] = this.getPropositions;
        return data;
    }
}

export interface IProposition {
    getPropositions?: boolean | undefined;
}

export class Proposition2 implements IProposition2 {
    numeroProposition?: number | undefined;
    codeProduit?: string | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    codePromotion?: string | undefined;
    codeOperation?: string | undefined;
    codeApporteur?: string | undefined;
    dateCreation?: Date | undefined;
    dateEffet?: Date | undefined;
    dateSignature?: Date | undefined;

    constructor(data?: IProposition2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroProposition = _data["numeroProposition"];
            this.codeProduit = _data["codeProduit"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.codePromotion = _data["codePromotion"];
            this.codeOperation = _data["codeOperation"];
            this.codeApporteur = _data["codeApporteur"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : undefined as any;
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : undefined as any;
            this.dateSignature = _data["dateSignature"] ? new Date(_data["dateSignature"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Proposition2 {
        data = typeof data === 'object' ? data : {};
        let result = new Proposition2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroProposition"] = this.numeroProposition;
        data["codeProduit"] = this.codeProduit;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["codePromotion"] = this.codePromotion;
        data["codeOperation"] = this.codeOperation;
        data["codeApporteur"] = this.codeApporteur;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : undefined as any;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : undefined as any;
        data["dateSignature"] = this.dateSignature ? this.dateSignature.toISOString() : undefined as any;
        return data;
    }
}

export interface IProposition2 {
    numeroProposition?: number | undefined;
    codeProduit?: string | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    codePromotion?: string | undefined;
    codeOperation?: string | undefined;
    codeApporteur?: string | undefined;
    dateCreation?: Date | undefined;
    dateEffet?: Date | undefined;
    dateSignature?: Date | undefined;
}

export class RenteInformations implements IRenteInformations {
    numeroRente?: number | undefined;
    codeProduit?: string | undefined;
    libelleContrat?: string | undefined;
    categorieContrat?: string | undefined;
    idOption?: number | undefined;
    libelleOption?: string | undefined;
    tauxReversion?: number | undefined;
    montantTrimestriel?: number | undefined;
    montantCapitalReserve?: number | undefined;
    valeurRachat?: number | undefined;
    numeroContratSource?: number | undefined;
    libelleContratSource?: string | undefined;
    dateOuvertureContratSource?: Date | undefined;
    numeroRentier?: number | undefined;
    numeroReversataire?: number | undefined;
    flagAC?: boolean | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatRente?: number | undefined;
    libelleCategorieEtatRente?: string | undefined;
    idEtatRenteSocietaire?: number | undefined;
    libelleEtatRenteSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
    versementRente?: VersementRente[] | undefined;

    constructor(data?: IRenteInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroRente = _data["numeroRente"];
            this.codeProduit = _data["codeProduit"];
            this.libelleContrat = _data["libelleContrat"];
            this.categorieContrat = _data["categorieContrat"];
            this.idOption = _data["idOption"];
            this.libelleOption = _data["libelleOption"];
            this.tauxReversion = _data["tauxReversion"];
            this.montantTrimestriel = _data["montantTrimestriel"];
            this.montantCapitalReserve = _data["montantCapitalReserve"];
            this.valeurRachat = _data["valeurRachat"];
            this.numeroContratSource = _data["numeroContratSource"];
            this.libelleContratSource = _data["libelleContratSource"];
            this.dateOuvertureContratSource = _data["dateOuvertureContratSource"] ? new Date(_data["dateOuvertureContratSource"].toString()) : undefined as any;
            this.numeroRentier = _data["numeroRentier"];
            this.numeroReversataire = _data["numeroReversataire"];
            this.flagAC = _data["flagAC"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.idCategorieEtatRente = _data["idCategorieEtatRente"];
            this.libelleCategorieEtatRente = _data["libelleCategorieEtatRente"];
            this.idEtatRenteSocietaire = _data["idEtatRenteSocietaire"];
            this.libelleEtatRenteSocietaire = _data["libelleEtatRenteSocietaire"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : undefined as any;
            this.dateFinEffet = _data["dateFinEffet"] ? new Date(_data["dateFinEffet"].toString()) : undefined as any;
            if (Array.isArray(_data["versementRente"])) {
                this.versementRente = [] as any;
                for (let item of _data["versementRente"])
                    this.versementRente!.push(VersementRente.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RenteInformations {
        data = typeof data === 'object' ? data : {};
        let result = new RenteInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroRente"] = this.numeroRente;
        data["codeProduit"] = this.codeProduit;
        data["libelleContrat"] = this.libelleContrat;
        data["categorieContrat"] = this.categorieContrat;
        data["idOption"] = this.idOption;
        data["libelleOption"] = this.libelleOption;
        data["tauxReversion"] = this.tauxReversion;
        data["montantTrimestriel"] = this.montantTrimestriel;
        data["montantCapitalReserve"] = this.montantCapitalReserve;
        data["valeurRachat"] = this.valeurRachat;
        data["numeroContratSource"] = this.numeroContratSource;
        data["libelleContratSource"] = this.libelleContratSource;
        data["dateOuvertureContratSource"] = this.dateOuvertureContratSource ? this.dateOuvertureContratSource.toISOString() : undefined as any;
        data["numeroRentier"] = this.numeroRentier;
        data["numeroReversataire"] = this.numeroReversataire;
        data["flagAC"] = this.flagAC;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["idCategorieEtatRente"] = this.idCategorieEtatRente;
        data["libelleCategorieEtatRente"] = this.libelleCategorieEtatRente;
        data["idEtatRenteSocietaire"] = this.idEtatRenteSocietaire;
        data["libelleEtatRenteSocietaire"] = this.libelleEtatRenteSocietaire;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : undefined as any;
        data["dateFinEffet"] = this.dateFinEffet ? this.dateFinEffet.toISOString() : undefined as any;
        if (Array.isArray(this.versementRente)) {
            data["versementRente"] = [];
            for (let item of this.versementRente)
                data["versementRente"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRenteInformations {
    numeroRente?: number | undefined;
    codeProduit?: string | undefined;
    libelleContrat?: string | undefined;
    categorieContrat?: string | undefined;
    idOption?: number | undefined;
    libelleOption?: string | undefined;
    tauxReversion?: number | undefined;
    montantTrimestriel?: number | undefined;
    montantCapitalReserve?: number | undefined;
    valeurRachat?: number | undefined;
    numeroContratSource?: number | undefined;
    libelleContratSource?: string | undefined;
    dateOuvertureContratSource?: Date | undefined;
    numeroRentier?: number | undefined;
    numeroReversataire?: number | undefined;
    flagAC?: boolean | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatRente?: number | undefined;
    libelleCategorieEtatRente?: string | undefined;
    idEtatRenteSocietaire?: number | undefined;
    libelleEtatRenteSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
    versementRente?: VersementRente[] | undefined;
}

export class Support implements ISupport {
    codeGarantie?: string | undefined;
    codeIsin?: string | undefined;
    libelleSupport?: string | undefined;
    montant?: number | undefined;
    pourcentage?: number | undefined;

    constructor(data?: ISupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeGarantie = _data["codeGarantie"];
            this.codeIsin = _data["codeIsin"];
            this.libelleSupport = _data["libelleSupport"];
            this.montant = _data["montant"];
            this.pourcentage = _data["pourcentage"];
        }
    }

    static fromJS(data: any): Support {
        data = typeof data === 'object' ? data : {};
        let result = new Support();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeGarantie"] = this.codeGarantie;
        data["codeIsin"] = this.codeIsin;
        data["libelleSupport"] = this.libelleSupport;
        data["montant"] = this.montant;
        data["pourcentage"] = this.pourcentage;
        return data;
    }
}

export interface ISupport {
    codeGarantie?: string | undefined;
    codeIsin?: string | undefined;
    libelleSupport?: string | undefined;
    montant?: number | undefined;
    pourcentage?: number | undefined;
}

export class VersementRente implements IVersementRente {
    numeroVersement?: number | undefined;
    numeroInterne?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;

    constructor(data?: IVersementRente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroVersement = _data["numeroVersement"];
            this.numeroInterne = _data["numeroInterne"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : undefined as any;
            this.dateFinEffet = _data["dateFinEffet"] ? new Date(_data["dateFinEffet"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VersementRente {
        data = typeof data === 'object' ? data : {};
        let result = new VersementRente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroVersement"] = this.numeroVersement;
        data["numeroInterne"] = this.numeroInterne;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : undefined as any;
        data["dateFinEffet"] = this.dateFinEffet ? this.dateFinEffet.toISOString() : undefined as any;
        return data;
    }
}

export interface IVersementRente {
    numeroVersement?: number | undefined;
    numeroInterne?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
}

export class Apporteur implements IApporteur {
    numeroApporteur?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IApporteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroApporteur = _data["numeroApporteur"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Apporteur {
        data = typeof data === 'object' ? data : {};
        let result = new Apporteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroApporteur"] = this.numeroApporteur;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IApporteur {
    numeroApporteur?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Assure1 implements IAssure1 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IAssure1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Assure1 {
        data = typeof data === 'object' ? data : {};
        let result = new Assure1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssure1 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Assure2 implements IAssure2 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IAssure2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Assure2 {
        data = typeof data === 'object' ? data : {};
        let result = new Assure2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssure2 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Beneficiaire implements IBeneficiaire {
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;

    constructor(data?: IBeneficiaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
        }
    }

    static fromJS(data: any): Beneficiaire {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        return data;
    }
}

export interface IBeneficiaire {
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
}

export class ContratTransferableFourgous implements IContratTransferableFourgous {
    numeroContrat?: number | undefined;
    libelleContrat?: string | undefined;
    dateEffet?: string | undefined;
    valeurRachat?: number | undefined;

    constructor(data?: IContratTransferableFourgous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.libelleContrat = _data["libelleContrat"];
            this.dateEffet = _data["dateEffet"];
            this.valeurRachat = _data["valeurRachat"];
        }
    }

    static fromJS(data: any): ContratTransferableFourgous {
        data = typeof data === 'object' ? data : {};
        let result = new ContratTransferableFourgous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["libelleContrat"] = this.libelleContrat;
        data["dateEffet"] = this.dateEffet;
        data["valeurRachat"] = this.valeurRachat;
        return data;
    }
}

export interface IContratTransferableFourgous {
    numeroContrat?: number | undefined;
    libelleContrat?: string | undefined;
    dateEffet?: string | undefined;
    valeurRachat?: number | undefined;
}

export class DemarcheEnCours implements IDemarcheEnCours {
    idDemarche?: number | undefined;
    numeroContrat?: number | undefined;
    numeroDemarche?: number | undefined;

    constructor(data?: IDemarcheEnCours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idDemarche = _data["idDemarche"];
            this.numeroContrat = _data["numeroContrat"];
            this.numeroDemarche = _data["numeroDemarche"];
        }
    }

    static fromJS(data: any): DemarcheEnCours {
        data = typeof data === 'object' ? data : {};
        let result = new DemarcheEnCours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idDemarche"] = this.idDemarche;
        data["numeroContrat"] = this.numeroContrat;
        data["numeroDemarche"] = this.numeroDemarche;
        return data;
    }
}

export interface IDemarcheEnCours {
    idDemarche?: number | undefined;
    numeroContrat?: number | undefined;
    numeroDemarche?: number | undefined;
}

export class Erreur6 implements IErreur6 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur6 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur6 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetClientByNumeroContratRequest implements IGetClientByNumeroContratRequest {
    noContrat?: number | undefined;

    constructor(data?: IGetClientByNumeroContratRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): GetClientByNumeroContratRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroContratRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IGetClientByNumeroContratRequest {
    noContrat?: number | undefined;
}

export class GetClientByNumeroContratResponse implements IGetClientByNumeroContratResponse {
    numeroInterneSouscripteur?: number | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IGetClientByNumeroContratResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterneSouscripteur = _data["numeroInterneSouscripteur"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByNumeroContratResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroContratResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterneSouscripteur"] = this.numeroInterneSouscripteur;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetClientByNumeroContratResponse {
    numeroInterneSouscripteur?: number | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class GetContratsTransferablesFourgousRequest implements IGetContratsTransferablesFourgousRequest {
    codeProduit?: string | undefined;
    numeroSocietaireInterne?: number;

    constructor(data?: IGetContratsTransferablesFourgousRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
        }
    }

    static fromJS(data: any): GetContratsTransferablesFourgousRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratsTransferablesFourgousRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        return data;
    }
}

export interface IGetContratsTransferablesFourgousRequest {
    codeProduit?: string | undefined;
    numeroSocietaireInterne?: number;
}

export class GetContratsTransferablesFourgousResponse implements IGetContratsTransferablesFourgousResponse {
    contratTransferableFourgous?: ContratTransferableFourgous[] | undefined;
    erreurs?: Erreur6[] | undefined;
    warnings?: Warning4[] | undefined;

    constructor(data?: IGetContratsTransferablesFourgousResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contratTransferableFourgous"])) {
                this.contratTransferableFourgous = [] as any;
                for (let item of _data["contratTransferableFourgous"])
                    this.contratTransferableFourgous!.push(ContratTransferableFourgous.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContratsTransferablesFourgousResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratsTransferablesFourgousResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contratTransferableFourgous)) {
            data["contratTransferableFourgous"] = [];
            for (let item of this.contratTransferableFourgous)
                data["contratTransferableFourgous"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetContratsTransferablesFourgousResponse {
    contratTransferableFourgous?: ContratTransferableFourgous[] | undefined;
    erreurs?: Erreur6[] | undefined;
    warnings?: Warning4[] | undefined;
}

export class GetDemarchesEnCoursRequest implements IGetDemarchesEnCoursRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IGetDemarchesEnCoursRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetDemarchesEnCoursRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemarchesEnCoursRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetDemarchesEnCoursRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class GetDemarchesEnCoursResponse implements IGetDemarchesEnCoursResponse {
    demarcheEnCours?: DemarcheEnCours[] | undefined;
    erreurs?: Erreur6[] | undefined;
    warnings?: Warning4[] | undefined;

    constructor(data?: IGetDemarchesEnCoursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demarcheEnCours"])) {
                this.demarcheEnCours = [] as any;
                for (let item of _data["demarcheEnCours"])
                    this.demarcheEnCours!.push(DemarcheEnCours.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDemarchesEnCoursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemarchesEnCoursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demarcheEnCours)) {
            data["demarcheEnCours"] = [];
            for (let item of this.demarcheEnCours)
                data["demarcheEnCours"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDemarchesEnCoursResponse {
    demarcheEnCours?: DemarcheEnCours[] | undefined;
    erreurs?: Erreur6[] | undefined;
    warnings?: Warning4[] | undefined;
}

export class GetPolicesRequest2 implements IGetPolicesRequest2 {
    noIdentiteInterne?: number;
    numeroContrat?: number;

    constructor(data?: IGetPolicesRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noIdentiteInterne = _data["noIdentiteInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetPolicesRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noIdentiteInterne"] = this.noIdentiteInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetPolicesRequest2 {
    noIdentiteInterne?: number;
    numeroContrat?: number;
}

export class GetPolicesResponse2 implements IGetPolicesResponse2 {
    police?: Police3[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IGetPolicesResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["police"])) {
                this.police = [] as any;
                for (let item of _data["police"])
                    this.police!.push(Police3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPolicesResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.police)) {
            data["police"] = [];
            for (let item of this.police)
                data["police"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPolicesResponse2 {
    police?: Police3[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class GetRepartitionContratMultisupportRequest implements IGetRepartitionContratMultisupportRequest {
    numeroContrat?: number;

    constructor(data?: IGetRepartitionContratMultisupportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetRepartitionContratMultisupportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepartitionContratMultisupportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetRepartitionContratMultisupportRequest {
    numeroContrat?: number;
}

export class GetRepartitionContratMultisupportResponse implements IGetRepartitionContratMultisupportResponse {
    support?: Support2[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IGetRepartitionContratMultisupportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["support"])) {
                this.support = [] as any;
                for (let item of _data["support"])
                    this.support!.push(Support2.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRepartitionContratMultisupportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepartitionContratMultisupportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.support)) {
            data["support"] = [];
            for (let item of this.support)
                data["support"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRepartitionContratMultisupportResponse {
    support?: Support2[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class GetSupportsContratRequest implements IGetSupportsContratRequest {
    numeroContrat?: number;

    constructor(data?: IGetSupportsContratRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetSupportsContratRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportsContratRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetSupportsContratRequest {
    numeroContrat?: number;
}

export class GetSupportsContratResponse implements IGetSupportsContratResponse {
    supportContrat?: SupportContrat[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IGetSupportsContratResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supportContrat"])) {
                this.supportContrat = [] as any;
                for (let item of _data["supportContrat"])
                    this.supportContrat!.push(SupportContrat.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSupportsContratResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportsContratResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supportContrat)) {
            data["supportContrat"] = [];
            for (let item of this.supportContrat)
                data["supportContrat"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSupportsContratResponse {
    supportContrat?: SupportContrat[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class Parrain implements IParrain {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IParrain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Parrain {
        data = typeof data === 'object' ? data : {};
        let result = new Parrain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IParrain {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Payeur implements IPayeur {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IPayeur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Payeur {
        data = typeof data === 'object' ? data : {};
        let result = new Payeur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IPayeur {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Police3 implements IPolice3 {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    numeroContrat?: number | undefined;
    codeProduit?: string | undefined;
    typeContrat?: string | undefined;
    affichable?: string | undefined;
    consultable?: string | undefined;
    codeTypeVersement?: string | undefined;
    typeVersement?: string | undefined;
    solde01?: number | undefined;
    soldeEnCours?: number | undefined;
    cotisation?: number | undefined;
    augmCotis1?: number | undefined;
    augmCotis2?: number | undefined;
    augmCotis3?: number | undefined;
    coefRevalorisation?: number | undefined;
    dateOuverture?: Date | undefined;
    dateEffet?: Date | undefined;
    flagFourgous?: string | undefined;
    dateDernierVersementLibre?: Date | undefined;
    libelleEtat?: string | undefined;
    alimentation?: string | undefined;
    capital?: number | undefined;
    libelleAdq?: string | undefined;
    capitalAdq?: number | undefined;
    cotisationAdq?: number | undefined;
    dateFermeture?: Date | undefined;
    dateCloture?: Date | undefined;
    montantVersIni?: number | undefined;
    montantVersCumul?: number | undefined;
    montantVersCumul98?: number | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    montantValeurReduction?: number | undefined;
    bareme57ans?: number | undefined;
    montantCapitalDeces?: number | undefined;
    montantCapitalOption?: string | undefined;
    dateSouscription?: Date | undefined;
    cptrDateJouissance?: Date | undefined;
    cptrAgeLiquidation?: number | undefined;
    cptrOption?: string | undefined;
    cptrPartRenteAcquise?: number | undefined;
    dateAvenantMPRM?: Date | undefined;
    dateAvenantMMRV?: Date | undefined;
    versementMini?: number | undefined;
    montantAvenantMiniMPRM?: number | undefined;
    montantAvenantMaxiMPRM?: number | undefined;
    attenteMPRM?: number | undefined;
    dateEffetCtFuture?: Date | undefined;
    montantCtFuture?: number | undefined;
    duree?: string | undefined;
    libPromotion?: string | undefined;
    horizonPlacement?: number | undefined;
    idModeGestion?: number | undefined;
    typeGestion?: string | undefined;
    idMandatGestion?: number | undefined;
    libelleMandatGestion?: string | undefined;
    dateDernierArbitrage?: Date | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    cumulVersements?: number | undefined;
    cumulRachats?: number | undefined;
    dateEcheance?: Date | undefined;
    blocNote?: string | undefined;
    souscripteur?: Souscripteur;
    assure1?: Assure1;
    assure2?: Assure2;
    payeur?: Payeur;
    parrain?: Parrain;
    apporteur?: Apporteur;
    beneficiaire?: Beneficiaire;

    constructor(data?: IPolice3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
            this.numeroContrat = _data["numeroContrat"];
            this.codeProduit = _data["codeProduit"];
            this.typeContrat = _data["typeContrat"];
            this.affichable = _data["affichable"];
            this.consultable = _data["consultable"];
            this.codeTypeVersement = _data["codeTypeVersement"];
            this.typeVersement = _data["typeVersement"];
            this.solde01 = _data["solde01"];
            this.soldeEnCours = _data["soldeEnCours"];
            this.cotisation = _data["cotisation"];
            this.augmCotis1 = _data["augmCotis1"];
            this.augmCotis2 = _data["augmCotis2"];
            this.augmCotis3 = _data["augmCotis3"];
            this.coefRevalorisation = _data["coefRevalorisation"];
            this.dateOuverture = _data["dateOuverture"] ? new Date(_data["dateOuverture"].toString()) : undefined as any;
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : undefined as any;
            this.flagFourgous = _data["flagFourgous"];
            this.dateDernierVersementLibre = _data["dateDernierVersementLibre"] ? new Date(_data["dateDernierVersementLibre"].toString()) : undefined as any;
            this.libelleEtat = _data["libelleEtat"];
            this.alimentation = _data["alimentation"];
            this.capital = _data["capital"];
            this.libelleAdq = _data["libelleAdq"];
            this.capitalAdq = _data["capitalAdq"];
            this.cotisationAdq = _data["cotisationAdq"];
            this.dateFermeture = _data["dateFermeture"] ? new Date(_data["dateFermeture"].toString()) : undefined as any;
            this.dateCloture = _data["dateCloture"] ? new Date(_data["dateCloture"].toString()) : undefined as any;
            this.montantVersIni = _data["montantVersIni"];
            this.montantVersCumul = _data["montantVersCumul"];
            this.montantVersCumul98 = _data["montantVersCumul98"];
            this.montantValeurRT = _data["montantValeurRT"];
            this.montantValeurRP = _data["montantValeurRP"];
            this.montantValeurReduction = _data["montantValeurReduction"];
            this.bareme57ans = _data["bareme57ans"];
            this.montantCapitalDeces = _data["montantCapitalDeces"];
            this.montantCapitalOption = _data["montantCapitalOption"];
            this.dateSouscription = _data["dateSouscription"] ? new Date(_data["dateSouscription"].toString()) : undefined as any;
            this.cptrDateJouissance = _data["cptrDateJouissance"] ? new Date(_data["cptrDateJouissance"].toString()) : undefined as any;
            this.cptrAgeLiquidation = _data["cptrAgeLiquidation"];
            this.cptrOption = _data["cptrOption"];
            this.cptrPartRenteAcquise = _data["cptrPartRenteAcquise"];
            this.dateAvenantMPRM = _data["dateAvenantMPRM"] ? new Date(_data["dateAvenantMPRM"].toString()) : undefined as any;
            this.dateAvenantMMRV = _data["dateAvenantMMRV"] ? new Date(_data["dateAvenantMMRV"].toString()) : undefined as any;
            this.versementMini = _data["versementMini"];
            this.montantAvenantMiniMPRM = _data["montantAvenantMiniMPRM"];
            this.montantAvenantMaxiMPRM = _data["montantAvenantMaxiMPRM"];
            this.attenteMPRM = _data["attenteMPRM"];
            this.dateEffetCtFuture = _data["dateEffetCtFuture"] ? new Date(_data["dateEffetCtFuture"].toString()) : undefined as any;
            this.montantCtFuture = _data["montantCtFuture"];
            this.duree = _data["duree"];
            this.libPromotion = _data["libPromotion"];
            this.horizonPlacement = _data["horizonPlacement"];
            this.idModeGestion = _data["idModeGestion"];
            this.typeGestion = _data["typeGestion"];
            this.idMandatGestion = _data["idMandatGestion"];
            this.libelleMandatGestion = _data["libelleMandatGestion"];
            this.dateDernierArbitrage = _data["dateDernierArbitrage"] ? new Date(_data["dateDernierArbitrage"].toString()) : undefined as any;
            this.plusMoinsValueValeur = _data["plusMoinsValueValeur"];
            this.plusMoinsValuePourcentage = _data["plusMoinsValuePourcentage"];
            this.cumulVersements = _data["cumulVersements"];
            this.cumulRachats = _data["cumulRachats"];
            this.dateEcheance = _data["dateEcheance"] ? new Date(_data["dateEcheance"].toString()) : undefined as any;
            this.blocNote = _data["blocNote"];
            this.souscripteur = _data["souscripteur"] ? Souscripteur.fromJS(_data["souscripteur"]) : undefined as any;
            this.assure1 = _data["assure1"] ? Assure1.fromJS(_data["assure1"]) : undefined as any;
            this.assure2 = _data["assure2"] ? Assure2.fromJS(_data["assure2"]) : undefined as any;
            this.payeur = _data["payeur"] ? Payeur.fromJS(_data["payeur"]) : undefined as any;
            this.parrain = _data["parrain"] ? Parrain.fromJS(_data["parrain"]) : undefined as any;
            this.apporteur = _data["apporteur"] ? Apporteur.fromJS(_data["apporteur"]) : undefined as any;
            this.beneficiaire = _data["beneficiaire"] ? Beneficiaire.fromJS(_data["beneficiaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): Police3 {
        data = typeof data === 'object' ? data : {};
        let result = new Police3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        data["numeroContrat"] = this.numeroContrat;
        data["codeProduit"] = this.codeProduit;
        data["typeContrat"] = this.typeContrat;
        data["affichable"] = this.affichable;
        data["consultable"] = this.consultable;
        data["codeTypeVersement"] = this.codeTypeVersement;
        data["typeVersement"] = this.typeVersement;
        data["solde01"] = this.solde01;
        data["soldeEnCours"] = this.soldeEnCours;
        data["cotisation"] = this.cotisation;
        data["augmCotis1"] = this.augmCotis1;
        data["augmCotis2"] = this.augmCotis2;
        data["augmCotis3"] = this.augmCotis3;
        data["coefRevalorisation"] = this.coefRevalorisation;
        data["dateOuverture"] = this.dateOuverture ? this.dateOuverture.toISOString() : undefined as any;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : undefined as any;
        data["flagFourgous"] = this.flagFourgous;
        data["dateDernierVersementLibre"] = this.dateDernierVersementLibre ? this.dateDernierVersementLibre.toISOString() : undefined as any;
        data["libelleEtat"] = this.libelleEtat;
        data["alimentation"] = this.alimentation;
        data["capital"] = this.capital;
        data["libelleAdq"] = this.libelleAdq;
        data["capitalAdq"] = this.capitalAdq;
        data["cotisationAdq"] = this.cotisationAdq;
        data["dateFermeture"] = this.dateFermeture ? this.dateFermeture.toISOString() : undefined as any;
        data["dateCloture"] = this.dateCloture ? this.dateCloture.toISOString() : undefined as any;
        data["montantVersIni"] = this.montantVersIni;
        data["montantVersCumul"] = this.montantVersCumul;
        data["montantVersCumul98"] = this.montantVersCumul98;
        data["montantValeurRT"] = this.montantValeurRT;
        data["montantValeurRP"] = this.montantValeurRP;
        data["montantValeurReduction"] = this.montantValeurReduction;
        data["bareme57ans"] = this.bareme57ans;
        data["montantCapitalDeces"] = this.montantCapitalDeces;
        data["montantCapitalOption"] = this.montantCapitalOption;
        data["dateSouscription"] = this.dateSouscription ? this.dateSouscription.toISOString() : undefined as any;
        data["cptrDateJouissance"] = this.cptrDateJouissance ? this.cptrDateJouissance.toISOString() : undefined as any;
        data["cptrAgeLiquidation"] = this.cptrAgeLiquidation;
        data["cptrOption"] = this.cptrOption;
        data["cptrPartRenteAcquise"] = this.cptrPartRenteAcquise;
        data["dateAvenantMPRM"] = this.dateAvenantMPRM ? this.dateAvenantMPRM.toISOString() : undefined as any;
        data["dateAvenantMMRV"] = this.dateAvenantMMRV ? this.dateAvenantMMRV.toISOString() : undefined as any;
        data["versementMini"] = this.versementMini;
        data["montantAvenantMiniMPRM"] = this.montantAvenantMiniMPRM;
        data["montantAvenantMaxiMPRM"] = this.montantAvenantMaxiMPRM;
        data["attenteMPRM"] = this.attenteMPRM;
        data["dateEffetCtFuture"] = this.dateEffetCtFuture ? this.dateEffetCtFuture.toISOString() : undefined as any;
        data["montantCtFuture"] = this.montantCtFuture;
        data["duree"] = this.duree;
        data["libPromotion"] = this.libPromotion;
        data["horizonPlacement"] = this.horizonPlacement;
        data["idModeGestion"] = this.idModeGestion;
        data["typeGestion"] = this.typeGestion;
        data["idMandatGestion"] = this.idMandatGestion;
        data["libelleMandatGestion"] = this.libelleMandatGestion;
        data["dateDernierArbitrage"] = this.dateDernierArbitrage ? this.dateDernierArbitrage.toISOString() : undefined as any;
        data["plusMoinsValueValeur"] = this.plusMoinsValueValeur;
        data["plusMoinsValuePourcentage"] = this.plusMoinsValuePourcentage;
        data["cumulVersements"] = this.cumulVersements;
        data["cumulRachats"] = this.cumulRachats;
        data["dateEcheance"] = this.dateEcheance ? this.dateEcheance.toISOString() : undefined as any;
        data["blocNote"] = this.blocNote;
        data["souscripteur"] = this.souscripteur ? this.souscripteur.toJSON() : undefined as any;
        data["assure1"] = this.assure1 ? this.assure1.toJSON() : undefined as any;
        data["assure2"] = this.assure2 ? this.assure2.toJSON() : undefined as any;
        data["payeur"] = this.payeur ? this.payeur.toJSON() : undefined as any;
        data["parrain"] = this.parrain ? this.parrain.toJSON() : undefined as any;
        data["apporteur"] = this.apporteur ? this.apporteur.toJSON() : undefined as any;
        data["beneficiaire"] = this.beneficiaire ? this.beneficiaire.toJSON() : undefined as any;
        return data;
    }
}

export interface IPolice3 {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    numeroContrat?: number | undefined;
    codeProduit?: string | undefined;
    typeContrat?: string | undefined;
    affichable?: string | undefined;
    consultable?: string | undefined;
    codeTypeVersement?: string | undefined;
    typeVersement?: string | undefined;
    solde01?: number | undefined;
    soldeEnCours?: number | undefined;
    cotisation?: number | undefined;
    augmCotis1?: number | undefined;
    augmCotis2?: number | undefined;
    augmCotis3?: number | undefined;
    coefRevalorisation?: number | undefined;
    dateOuverture?: Date | undefined;
    dateEffet?: Date | undefined;
    flagFourgous?: string | undefined;
    dateDernierVersementLibre?: Date | undefined;
    libelleEtat?: string | undefined;
    alimentation?: string | undefined;
    capital?: number | undefined;
    libelleAdq?: string | undefined;
    capitalAdq?: number | undefined;
    cotisationAdq?: number | undefined;
    dateFermeture?: Date | undefined;
    dateCloture?: Date | undefined;
    montantVersIni?: number | undefined;
    montantVersCumul?: number | undefined;
    montantVersCumul98?: number | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    montantValeurReduction?: number | undefined;
    bareme57ans?: number | undefined;
    montantCapitalDeces?: number | undefined;
    montantCapitalOption?: string | undefined;
    dateSouscription?: Date | undefined;
    cptrDateJouissance?: Date | undefined;
    cptrAgeLiquidation?: number | undefined;
    cptrOption?: string | undefined;
    cptrPartRenteAcquise?: number | undefined;
    dateAvenantMPRM?: Date | undefined;
    dateAvenantMMRV?: Date | undefined;
    versementMini?: number | undefined;
    montantAvenantMiniMPRM?: number | undefined;
    montantAvenantMaxiMPRM?: number | undefined;
    attenteMPRM?: number | undefined;
    dateEffetCtFuture?: Date | undefined;
    montantCtFuture?: number | undefined;
    duree?: string | undefined;
    libPromotion?: string | undefined;
    horizonPlacement?: number | undefined;
    idModeGestion?: number | undefined;
    typeGestion?: string | undefined;
    idMandatGestion?: number | undefined;
    libelleMandatGestion?: string | undefined;
    dateDernierArbitrage?: Date | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    cumulVersements?: number | undefined;
    cumulRachats?: number | undefined;
    dateEcheance?: Date | undefined;
    blocNote?: string | undefined;
    souscripteur?: Souscripteur;
    assure1?: Assure1;
    assure2?: Assure2;
    payeur?: Payeur;
    parrain?: Parrain;
    apporteur?: Apporteur;
    beneficiaire?: Beneficiaire;
}

export class RechercheAvenantNantissementRequest implements IRechercheAvenantNantissementRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;

    constructor(data?: IRechercheAvenantNantissementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): RechercheAvenantNantissementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAvenantNantissementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IRechercheAvenantNantissementRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
}

export class RechercheAvenantNantissementResponse implements IRechercheAvenantNantissementResponse {
    codeRetour?: number | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheAvenantNantissementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheAvenantNantissementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAvenantNantissementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheAvenantNantissementResponse {
    codeRetour?: number | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheRachatRequest implements IRechercheRachatRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
    dateReceptionRachat?: Date | undefined;
    nbMoisSuccessif?: number | undefined;
    nbRachat?: number | undefined;
    nbMoisLimite?: number | undefined;

    constructor(data?: IRechercheRachatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noContrat = _data["noContrat"];
            this.dateReceptionRachat = _data["dateReceptionRachat"] ? new Date(_data["dateReceptionRachat"].toString()) : undefined as any;
            this.nbMoisSuccessif = _data["nbMoisSuccessif"];
            this.nbRachat = _data["nbRachat"];
            this.nbMoisLimite = _data["nbMoisLimite"];
        }
    }

    static fromJS(data: any): RechercheRachatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRachatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noContrat"] = this.noContrat;
        data["dateReceptionRachat"] = this.dateReceptionRachat ? this.dateReceptionRachat.toISOString() : undefined as any;
        data["nbMoisSuccessif"] = this.nbMoisSuccessif;
        data["nbRachat"] = this.nbRachat;
        data["nbMoisLimite"] = this.nbMoisLimite;
        return data;
    }
}

export interface IRechercheRachatRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
    dateReceptionRachat?: Date | undefined;
    nbMoisSuccessif?: number | undefined;
    nbRachat?: number | undefined;
    nbMoisLimite?: number | undefined;
}

export class RechercheRachatResponse implements IRechercheRachatResponse {
    retours?: Retour[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheRachatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["retours"])) {
                this.retours = [] as any;
                for (let item of _data["retours"])
                    this.retours!.push(Retour.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheRachatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRachatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.retours)) {
            data["retours"] = [];
            for (let item of this.retours)
                data["retours"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRechercheRachatResponse {
    retours?: Retour[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class Retour implements IRetour {
    codeRetour?: number | undefined;
    libelleRetour?: string | undefined;

    constructor(data?: IRetour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.libelleRetour = _data["libelleRetour"];
        }
    }

    static fromJS(data: any): Retour {
        data = typeof data === 'object' ? data : {};
        let result = new Retour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["libelleRetour"] = this.libelleRetour;
        return data;
    }
}

export interface IRetour {
    codeRetour?: number | undefined;
    libelleRetour?: string | undefined;
}

export class Souscripteur implements ISouscripteur {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: ISouscripteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Souscripteur {
        data = typeof data === 'object' ? data : {};
        let result = new Souscripteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface ISouscripteur {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Support2 implements ISupport2 {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    repartition?: number | undefined;

    constructor(data?: ISupport2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeISIN = _data["codeISIN"];
            this.libelle = _data["libelle"];
            this.repartition = _data["repartition"];
        }
    }

    static fromJS(data: any): Support2 {
        data = typeof data === 'object' ? data : {};
        let result = new Support2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeISIN"] = this.codeISIN;
        data["libelle"] = this.libelle;
        data["repartition"] = this.repartition;
        return data;
    }
}

export interface ISupport2 {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    repartition?: number | undefined;
}

export class SupportContrat implements ISupportContrat {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    montant?: number | undefined;
    montantInvesti?: number | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    valeurLiquidative?: number | undefined;
    dateMAJ?: Date | undefined;
    nombreParts?: number | undefined;
    repartition?: number | undefined;
    idSupport?: string | undefined;

    constructor(data?: ISupportContrat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeISIN = _data["codeISIN"];
            this.libelle = _data["libelle"];
            this.montant = _data["montant"];
            this.montantInvesti = _data["montantInvesti"];
            this.plusMoinsValueValeur = _data["plusMoinsValueValeur"];
            this.plusMoinsValuePourcentage = _data["plusMoinsValuePourcentage"];
            this.valeurLiquidative = _data["valeurLiquidative"];
            this.dateMAJ = _data["dateMAJ"] ? new Date(_data["dateMAJ"].toString()) : undefined as any;
            this.nombreParts = _data["nombreParts"];
            this.repartition = _data["repartition"];
            this.idSupport = _data["idSupport"];
        }
    }

    static fromJS(data: any): SupportContrat {
        data = typeof data === 'object' ? data : {};
        let result = new SupportContrat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeISIN"] = this.codeISIN;
        data["libelle"] = this.libelle;
        data["montant"] = this.montant;
        data["montantInvesti"] = this.montantInvesti;
        data["plusMoinsValueValeur"] = this.plusMoinsValueValeur;
        data["plusMoinsValuePourcentage"] = this.plusMoinsValuePourcentage;
        data["valeurLiquidative"] = this.valeurLiquidative;
        data["dateMAJ"] = this.dateMAJ ? this.dateMAJ.toISOString() : undefined as any;
        data["nombreParts"] = this.nombreParts;
        data["repartition"] = this.repartition;
        data["idSupport"] = this.idSupport;
        return data;
    }
}

export interface ISupportContrat {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    montant?: number | undefined;
    montantInvesti?: number | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    valeurLiquidative?: number | undefined;
    dateMAJ?: Date | undefined;
    nombreParts?: number | undefined;
    repartition?: number | undefined;
    idSupport?: string | undefined;
}

export class Warning4 implements IWarning4 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning4 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning4 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class Cotisation implements ICotisation {
    age?: number;
    mntCotisation?: number | undefined;

    constructor(data?: ICotisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.mntCotisation = _data["mntCotisation"];
        }
    }

    static fromJS(data: any): Cotisation {
        data = typeof data === 'object' ? data : {};
        let result = new Cotisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["mntCotisation"] = this.mntCotisation;
        return data;
    }
}

export interface ICotisation {
    age?: number;
    mntCotisation?: number | undefined;
}

export class Erreur7 implements IErreur7 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur7 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur7 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetTarifsPrevoyanceGFDRequest implements IGetTarifsPrevoyanceGFDRequest {
    prevoyanceGFD?: PrevoyanceGFD;

    constructor(data?: IGetTarifsPrevoyanceGFDRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prevoyanceGFD = _data["prevoyanceGFD"] ? PrevoyanceGFD.fromJS(_data["prevoyanceGFD"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGFDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGFDRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prevoyanceGFD"] = this.prevoyanceGFD ? this.prevoyanceGFD.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTarifsPrevoyanceGFDRequest {
    prevoyanceGFD?: PrevoyanceGFD;
}

export class GetTarifsPrevoyanceGFDResponse implements IGetTarifsPrevoyanceGFDResponse {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation[] | undefined;
    erreurs?: Erreur7[] | undefined;
    warnings?: Warning5[] | undefined;

    constructor(data?: IGetTarifsPrevoyanceGFDResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.periodicitePaiement = _data["periodicitePaiement"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
            if (Array.isArray(_data["cotisation"])) {
                this.cotisation = [] as any;
                for (let item of _data["cotisation"])
                    this.cotisation!.push(Cotisation.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGFDResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGFDResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["periodicitePaiement"] = this.periodicitePaiement;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        if (Array.isArray(this.cotisation)) {
            data["cotisation"] = [];
            for (let item of this.cotisation)
                data["cotisation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTarifsPrevoyanceGFDResponse {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation[] | undefined;
    erreurs?: Erreur7[] | undefined;
    warnings?: Warning5[] | undefined;
}

export class PrevoyanceGFD implements IPrevoyanceGFD {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;

    constructor(data?: IPrevoyanceGFD) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.periodicitePaiement = _data["periodicitePaiement"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
        }
    }

    static fromJS(data: any): PrevoyanceGFD {
        data = typeof data === 'object' ? data : {};
        let result = new PrevoyanceGFD();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["periodicitePaiement"] = this.periodicitePaiement;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        return data;
    }
}

export interface IPrevoyanceGFD {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
}

export class Warning5 implements IWarning5 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning5 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning5 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class Cotisation2 implements ICotisation2 {
    age?: number;
    mntCotisation?: number | undefined;

    constructor(data?: ICotisation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.mntCotisation = _data["mntCotisation"];
        }
    }

    static fromJS(data: any): Cotisation2 {
        data = typeof data === 'object' ? data : {};
        let result = new Cotisation2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["mntCotisation"] = this.mntCotisation;
        return data;
    }
}

export interface ICotisation2 {
    age?: number;
    mntCotisation?: number | undefined;
}

export class Erreur8 implements IErreur8 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur8 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur8 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetTarifsPrevoyanceGPARequest implements IGetTarifsPrevoyanceGPARequest {
    prevoyanceGPA?: PrevoyanceGPA;

    constructor(data?: IGetTarifsPrevoyanceGPARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prevoyanceGPA = _data["prevoyanceGPA"] ? PrevoyanceGPA.fromJS(_data["prevoyanceGPA"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGPARequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGPARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prevoyanceGPA"] = this.prevoyanceGPA ? this.prevoyanceGPA.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTarifsPrevoyanceGPARequest {
    prevoyanceGPA?: PrevoyanceGPA;
}

export class GetTarifsPrevoyanceGPAResponse implements IGetTarifsPrevoyanceGPAResponse {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation2[] | undefined;
    erreurs?: Erreur8[] | undefined;
    warnings?: Warning6[] | undefined;

    constructor(data?: IGetTarifsPrevoyanceGPAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.option = _data["option"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
            if (Array.isArray(_data["cotisation"])) {
                this.cotisation = [] as any;
                for (let item of _data["cotisation"])
                    this.cotisation!.push(Cotisation2.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur8.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGPAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGPAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["option"] = this.option;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        if (Array.isArray(this.cotisation)) {
            data["cotisation"] = [];
            for (let item of this.cotisation)
                data["cotisation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTarifsPrevoyanceGPAResponse {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation2[] | undefined;
    erreurs?: Erreur8[] | undefined;
    warnings?: Warning6[] | undefined;
}

export class PrevoyanceGPA implements IPrevoyanceGPA {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;

    constructor(data?: IPrevoyanceGPA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.option = _data["option"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
        }
    }

    static fromJS(data: any): PrevoyanceGPA {
        data = typeof data === 'object' ? data : {};
        let result = new PrevoyanceGPA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["option"] = this.option;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        return data;
    }
}

export interface IPrevoyanceGPA {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
}

export class Warning6 implements IWarning6 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning6 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning6 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class ClasseActifs implements IClasseActifs {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: IClasseActifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): ClasseActifs {
        data = typeof data === 'object' ? data : {};
        let result = new ClasseActifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IClasseActifs {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class Document implements IDocument {
    id?: string | undefined;
    libelle?: string | undefined;
    produits?: Produit2[] | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            if (Array.isArray(_data["produits"])) {
                this.produits = [] as any;
                for (let item of _data["produits"])
                    this.produits!.push(Produit2.fromJS(item));
            }
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : undefined as any;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        if (Array.isArray(this.produits)) {
            data["produits"] = [];
            for (let item of this.produits)
                data["produits"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument {
    id?: string | undefined;
    libelle?: string | undefined;
    produits?: Produit2[] | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class Document2 implements IDocument2 {
    id?: number | undefined;
    libelle?: string | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
    statut?: boolean | undefined;
    dateMaj?: number | undefined;
    codeEditique?: string | undefined;
    suffixeLibelle?: string | undefined;
    articleLibelle?: string | undefined;
    autreLibelle?: string | undefined;

    constructor(data?: IDocument2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : undefined as any;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
            this.statut = _data["statut"];
            this.dateMaj = _data["dateMaj"];
            this.codeEditique = _data["codeEditique"];
            this.suffixeLibelle = _data["suffixeLibelle"];
            this.articleLibelle = _data["articleLibelle"];
            this.autreLibelle = _data["autreLibelle"];
        }
    }

    static fromJS(data: any): Document2 {
        data = typeof data === 'object' ? data : {};
        let result = new Document2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        data["statut"] = this.statut;
        data["dateMaj"] = this.dateMaj;
        data["codeEditique"] = this.codeEditique;
        data["suffixeLibelle"] = this.suffixeLibelle;
        data["articleLibelle"] = this.articleLibelle;
        data["autreLibelle"] = this.autreLibelle;
        return data;
    }
}

export interface IDocument2 {
    id?: number | undefined;
    libelle?: string | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
    statut?: boolean | undefined;
    dateMaj?: number | undefined;
    codeEditique?: string | undefined;
    suffixeLibelle?: string | undefined;
    articleLibelle?: string | undefined;
    autreLibelle?: string | undefined;
}

export class Document3 implements IDocument3 {
    id?: string | undefined;
    libelle?: string | undefined;
    libelleArticle?: string | undefined;
    libelleSuffixe?: string | undefined;
    ordre?: number | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.libelleArticle = _data["libelleArticle"];
            this.libelleSuffixe = _data["libelleSuffixe"];
            this.ordre = _data["ordre"];
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : undefined as any;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document3 {
        data = typeof data === 'object' ? data : {};
        let result = new Document3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["libelleArticle"] = this.libelleArticle;
        data["libelleSuffixe"] = this.libelleSuffixe;
        data["ordre"] = this.ordre;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument3 {
    id?: string | undefined;
    libelle?: string | undefined;
    libelleArticle?: string | undefined;
    libelleSuffixe?: string | undefined;
    ordre?: number | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class Document4 implements IDocument4 {
    id?: string | undefined;
    libelle?: string | undefined;
    type?: Type;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? Type.fromJS(_data["type"]) : undefined as any;
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document4 {
        data = typeof data === 'object' ? data : {};
        let result = new Document4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument4 {
    id?: string | undefined;
    libelle?: string | undefined;
    type?: Type;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class DocumentsProduitSignatureSouscriptionEnLigneRequest implements IDocumentsProduitSignatureSouscriptionEnLigneRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean | undefined;
    fonds?: (number | undefined)[] | undefined;

    constructor(data?: IDocumentsProduitSignatureSouscriptionEnLigneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentsProduitSignatureSouscriptionEnLigneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsProduitSignatureSouscriptionEnLigneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item);
        }
        return data;
    }
}

export interface IDocumentsProduitSignatureSouscriptionEnLigneRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean | undefined;
    fonds?: (number | undefined)[] | undefined;
}

export class DocumentsProduitSignatureSouscriptionEnLigneResponse implements IDocumentsProduitSignatureSouscriptionEnLigneResponse {
    document?: Document3[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IDocumentsProduitSignatureSouscriptionEnLigneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentsProduitSignatureSouscriptionEnLigneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsProduitSignatureSouscriptionEnLigneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDocumentsProduitSignatureSouscriptionEnLigneResponse {
    document?: Document3[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class EntetePDF implements IEntetePDF {
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;

    constructor(data?: IEntetePDF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
        }
    }

    static fromJS(data: any): EntetePDF {
        data = typeof data === 'object' ? data : {};
        let result = new EntetePDF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        return data;
    }
}

export interface IEntetePDF {
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
}

export class Erreur9 implements IErreur9 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur9 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur9 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class Fonds implements IFonds {
    id?: number | undefined;
    libelle?: string | undefined;
    nomCommercial?: string | undefined;
    typeFonds?: TypeFonds;
    codeISIN?: string | undefined;
    niveauRisque?: number | undefined;
    codeGarantie?: string | undefined;
    ordre?: number | undefined;
    devise?: string | undefined;
    risqueChange?: string | undefined;
    fraisGestionMax?: number | undefined;
    signatairePRI?: string | undefined;
    classificationInvestissementResponsable?: string | undefined;
    estCommercialise?: boolean | undefined;
    estAffiche?: boolean | undefined;
    debutDateCommercialisation?: Date | undefined;
    finDateCommercialisation?: Date | undefined;
    typeRegle?: TypeRegle[] | undefined;
    document?: Document[] | undefined;
    classeActifs?: ClasseActifs;
    classeActifs2?: ClasseActifs;
    classeActifs3?: ClasseActifs;
    classeActifs4?: ClasseActifs;
    performance?: Performance[] | undefined;
    zoneGeographique?: ZoneGeographique[] | undefined;
    gestionnaire?: Gestionnaire;

    constructor(data?: IFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.nomCommercial = _data["nomCommercial"];
            this.typeFonds = _data["typeFonds"] ? TypeFonds.fromJS(_data["typeFonds"]) : undefined as any;
            this.codeISIN = _data["codeISIN"];
            this.niveauRisque = _data["niveauRisque"];
            this.codeGarantie = _data["codeGarantie"];
            this.ordre = _data["ordre"];
            this.devise = _data["devise"];
            this.risqueChange = _data["risqueChange"];
            this.fraisGestionMax = _data["fraisGestionMax"];
            this.signatairePRI = _data["signatairePRI"];
            this.classificationInvestissementResponsable = _data["classificationInvestissementResponsable"];
            this.estCommercialise = _data["estCommercialise"];
            this.estAffiche = _data["estAffiche"];
            this.debutDateCommercialisation = _data["debutDateCommercialisation"] ? new Date(_data["debutDateCommercialisation"].toString()) : undefined as any;
            this.finDateCommercialisation = _data["finDateCommercialisation"] ? new Date(_data["finDateCommercialisation"].toString()) : undefined as any;
            if (Array.isArray(_data["typeRegle"])) {
                this.typeRegle = [] as any;
                for (let item of _data["typeRegle"])
                    this.typeRegle!.push(TypeRegle.fromJS(item));
            }
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            this.classeActifs = _data["classeActifs"] ? ClasseActifs.fromJS(_data["classeActifs"]) : undefined as any;
            this.classeActifs2 = _data["classeActifs2"] ? ClasseActifs.fromJS(_data["classeActifs2"]) : undefined as any;
            this.classeActifs3 = _data["classeActifs3"] ? ClasseActifs.fromJS(_data["classeActifs3"]) : undefined as any;
            this.classeActifs4 = _data["classeActifs4"] ? ClasseActifs.fromJS(_data["classeActifs4"]) : undefined as any;
            if (Array.isArray(_data["performance"])) {
                this.performance = [] as any;
                for (let item of _data["performance"])
                    this.performance!.push(Performance.fromJS(item));
            }
            if (Array.isArray(_data["zoneGeographique"])) {
                this.zoneGeographique = [] as any;
                for (let item of _data["zoneGeographique"])
                    this.zoneGeographique!.push(ZoneGeographique.fromJS(item));
            }
            this.gestionnaire = _data["gestionnaire"] ? Gestionnaire.fromJS(_data["gestionnaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): Fonds {
        data = typeof data === 'object' ? data : {};
        let result = new Fonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["nomCommercial"] = this.nomCommercial;
        data["typeFonds"] = this.typeFonds ? this.typeFonds.toJSON() : undefined as any;
        data["codeISIN"] = this.codeISIN;
        data["niveauRisque"] = this.niveauRisque;
        data["codeGarantie"] = this.codeGarantie;
        data["ordre"] = this.ordre;
        data["devise"] = this.devise;
        data["risqueChange"] = this.risqueChange;
        data["fraisGestionMax"] = this.fraisGestionMax;
        data["signatairePRI"] = this.signatairePRI;
        data["classificationInvestissementResponsable"] = this.classificationInvestissementResponsable;
        data["estCommercialise"] = this.estCommercialise;
        data["estAffiche"] = this.estAffiche;
        data["debutDateCommercialisation"] = this.debutDateCommercialisation ? this.debutDateCommercialisation.toISOString() : undefined as any;
        data["finDateCommercialisation"] = this.finDateCommercialisation ? this.finDateCommercialisation.toISOString() : undefined as any;
        if (Array.isArray(this.typeRegle)) {
            data["typeRegle"] = [];
            for (let item of this.typeRegle)
                data["typeRegle"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        data["classeActifs"] = this.classeActifs ? this.classeActifs.toJSON() : undefined as any;
        data["classeActifs2"] = this.classeActifs2 ? this.classeActifs2.toJSON() : undefined as any;
        data["classeActifs3"] = this.classeActifs3 ? this.classeActifs3.toJSON() : undefined as any;
        data["classeActifs4"] = this.classeActifs4 ? this.classeActifs4.toJSON() : undefined as any;
        if (Array.isArray(this.performance)) {
            data["performance"] = [];
            for (let item of this.performance)
                data["performance"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.zoneGeographique)) {
            data["zoneGeographique"] = [];
            for (let item of this.zoneGeographique)
                data["zoneGeographique"].push(item ? item.toJSON() : undefined as any);
        }
        data["gestionnaire"] = this.gestionnaire ? this.gestionnaire.toJSON() : undefined as any;
        return data;
    }
}

export interface IFonds {
    id?: number | undefined;
    libelle?: string | undefined;
    nomCommercial?: string | undefined;
    typeFonds?: TypeFonds;
    codeISIN?: string | undefined;
    niveauRisque?: number | undefined;
    codeGarantie?: string | undefined;
    ordre?: number | undefined;
    devise?: string | undefined;
    risqueChange?: string | undefined;
    fraisGestionMax?: number | undefined;
    signatairePRI?: string | undefined;
    classificationInvestissementResponsable?: string | undefined;
    estCommercialise?: boolean | undefined;
    estAffiche?: boolean | undefined;
    debutDateCommercialisation?: Date | undefined;
    finDateCommercialisation?: Date | undefined;
    typeRegle?: TypeRegle[] | undefined;
    document?: Document[] | undefined;
    classeActifs?: ClasseActifs;
    classeActifs2?: ClasseActifs;
    classeActifs3?: ClasseActifs;
    classeActifs4?: ClasseActifs;
    performance?: Performance[] | undefined;
    zoneGeographique?: ZoneGeographique[] | undefined;
    gestionnaire?: Gestionnaire;
}

export class FondsRepartition implements IFondsRepartition {
    fonds?: Fonds;
    repartition?: number | undefined;
    titre?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IFondsRepartition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fonds = _data["fonds"] ? Fonds.fromJS(_data["fonds"]) : undefined as any;
            this.repartition = _data["repartition"];
            this.titre = _data["titre"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): FondsRepartition {
        data = typeof data === 'object' ? data : {};
        let result = new FondsRepartition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fonds"] = this.fonds ? this.fonds.toJSON() : undefined as any;
        data["repartition"] = this.repartition;
        data["titre"] = this.titre;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IFondsRepartition {
    fonds?: Fonds;
    repartition?: number | undefined;
    titre?: string | undefined;
    libelle?: string | undefined;
}

export class Gestionnaire implements IGestionnaire {
    id?: number | undefined;
    libelle?: string | undefined;
    noteGestionnaireDonneeOFI?: number | undefined;
    noteISR?: number | undefined;

    constructor(data?: IGestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.noteGestionnaireDonneeOFI = _data["noteGestionnaireDonneeOFI"];
            this.noteISR = _data["noteISR"];
        }
    }

    static fromJS(data: any): Gestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Gestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["noteGestionnaireDonneeOFI"] = this.noteGestionnaireDonneeOFI;
        data["noteISR"] = this.noteISR;
        return data;
    }
}

export interface IGestionnaire {
    id?: number | undefined;
    libelle?: string | undefined;
    noteGestionnaireDonneeOFI?: number | undefined;
    noteISR?: number | undefined;
}

export class GetCodeCommuneRequest implements IGetCodeCommuneRequest {
    codeDepartement?: string | undefined;
    libelleCommune?: string | undefined;
    dateNaissance?: Date;

    constructor(data?: IGetCodeCommuneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeDepartement = _data["codeDepartement"];
            this.libelleCommune = _data["libelleCommune"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetCodeCommuneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeCommuneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeDepartement"] = this.codeDepartement;
        data["libelleCommune"] = this.libelleCommune;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetCodeCommuneRequest {
    codeDepartement?: string | undefined;
    libelleCommune?: string | undefined;
    dateNaissance?: Date;
}

export class GetCodeCommuneResponse implements IGetCodeCommuneResponse {
    codeCommune?: string | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetCodeCommuneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeCommune = _data["codeCommune"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCodeCommuneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeCommuneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeCommune"] = this.codeCommune;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCodeCommuneResponse {
    codeCommune?: string | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDocumentPackProduitRequest implements IGetDocumentPackProduitRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentPackProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentPackProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentPackProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentPackProduitRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentPackProduitResponse implements IGetDocumentPackProduitResponse {
    lienDocuments?: LienDocuments[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDocumentPackProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lienDocuments"])) {
                this.lienDocuments = [] as any;
                for (let item of _data["lienDocuments"])
                    this.lienDocuments!.push(LienDocuments.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentPackProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentPackProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lienDocuments)) {
            data["lienDocuments"] = [];
            for (let item of this.lienDocuments)
                data["lienDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDocumentPackProduitResponse {
    lienDocuments?: LienDocuments[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDocumentsFichierRequest implements IGetDocumentsFichierRequest {
    repertoireRefMetier?: string | undefined;
    cheminFichier?: string | undefined;
    idDocument?: number;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsFichierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repertoireRefMetier = _data["repertoireRefMetier"];
            this.cheminFichier = _data["cheminFichier"];
            this.idDocument = _data["idDocument"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsFichierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFichierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repertoireRefMetier"] = this.repertoireRefMetier;
        data["cheminFichier"] = this.cheminFichier;
        data["idDocument"] = this.idDocument;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsFichierRequest {
    repertoireRefMetier?: string | undefined;
    cheminFichier?: string | undefined;
    idDocument?: number;
    lireDocuments?: boolean;
}

export class GetDocumentsFichierResponse implements IGetDocumentsFichierResponse {
    document?: Document2[] | undefined;
    repertoireRefMetier?: string | undefined;
    repertoiresRefMetier?: string | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDocumentsFichierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document2.fromJS(item));
            }
            this.repertoireRefMetier = _data["repertoireRefMetier"];
            this.repertoiresRefMetier = _data["repertoiresRefMetier"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsFichierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFichierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        data["repertoireRefMetier"] = this.repertoireRefMetier;
        data["repertoiresRefMetier"] = this.repertoiresRefMetier;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDocumentsFichierResponse {
    document?: Document2[] | undefined;
    repertoireRefMetier?: string | undefined;
    repertoiresRefMetier?: string | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDocumentsFondsRequest implements IGetDocumentsFondsRequest {
    idTypeDocument?: number | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsFondsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.idFonds = _data["idFonds"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsFondsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFondsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["idFonds"] = this.idFonds;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsFondsRequest {
    idTypeDocument?: number | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentsFondsResponse implements IGetDocumentsFondsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDocumentsFondsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsFondsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFondsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDocumentsFondsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDocumentsProduitRequest implements IGetDocumentsProduitRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsProduitRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentsProduitResponse implements IGetDocumentsProduitResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDocumentsProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDocumentsProduitResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDonneesArbitrageRequest implements IGetDonneesArbitrageRequest {
    numeroContrat?: number | undefined;
    montantFondsEuroDesinvesti?: number;

    constructor(data?: IGetDonneesArbitrageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.montantFondsEuroDesinvesti = _data["montantFondsEuroDesinvesti"];
        }
    }

    static fromJS(data: any): GetDonneesArbitrageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesArbitrageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["montantFondsEuroDesinvesti"] = this.montantFondsEuroDesinvesti;
        return data;
    }
}

export interface IGetDonneesArbitrageRequest {
    numeroContrat?: number | undefined;
    montantFondsEuroDesinvesti?: number;
}

export class GetDonneesArbitrageResponse implements IGetDonneesArbitrageResponse {
    montantsSeuils?: MontantsSeuilsArbitrage;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDonneesArbitrageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsArbitrage.fromJS(_data["montantsSeuils"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesArbitrageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesArbitrageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDonneesArbitrageResponse {
    montantsSeuils?: MontantsSeuilsArbitrage;
    erreurs?: Erreur9[] | undefined;
}

export class GetDonneesRachatRequest implements IGetDonneesRachatRequest {
    numeroContrat?: number | undefined;
    montantRachat?: number;

    constructor(data?: IGetDonneesRachatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.montantRachat = _data["montantRachat"];
        }
    }

    static fromJS(data: any): GetDonneesRachatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesRachatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["montantRachat"] = this.montantRachat;
        return data;
    }
}

export interface IGetDonneesRachatRequest {
    numeroContrat?: number | undefined;
    montantRachat?: number;
}

export class GetDonneesRachatResponse implements IGetDonneesRachatResponse {
    montantsSeuils?: MontantsSeuilsRachat;
    motif?: MotifRachat[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDonneesRachatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsRachat.fromJS(_data["montantsSeuils"]) : undefined as any;
            if (Array.isArray(_data["motif"])) {
                this.motif = [] as any;
                for (let item of _data["motif"])
                    this.motif!.push(MotifRachat.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesRachatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesRachatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : undefined as any;
        if (Array.isArray(this.motif)) {
            data["motif"] = [];
            for (let item of this.motif)
                data["motif"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDonneesRachatResponse {
    montantsSeuils?: MontantsSeuilsRachat;
    motif?: MotifRachat[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetDonneesVersementRequest implements IGetDonneesVersementRequest {
    numeroContrat?: number | undefined;
    etapeContrat?: string | undefined;
    montantVersement?: number;
    montantRevenuNetMensuel?: number;
    montantPatrimoineFoyer?: number;

    constructor(data?: IGetDonneesVersementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.etapeContrat = _data["etapeContrat"];
            this.montantVersement = _data["montantVersement"];
            this.montantRevenuNetMensuel = _data["montantRevenuNetMensuel"];
            this.montantPatrimoineFoyer = _data["montantPatrimoineFoyer"];
        }
    }

    static fromJS(data: any): GetDonneesVersementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesVersementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["etapeContrat"] = this.etapeContrat;
        data["montantVersement"] = this.montantVersement;
        data["montantRevenuNetMensuel"] = this.montantRevenuNetMensuel;
        data["montantPatrimoineFoyer"] = this.montantPatrimoineFoyer;
        return data;
    }
}

export interface IGetDonneesVersementRequest {
    numeroContrat?: number | undefined;
    etapeContrat?: string | undefined;
    montantVersement?: number;
    montantRevenuNetMensuel?: number;
    montantPatrimoineFoyer?: number;
}

export class GetDonneesVersementResponse implements IGetDonneesVersementResponse {
    montantsSeuils?: MontantsSeuilsVersement;
    provenanceFonds?: ProvenanceFonds[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetDonneesVersementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsVersement.fromJS(_data["montantsSeuils"]) : undefined as any;
            if (Array.isArray(_data["provenanceFonds"])) {
                this.provenanceFonds = [] as any;
                for (let item of _data["provenanceFonds"])
                    this.provenanceFonds!.push(ProvenanceFonds.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesVersementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesVersementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : undefined as any;
        if (Array.isArray(this.provenanceFonds)) {
            data["provenanceFonds"] = [];
            for (let item of this.provenanceFonds)
                data["provenanceFonds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDonneesVersementResponse {
    montantsSeuils?: MontantsSeuilsVersement;
    provenanceFonds?: ProvenanceFonds[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetFichierPDFRequest implements IGetFichierPDFRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    personne?: Personne;
    entetePDF?: EntetePDF;

    constructor(data?: IGetFichierPDFRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.codeProduit = _data["codeProduit"];
            this.personne = _data["personne"] ? Personne.fromJS(_data["personne"]) : undefined as any;
            this.entetePDF = _data["entetePDF"] ? EntetePDF.fromJS(_data["entetePDF"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFichierPDFRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFichierPDFRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["codeProduit"] = this.codeProduit;
        data["personne"] = this.personne ? this.personne.toJSON() : undefined as any;
        data["entetePDF"] = this.entetePDF ? this.entetePDF.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFichierPDFRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    personne?: Personne;
    entetePDF?: EntetePDF;
}

export class GetFichierPDFResponse implements IGetFichierPDFResponse {
    document?: Document;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetFichierPDFResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFichierPDFResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFichierPDFResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFichierPDFResponse {
    document?: Document;
    erreurs?: Erreur9[] | undefined;
}

export class GetFondsProduitRequest implements IGetFondsProduitRequest {
    codeProduit?: string | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;

    constructor(data?: IGetFondsProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.idFonds = _data["idFonds"];
            this.lireDocuments = _data["lireDocuments"];
            this.idCanal = _data["idCanal"];
            this.idDemarche = _data["idDemarche"];
        }
    }

    static fromJS(data: any): GetFondsProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFondsProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["idFonds"] = this.idFonds;
        data["lireDocuments"] = this.lireDocuments;
        data["idCanal"] = this.idCanal;
        data["idDemarche"] = this.idDemarche;
        return data;
    }
}

export interface IGetFondsProduitRequest {
    codeProduit?: string | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;
}

export class GetFondsProduitResponse implements IGetFondsProduitResponse {
    fonds?: Fonds[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetFondsProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(Fonds.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFondsProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFondsProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFondsProduitResponse {
    fonds?: Fonds[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetFraisVersementRequest implements IGetFraisVersementRequest {
    numeroContrat?: number;
    transfertPacte?: boolean;
    pourcentageVersementFondsEuro?: number;
    montantVerse?: number | undefined;

    constructor(data?: IGetFraisVersementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.transfertPacte = _data["transfertPacte"];
            this.pourcentageVersementFondsEuro = _data["pourcentageVersementFondsEuro"];
            this.montantVerse = _data["montantVerse"];
        }
    }

    static fromJS(data: any): GetFraisVersementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraisVersementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["transfertPacte"] = this.transfertPacte;
        data["pourcentageVersementFondsEuro"] = this.pourcentageVersementFondsEuro;
        data["montantVerse"] = this.montantVerse;
        return data;
    }
}

export interface IGetFraisVersementRequest {
    numeroContrat?: number;
    transfertPacte?: boolean;
    pourcentageVersementFondsEuro?: number;
    montantVerse?: number | undefined;
}

export class GetFraisVersementResponse implements IGetFraisVersementResponse {
    versement?: Versement;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetFraisVersementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versement = _data["versement"] ? Versement.fromJS(_data["versement"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFraisVersementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraisVersementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versement"] = this.versement ? this.versement.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFraisVersementResponse {
    versement?: Versement;
    erreurs?: Erreur9[] | undefined;
}

export class GetGrilleDesensibilisationCERURequest implements IGetGrilleDesensibilisationCERURequest {

    constructor(data?: IGetGrilleDesensibilisationCERURequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGrilleDesensibilisationCERURequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGrilleDesensibilisationCERURequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGrilleDesensibilisationCERURequest {
}

export class GetGrilleDesensibilisationCERUResponse implements IGetGrilleDesensibilisationCERUResponse {
    grilleDesensibilisation?: GrilleDesensibilisation;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetGrilleDesensibilisationCERUResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grilleDesensibilisation = _data["grilleDesensibilisation"] ? GrilleDesensibilisation.fromJS(_data["grilleDesensibilisation"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGrilleDesensibilisationCERUResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGrilleDesensibilisationCERUResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grilleDesensibilisation"] = this.grilleDesensibilisation ? this.grilleDesensibilisation.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetGrilleDesensibilisationCERUResponse {
    grilleDesensibilisation?: GrilleDesensibilisation;
    erreurs?: Erreur9[] | undefined;
}

export class GetListeDocumentsRequest implements IGetListeDocumentsRequest {
    identifiant?: number;
    idTypeDocument?: number;
    modeLecture?: string | undefined;

    constructor(data?: IGetListeDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.idTypeDocument = _data["idTypeDocument"];
            this.modeLecture = _data["modeLecture"];
        }
    }

    static fromJS(data: any): GetListeDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListeDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["idTypeDocument"] = this.idTypeDocument;
        data["modeLecture"] = this.modeLecture;
        return data;
    }
}

export interface IGetListeDocumentsRequest {
    identifiant?: number;
    idTypeDocument?: number;
    modeLecture?: string | undefined;
}

export class GetListeDocumentsResponse implements IGetListeDocumentsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetListeDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListeDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListeDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetListeDocumentsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetMentionsLegalesRequest implements IGetMentionsLegalesRequest {
    dateRecherche?: Date | undefined;

    constructor(data?: IGetMentionsLegalesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRecherche = _data["dateRecherche"] ? new Date(_data["dateRecherche"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetMentionsLegalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMentionsLegalesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRecherche"] = this.dateRecherche ? this.dateRecherche.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetMentionsLegalesRequest {
    dateRecherche?: Date | undefined;
}

export class GetMentionsLegalesResponse implements IGetMentionsLegalesResponse {
    mentionsLegales?: MentionLegale[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetMentionsLegalesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mentionsLegales"])) {
                this.mentionsLegales = [] as any;
                for (let item of _data["mentionsLegales"])
                    this.mentionsLegales!.push(MentionLegale.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMentionsLegalesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMentionsLegalesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mentionsLegales)) {
            data["mentionsLegales"] = [];
            for (let item of this.mentionsLegales)
                data["mentionsLegales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMentionsLegalesResponse {
    mentionsLegales?: MentionLegale[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetOrigineDemandeRequest implements IGetOrigineDemandeRequest {

    constructor(data?: IGetOrigineDemandeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrigineDemandeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrigineDemandeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrigineDemandeRequest {
}

export class GetOrigineDemandeResponse implements IGetOrigineDemandeResponse {
    origineDemande?: OrigineDemande[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetOrigineDemandeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["origineDemande"])) {
                this.origineDemande = [] as any;
                for (let item of _data["origineDemande"])
                    this.origineDemande!.push(OrigineDemande.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrigineDemandeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrigineDemandeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.origineDemande)) {
            data["origineDemande"] = [];
            for (let item of this.origineDemande)
                data["origineDemande"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetOrigineDemandeResponse {
    origineDemande?: OrigineDemande[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetProduitsRequest implements IGetProduitsRequest {
    produitSouscriptionLigne?: boolean;

    constructor(data?: IGetProduitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produitSouscriptionLigne = _data["produitSouscriptionLigne"];
        }
    }

    static fromJS(data: any): GetProduitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProduitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produitSouscriptionLigne"] = this.produitSouscriptionLigne;
        return data;
    }
}

export interface IGetProduitsRequest {
    produitSouscriptionLigne?: boolean;
}

export class GetProduitsResponse implements IGetProduitsResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetProduitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["produit"])) {
                this.produit = [] as any;
                for (let item of _data["produit"])
                    this.produit!.push(Produit3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProduitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProduitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.produit)) {
            data["produit"] = [];
            for (let item of this.produit)
                data["produit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProduitsResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetProfils implements IGetProfils {

    constructor(data?: IGetProfils) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetProfils {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfils();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetProfils {
}

export class GetProfilsResponse implements IGetProfilsResponse {
    profils?: Profil[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetProfilsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profils"])) {
                this.profils = [] as any;
                for (let item of _data["profils"])
                    this.profils!.push(Profil.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfilsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profils)) {
            data["profils"] = [];
            for (let item of this.profils)
                data["profils"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProfilsResponse {
    profils?: Profil[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetRUMRequest implements IGetRUMRequest {

    constructor(data?: IGetRUMRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRUMRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRUMRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRUMRequest {
}

export class GetRUMResponse implements IGetRUMResponse {
    rUM?: string | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetRUMResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rUM = _data["RUM"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRUMResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRUMResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RUM"] = this.rUM;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRUMResponse {
    rUM?: string | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetRecommandationRequest implements IGetRecommandationRequest {
    score?: number | undefined;
    codeProduit?: string | undefined;
    idDemarche?: number | undefined;
    montantVerse?: number | undefined;
    transfertPACTE?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    lireDocuments?: boolean | undefined;
    dateEstimationDepartRetraite?: Date;
    flagDurabilite?: boolean | undefined;

    constructor(data?: IGetRecommandationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.codeProduit = _data["codeProduit"];
            this.idDemarche = _data["idDemarche"];
            this.montantVerse = _data["montantVerse"];
            this.transfertPACTE = _data["transfertPACTE"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.lireDocuments = _data["lireDocuments"];
            this.dateEstimationDepartRetraite = _data["dateEstimationDepartRetraite"] ? new Date(_data["dateEstimationDepartRetraite"].toString()) : undefined as any;
            this.flagDurabilite = _data["flagDurabilite"];
        }
    }

    static fromJS(data: any): GetRecommandationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommandationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["codeProduit"] = this.codeProduit;
        data["idDemarche"] = this.idDemarche;
        data["montantVerse"] = this.montantVerse;
        data["transfertPACTE"] = this.transfertPACTE;
        data["echeancePrecise"] = this.echeancePrecise;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["lireDocuments"] = this.lireDocuments;
        data["dateEstimationDepartRetraite"] = this.dateEstimationDepartRetraite ? this.dateEstimationDepartRetraite.toISOString() : undefined as any;
        data["flagDurabilite"] = this.flagDurabilite;
        return data;
    }
}

export interface IGetRecommandationRequest {
    score?: number | undefined;
    codeProduit?: string | undefined;
    idDemarche?: number | undefined;
    montantVerse?: number | undefined;
    transfertPACTE?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    lireDocuments?: boolean | undefined;
    dateEstimationDepartRetraite?: Date;
    flagDurabilite?: boolean | undefined;
}

export class GetRecommandationResponse implements IGetRecommandationResponse {
    recommandation?: Recommandation;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetRecommandationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommandation = _data["recommandation"] ? Recommandation.fromJS(_data["recommandation"]) : undefined as any;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecommandationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommandationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommandation"] = this.recommandation ? this.recommandation.toJSON() : undefined as any;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRecommandationResponse {
    recommandation?: Recommandation;
    erreurs?: Erreur9[] | undefined;
}

export class GetReglesMetierProduitRequest implements IGetReglesMetierProduitRequest {
    codeProduit?: string | undefined;
    idTypeProduit?: number;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;

    constructor(data?: IGetReglesMetierProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.idTypeProduit = _data["idTypeProduit"];
            this.lireDocuments = _data["lireDocuments"];
            this.idCanal = _data["idCanal"];
            this.idDemarche = _data["idDemarche"];
        }
    }

    static fromJS(data: any): GetReglesMetierProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReglesMetierProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["idTypeProduit"] = this.idTypeProduit;
        data["lireDocuments"] = this.lireDocuments;
        data["idCanal"] = this.idCanal;
        data["idDemarche"] = this.idDemarche;
        return data;
    }
}

export interface IGetReglesMetierProduitRequest {
    codeProduit?: string | undefined;
    idTypeProduit?: number;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;
}

export class GetReglesMetierProduitResponse implements IGetReglesMetierProduitResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetReglesMetierProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["produit"])) {
                this.produit = [] as any;
                for (let item of _data["produit"])
                    this.produit!.push(Produit3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReglesMetierProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReglesMetierProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.produit)) {
            data["produit"] = [];
            for (let item of this.produit)
                data["produit"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetReglesMetierProduitResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetTypePDFDocumentProduitRequest implements IGetTypePDFDocumentProduitRequest {
    idTypeDocument?: number | undefined;

    constructor(data?: IGetTypePDFDocumentProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
        }
    }

    static fromJS(data: any): GetTypePDFDocumentProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypePDFDocumentProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        return data;
    }
}

export interface IGetTypePDFDocumentProduitRequest {
    idTypeDocument?: number | undefined;
}

export class GetTypePDFDocumentProduitResponse implements IGetTypePDFDocumentProduitResponse {
    pDFDynamique?: boolean;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetTypePDFDocumentProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pDFDynamique = _data["PDFDynamique"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTypePDFDocumentProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypePDFDocumentProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PDFDynamique"] = this.pDFDynamique;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTypePDFDocumentProduitResponse {
    pDFDynamique?: boolean;
    erreurs?: Erreur9[] | undefined;
}

export class GetTypesDocumentsRequest implements IGetTypesDocumentsRequest {
    codeProduit?: string | undefined;

    constructor(data?: IGetTypesDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
        }
    }

    static fromJS(data: any): GetTypesDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        return data;
    }
}

export interface IGetTypesDocumentsRequest {
    codeProduit?: string | undefined;
}

export class GetTypesDocumentsResponse implements IGetTypesDocumentsResponse {
    typeDocument?: TypeDocument[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetTypesDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["typeDocument"])) {
                this.typeDocument = [] as any;
                for (let item of _data["typeDocument"])
                    this.typeDocument!.push(TypeDocument.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTypesDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.typeDocument)) {
            data["typeDocument"] = [];
            for (let item of this.typeDocument)
                data["typeDocument"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTypesDocumentsResponse {
    typeDocument?: TypeDocument[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GrilleDesensibilisation implements IGrilleDesensibilisation {
    supportEuro?: string | undefined;
    supportUC?: string | undefined;
    repartition?: LigneRepartition[] | undefined;

    constructor(data?: IGrilleDesensibilisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportEuro = _data["supportEuro"];
            this.supportUC = _data["supportUC"];
            if (Array.isArray(_data["repartition"])) {
                this.repartition = [] as any;
                for (let item of _data["repartition"])
                    this.repartition!.push(LigneRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrilleDesensibilisation {
        data = typeof data === 'object' ? data : {};
        let result = new GrilleDesensibilisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportEuro"] = this.supportEuro;
        data["supportUC"] = this.supportUC;
        if (Array.isArray(this.repartition)) {
            data["repartition"] = [];
            for (let item of this.repartition)
                data["repartition"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGrilleDesensibilisation {
    supportEuro?: string | undefined;
    supportUC?: string | undefined;
    repartition?: LigneRepartition[] | undefined;
}

export class LienDocuments implements ILienDocuments {
    idPackDoc?: number | undefined;
    libelle?: string | undefined;
    document?: Document[] | undefined;

    constructor(data?: ILienDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPackDoc = _data["idPackDoc"];
            this.libelle = _data["libelle"];
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LienDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new LienDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPackDoc"] = this.idPackDoc;
        data["libelle"] = this.libelle;
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILienDocuments {
    idPackDoc?: number | undefined;
    libelle?: string | undefined;
    document?: Document[] | undefined;
}

export class LigneRepartition implements ILigneRepartition {
    nbAnneesRestantesHorizon?: number | undefined;
    repartitionSupportEuro?: number | undefined;
    repartitionSupportUC?: number | undefined;

    constructor(data?: ILigneRepartition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nbAnneesRestantesHorizon = _data["nbAnneesRestantesHorizon"];
            this.repartitionSupportEuro = _data["repartitionSupportEuro"];
            this.repartitionSupportUC = _data["repartitionSupportUC"];
        }
    }

    static fromJS(data: any): LigneRepartition {
        data = typeof data === 'object' ? data : {};
        let result = new LigneRepartition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nbAnneesRestantesHorizon"] = this.nbAnneesRestantesHorizon;
        data["repartitionSupportEuro"] = this.repartitionSupportEuro;
        data["repartitionSupportUC"] = this.repartitionSupportUC;
        return data;
    }
}

export interface ILigneRepartition {
    nbAnneesRestantesHorizon?: number | undefined;
    repartitionSupportEuro?: number | undefined;
    repartitionSupportUC?: number | undefined;
}

export class ListeReferencesMetierRequest implements IListeReferencesMetierRequest {
    idTypeReference?: number | undefined;

    constructor(data?: IListeReferencesMetierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeReference = _data["idTypeReference"];
        }
    }

    static fromJS(data: any): ListeReferencesMetierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListeReferencesMetierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeReference"] = this.idTypeReference;
        return data;
    }
}

export interface IListeReferencesMetierRequest {
    idTypeReference?: number | undefined;
}

export class ListeReferencesMetierResponse implements IListeReferencesMetierResponse {
    idTypeReference?: number | undefined;
    libelleTypeReference?: string | undefined;
    reference?: Reference[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IListeReferencesMetierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeReference = _data["idTypeReference"];
            this.libelleTypeReference = _data["libelleTypeReference"];
            if (Array.isArray(_data["reference"])) {
                this.reference = [] as any;
                for (let item of _data["reference"])
                    this.reference!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListeReferencesMetierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListeReferencesMetierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeReference"] = this.idTypeReference;
        data["libelleTypeReference"] = this.libelleTypeReference;
        if (Array.isArray(this.reference)) {
            data["reference"] = [];
            for (let item of this.reference)
                data["reference"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListeReferencesMetierResponse {
    idTypeReference?: number | undefined;
    libelleTypeReference?: string | undefined;
    reference?: Reference[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class Mandat implements IMandat {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    pourcentageEuros?: number;
    pourcentageUC?: number;
    dureePlacementConseillee?: number;

    constructor(data?: IMandat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.pourcentageEuros = _data["pourcentageEuros"];
            this.pourcentageUC = _data["pourcentageUC"];
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
        }
    }

    static fromJS(data: any): Mandat {
        data = typeof data === 'object' ? data : {};
        let result = new Mandat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["pourcentageEuros"] = this.pourcentageEuros;
        data["pourcentageUC"] = this.pourcentageUC;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        return data;
    }
}

export interface IMandat {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    pourcentageEuros?: number;
    pourcentageUC?: number;
    dureePlacementConseillee?: number;
}

export class MandatGestion implements IMandatGestion {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
    allocation?: FondsRepartition[] | undefined;

    constructor(data?: IMandatGestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.libelleRepartition = _data["libelleRepartition"];
            this.document = _data["document"] ? Document4.fromJS(_data["document"]) : undefined as any;
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
            if (Array.isArray(_data["allocation"])) {
                this.allocation = [] as any;
                for (let item of _data["allocation"])
                    this.allocation!.push(FondsRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MandatGestion {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["libelleRepartition"] = this.libelleRepartition;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        if (Array.isArray(this.allocation)) {
            data["allocation"] = [];
            for (let item of this.allocation)
                data["allocation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMandatGestion {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
    allocation?: FondsRepartition[] | undefined;
}

export class MandatGestion2 implements IMandatGestion2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;

    constructor(data?: IMandatGestion2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.libelleRepartition = _data["libelleRepartition"];
            this.document = _data["document"] ? Document4.fromJS(_data["document"]) : undefined as any;
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
        }
    }

    static fromJS(data: any): MandatGestion2 {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestion2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["libelleRepartition"] = this.libelleRepartition;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        return data;
    }
}

export interface IMandatGestion2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
}

export class MandatGestionRequest implements IMandatGestionRequest {
    idMandatGestion?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IMandatGestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idMandatGestion = _data["idMandatGestion"];
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): MandatGestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMandatGestion"] = this.idMandatGestion;
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IMandatGestionRequest {
    idMandatGestion?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class MandatGestionResponse implements IMandatGestionResponse {
    mandatGestion?: MandatGestion[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IMandatGestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mandatGestion"])) {
                this.mandatGestion = [] as any;
                for (let item of _data["mandatGestion"])
                    this.mandatGestion!.push(MandatGestion.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MandatGestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mandatGestion)) {
            data["mandatGestion"] = [];
            for (let item of this.mandatGestion)
                data["mandatGestion"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMandatGestionResponse {
    mandatGestion?: MandatGestion[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class MentionLegale implements IMentionLegale {
    idMentionLegale?: number | undefined;
    libelleCourt?: string | undefined;
    texte?: string | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;

    constructor(data?: IMentionLegale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idMentionLegale = _data["idMentionLegale"];
            this.libelleCourt = _data["libelleCourt"];
            this.texte = _data["texte"];
            this.dateDebut = _data["dateDebut"] ? new Date(_data["dateDebut"].toString()) : undefined as any;
            this.dateFin = _data["dateFin"] ? new Date(_data["dateFin"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MentionLegale {
        data = typeof data === 'object' ? data : {};
        let result = new MentionLegale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMentionLegale"] = this.idMentionLegale;
        data["libelleCourt"] = this.libelleCourt;
        data["texte"] = this.texte;
        data["dateDebut"] = this.dateDebut ? this.dateDebut.toISOString() : undefined as any;
        data["dateFin"] = this.dateFin ? this.dateFin.toISOString() : undefined as any;
        return data;
    }
}

export interface IMentionLegale {
    idMentionLegale?: number | undefined;
    libelleCourt?: string | undefined;
    texte?: string | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
}

export class ModeGestion implements IModeGestion {
    id?: number;
    libelle?: string | undefined;

    constructor(data?: IModeGestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): ModeGestion {
        data = typeof data === 'object' ? data : {};
        let result = new ModeGestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IModeGestion {
    id?: number;
    libelle?: string | undefined;
}

export class ModeGestionRecommandation implements IModeGestionRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: string | undefined;
    mandatGestion?: MandatGestion2;
    poche?: Poche[] | undefined;

    constructor(data?: IModeGestionRecommandation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.mandatGestion = _data["mandatGestion"] ? MandatGestion2.fromJS(_data["mandatGestion"]) : undefined as any;
            if (Array.isArray(_data["poche"])) {
                this.poche = [] as any;
                for (let item of _data["poche"])
                    this.poche!.push(Poche.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModeGestionRecommandation {
        data = typeof data === 'object' ? data : {};
        let result = new ModeGestionRecommandation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["mandatGestion"] = this.mandatGestion ? this.mandatGestion.toJSON() : undefined as any;
        if (Array.isArray(this.poche)) {
            data["poche"] = [];
            for (let item of this.poche)
                data["poche"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModeGestionRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: string | undefined;
    mandatGestion?: MandatGestion2;
    poche?: Poche[] | undefined;
}

export class MontantsSeuilsArbitrage implements IMontantsSeuilsArbitrage {
    mntMaxSeuilFondsEuroDesinvesti?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;

    constructor(data?: IMontantsSeuilsArbitrage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntMaxSeuilFondsEuroDesinvesti = _data["mntMaxSeuilFondsEuroDesinvesti"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
        }
    }

    static fromJS(data: any): MontantsSeuilsArbitrage {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsArbitrage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntMaxSeuilFondsEuroDesinvesti"] = this.mntMaxSeuilFondsEuroDesinvesti;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        return data;
    }
}

export interface IMontantsSeuilsArbitrage {
    mntMaxSeuilFondsEuroDesinvesti?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
}

export class MontantsSeuilsRachat implements IMontantsSeuilsRachat {
    mntValeurRachatTotal?: number | undefined;
    mntValeurRachatPartiel?: number | undefined;
    mntMinRachat?: number | undefined;
    mntMaxSeuilRachat?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
    seuilReglesDDFDepasse?: boolean | undefined;
    optionFiscalePFLAutorisee?: boolean | undefined;

    constructor(data?: IMontantsSeuilsRachat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntValeurRachatTotal = _data["mntValeurRachatTotal"];
            this.mntValeurRachatPartiel = _data["mntValeurRachatPartiel"];
            this.mntMinRachat = _data["mntMinRachat"];
            this.mntMaxSeuilRachat = _data["mntMaxSeuilRachat"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
            this.seuilReglesDDFDepasse = _data["seuilReglesDDFDepasse"];
            this.optionFiscalePFLAutorisee = _data["optionFiscalePFLAutorisee"];
        }
    }

    static fromJS(data: any): MontantsSeuilsRachat {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsRachat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntValeurRachatTotal"] = this.mntValeurRachatTotal;
        data["mntValeurRachatPartiel"] = this.mntValeurRachatPartiel;
        data["mntMinRachat"] = this.mntMinRachat;
        data["mntMaxSeuilRachat"] = this.mntMaxSeuilRachat;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        data["seuilReglesDDFDepasse"] = this.seuilReglesDDFDepasse;
        data["optionFiscalePFLAutorisee"] = this.optionFiscalePFLAutorisee;
        return data;
    }
}

export interface IMontantsSeuilsRachat {
    mntValeurRachatTotal?: number | undefined;
    mntValeurRachatPartiel?: number | undefined;
    mntMinRachat?: number | undefined;
    mntMaxSeuilRachat?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
    seuilReglesDDFDepasse?: boolean | undefined;
    optionFiscalePFLAutorisee?: boolean | undefined;
}

export class MontantsSeuilsVersement implements IMontantsSeuilsVersement {
    mntMinVersementLibre?: number | undefined;
    mntMinVersementProgramme?: number | undefined;
    mntMaxSeuilVersementLibre?: number | undefined;
    mntMaxSeuilVersementProgramme?: number | undefined;
    seuilReglesPOFDepasse?: boolean | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;

    constructor(data?: IMontantsSeuilsVersement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntMinVersementLibre = _data["mntMinVersementLibre"];
            this.mntMinVersementProgramme = _data["mntMinVersementProgramme"];
            this.mntMaxSeuilVersementLibre = _data["mntMaxSeuilVersementLibre"];
            this.mntMaxSeuilVersementProgramme = _data["mntMaxSeuilVersementProgramme"];
            this.seuilReglesPOFDepasse = _data["seuilReglesPOFDepasse"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
        }
    }

    static fromJS(data: any): MontantsSeuilsVersement {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsVersement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntMinVersementLibre"] = this.mntMinVersementLibre;
        data["mntMinVersementProgramme"] = this.mntMinVersementProgramme;
        data["mntMaxSeuilVersementLibre"] = this.mntMaxSeuilVersementLibre;
        data["mntMaxSeuilVersementProgramme"] = this.mntMaxSeuilVersementProgramme;
        data["seuilReglesPOFDepasse"] = this.seuilReglesPOFDepasse;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        return data;
    }
}

export interface IMontantsSeuilsVersement {
    mntMinVersementLibre?: number | undefined;
    mntMinVersementProgramme?: number | undefined;
    mntMaxSeuilVersementLibre?: number | undefined;
    mntMaxSeuilVersementProgramme?: number | undefined;
    seuilReglesPOFDepasse?: boolean | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
}

export class MotifRachat implements IMotifRachat {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IMotifRachat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): MotifRachat {
        data = typeof data === 'object' ? data : {};
        let result = new MotifRachat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IMotifRachat {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class OrigineDemande implements IOrigineDemande {
    id?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IOrigineDemande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): OrigineDemande {
        data = typeof data === 'object' ? data : {};
        let result = new OrigineDemande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IOrigineDemande {
    id?: string | undefined;
    libelle?: string | undefined;
}

export class Performance implements IPerformance {
    id?: number | undefined;
    libelle?: string | undefined;
    taux?: number | undefined;
    annee?: number | undefined;
    typeUC?: boolean | undefined;
    ordre?: number | undefined;

    constructor(data?: IPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.taux = _data["taux"];
            this.annee = _data["annee"];
            this.typeUC = _data["typeUC"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Performance {
        data = typeof data === 'object' ? data : {};
        let result = new Performance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["taux"] = this.taux;
        data["annee"] = this.annee;
        data["typeUC"] = this.typeUC;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IPerformance {
    id?: number | undefined;
    libelle?: string | undefined;
    taux?: number | undefined;
    annee?: number | undefined;
    typeUC?: boolean | undefined;
    ordre?: number | undefined;
}

export class Personne implements IPersonne {
    numeroSocietaire?: string | undefined;
    noContrat?: number;
    dateNaissance?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneFixe?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPersonne) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroSocietaire = _data["numeroSocietaire"];
            this.noContrat = _data["noContrat"];
            this.dateNaissance = _data["dateNaissance"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Personne {
        data = typeof data === 'object' ? data : {};
        let result = new Personne();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroSocietaire"] = this.numeroSocietaire;
        data["noContrat"] = this.noContrat;
        data["dateNaissance"] = this.dateNaissance;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneFixe"] = this.telephoneFixe;
        data["email"] = this.email;
        return data;
    }
}

export interface IPersonne {
    numeroSocietaire?: string | undefined;
    noContrat?: number;
    dateNaissance?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneFixe?: string | undefined;
    email?: string | undefined;
}

export class Poche implements IPoche {
    id?: string | undefined;
    libelle?: string | undefined;
    repartition?: string | undefined;
    fondsRepartition?: FondsRepartition[] | undefined;

    constructor(data?: IPoche) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.repartition = _data["repartition"];
            if (Array.isArray(_data["fondsRepartition"])) {
                this.fondsRepartition = [] as any;
                for (let item of _data["fondsRepartition"])
                    this.fondsRepartition!.push(FondsRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Poche {
        data = typeof data === 'object' ? data : {};
        let result = new Poche();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["repartition"] = this.repartition;
        if (Array.isArray(this.fondsRepartition)) {
            data["fondsRepartition"] = [];
            for (let item of this.fondsRepartition)
                data["fondsRepartition"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPoche {
    id?: string | undefined;
    libelle?: string | undefined;
    repartition?: string | undefined;
    fondsRepartition?: FondsRepartition[] | undefined;
}

export class Produit2 implements IProduit2 {
    id?: number;

    constructor(data?: IProduit2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Produit2 {
        data = typeof data === 'object' ? data : {};
        let result = new Produit2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProduit2 {
    id?: number;
}

export class Produit3 implements IProduit3 {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestion[] | undefined;
    typeRegle?: TypeRegle[] | undefined;
    fonds?: Fonds[] | undefined;
    document?: Document[] | undefined;

    constructor(data?: IProduit3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeProduit.fromJS(_data["type"]) : undefined as any;
            this.statut = _data["statut"];
            this.souscriptionLigne = _data["souscriptionLigne"];
            if (Array.isArray(_data["modeGestion"])) {
                this.modeGestion = [] as any;
                for (let item of _data["modeGestion"])
                    this.modeGestion!.push(ModeGestion.fromJS(item));
            }
            if (Array.isArray(_data["typeRegle"])) {
                this.typeRegle = [] as any;
                for (let item of _data["typeRegle"])
                    this.typeRegle!.push(TypeRegle.fromJS(item));
            }
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(Fonds.fromJS(item));
            }
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Produit3 {
        data = typeof data === 'object' ? data : {};
        let result = new Produit3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["statut"] = this.statut;
        data["souscriptionLigne"] = this.souscriptionLigne;
        if (Array.isArray(this.modeGestion)) {
            data["modeGestion"] = [];
            for (let item of this.modeGestion)
                data["modeGestion"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.typeRegle)) {
            data["typeRegle"] = [];
            for (let item of this.typeRegle)
                data["typeRegle"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProduit3 {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestion[] | undefined;
    typeRegle?: TypeRegle[] | undefined;
    fonds?: Fonds[] | undefined;
    document?: Document[] | undefined;
}

export class ProduitRecommande implements IProduitRecommande {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestionRecommandation[] | undefined;

    constructor(data?: IProduitRecommande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeProduit.fromJS(_data["type"]) : undefined as any;
            this.statut = _data["statut"];
            this.souscriptionLigne = _data["souscriptionLigne"];
            if (Array.isArray(_data["modeGestion"])) {
                this.modeGestion = [] as any;
                for (let item of _data["modeGestion"])
                    this.modeGestion!.push(ModeGestionRecommandation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProduitRecommande {
        data = typeof data === 'object' ? data : {};
        let result = new ProduitRecommande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["statut"] = this.statut;
        data["souscriptionLigne"] = this.souscriptionLigne;
        if (Array.isArray(this.modeGestion)) {
            data["modeGestion"] = [];
            for (let item of this.modeGestion)
                data["modeGestion"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProduitRecommande {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestionRecommandation[] | undefined;
}

export class Profil implements IProfil {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    scoreMin?: number;
    scoreMax?: number;
    mandat?: Mandat;

    constructor(data?: IProfil) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.scoreMin = _data["scoreMin"];
            this.scoreMax = _data["scoreMax"];
            this.mandat = _data["mandat"] ? Mandat.fromJS(_data["mandat"]) : undefined as any;
        }
    }

    static fromJS(data: any): Profil {
        data = typeof data === 'object' ? data : {};
        let result = new Profil();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["scoreMin"] = this.scoreMin;
        data["scoreMax"] = this.scoreMax;
        data["mandat"] = this.mandat ? this.mandat.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfil {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    scoreMin?: number;
    scoreMax?: number;
    mandat?: Mandat;
}

export class Profil2 implements IProfil2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;

    constructor(data?: IProfil2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Profil2 {
        data = typeof data === 'object' ? data : {};
        let result = new Profil2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        return data;
    }
}

export interface IProfil2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
}

export class ProvenanceFonds implements IProvenanceFonds {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IProvenanceFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): ProvenanceFonds {
        data = typeof data === 'object' ? data : {};
        let result = new ProvenanceFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IProvenanceFonds {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class Recommandation implements IRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    horizonMin?: number | undefined;
    horizonMax?: number | undefined;
    profil?: Profil2;
    produitRecommande?: ProduitRecommande;

    constructor(data?: IRecommandation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.horizonMin = _data["horizonMin"];
            this.horizonMax = _data["horizonMax"];
            this.profil = _data["profil"] ? Profil2.fromJS(_data["profil"]) : undefined as any;
            this.produitRecommande = _data["produitRecommande"] ? ProduitRecommande.fromJS(_data["produitRecommande"]) : undefined as any;
        }
    }

    static fromJS(data: any): Recommandation {
        data = typeof data === 'object' ? data : {};
        let result = new Recommandation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["horizonMin"] = this.horizonMin;
        data["horizonMax"] = this.horizonMax;
        data["profil"] = this.profil ? this.profil.toJSON() : undefined as any;
        data["produitRecommande"] = this.produitRecommande ? this.produitRecommande.toJSON() : undefined as any;
        return data;
    }
}

export interface IRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    horizonMin?: number | undefined;
    horizonMax?: number | undefined;
    profil?: Profil2;
    produitRecommande?: ProduitRecommande;
}

export class Reference implements IReference {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IReference {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class Regle implements IRegle {
    code?: string | undefined;
    type?: number;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    ordre?: number | undefined;
    idCategorie?: number | undefined;
    reponsePossible?: ReponsePossible[] | undefined;
    reponseAttendue?: ReponseAttendue[] | undefined;

    constructor(data?: IRegle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
            this.ordre = _data["ordre"];
            this.idCategorie = _data["idCategorie"];
            if (Array.isArray(_data["reponsePossible"])) {
                this.reponsePossible = [] as any;
                for (let item of _data["reponsePossible"])
                    this.reponsePossible!.push(ReponsePossible.fromJS(item));
            }
            if (Array.isArray(_data["reponseAttendue"])) {
                this.reponseAttendue = [] as any;
                for (let item of _data["reponseAttendue"])
                    this.reponseAttendue!.push(ReponseAttendue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Regle {
        data = typeof data === 'object' ? data : {};
        let result = new Regle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        data["ordre"] = this.ordre;
        data["idCategorie"] = this.idCategorie;
        if (Array.isArray(this.reponsePossible)) {
            data["reponsePossible"] = [];
            for (let item of this.reponsePossible)
                data["reponsePossible"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reponseAttendue)) {
            data["reponseAttendue"] = [];
            for (let item of this.reponseAttendue)
                data["reponseAttendue"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegle {
    code?: string | undefined;
    type?: number;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    ordre?: number | undefined;
    idCategorie?: number | undefined;
    reponsePossible?: ReponsePossible[] | undefined;
    reponseAttendue?: ReponseAttendue[] | undefined;
}

export class ReponseAttendue implements IReponseAttendue {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;

    constructor(data?: IReponseAttendue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.num = _data["num"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
        }
    }

    static fromJS(data: any): ReponseAttendue {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseAttendue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["num"] = this.num;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        return data;
    }
}

export interface IReponseAttendue {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
}

export class ReponsePossible implements IReponsePossible {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;

    constructor(data?: IReponsePossible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.num = _data["num"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
        }
    }

    static fromJS(data: any): ReponsePossible {
        data = typeof data === 'object' ? data : {};
        let result = new ReponsePossible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["num"] = this.num;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        return data;
    }
}

export interface IReponsePossible {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
}

export class Type implements IType {
    id?: string | undefined;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IType {
    id?: string | undefined;
}

export class TypeDocument implements ITypeDocument {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeDocument {
        data = typeof data === 'object' ? data : {};
        let result = new TypeDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeDocument {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeFonds implements ITypeFonds {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeFonds {
        data = typeof data === 'object' ? data : {};
        let result = new TypeFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeFonds {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeProduit implements ITypeProduit {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeProduit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeProduit {
        data = typeof data === 'object' ? data : {};
        let result = new TypeProduit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeProduit {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeRegle implements ITypeRegle {
    id?: number | undefined;
    libelle?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    statut?: boolean;
    regle?: Regle[] | undefined;

    constructor(data?: ITypeRegle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
            this.statut = _data["statut"];
            if (Array.isArray(_data["regle"])) {
                this.regle = [] as any;
                for (let item of _data["regle"])
                    this.regle!.push(Regle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeRegle {
        data = typeof data === 'object' ? data : {};
        let result = new TypeRegle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        data["statut"] = this.statut;
        if (Array.isArray(this.regle)) {
            data["regle"] = [];
            for (let item of this.regle)
                data["regle"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITypeRegle {
    id?: number | undefined;
    libelle?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    statut?: boolean;
    regle?: Regle[] | undefined;
}

export class Versement implements IVersement {
    montantBrutVerseFondsEuro?: number | undefined;
    montantFraisVersementFondsEuro?: number | undefined;
    montantNetVerseFondsEuro?: number | undefined;
    montantBrutVerseFondsUC?: number | undefined;
    montantFraisVersementFondsUC?: number | undefined;
    montantNetVerseFondsUC?: number | undefined;

    constructor(data?: IVersement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantBrutVerseFondsEuro = _data["montantBrutVerseFondsEuro"];
            this.montantFraisVersementFondsEuro = _data["montantFraisVersementFondsEuro"];
            this.montantNetVerseFondsEuro = _data["montantNetVerseFondsEuro"];
            this.montantBrutVerseFondsUC = _data["montantBrutVerseFondsUC"];
            this.montantFraisVersementFondsUC = _data["montantFraisVersementFondsUC"];
            this.montantNetVerseFondsUC = _data["montantNetVerseFondsUC"];
        }
    }

    static fromJS(data: any): Versement {
        data = typeof data === 'object' ? data : {};
        let result = new Versement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantBrutVerseFondsEuro"] = this.montantBrutVerseFondsEuro;
        data["montantFraisVersementFondsEuro"] = this.montantFraisVersementFondsEuro;
        data["montantNetVerseFondsEuro"] = this.montantNetVerseFondsEuro;
        data["montantBrutVerseFondsUC"] = this.montantBrutVerseFondsUC;
        data["montantFraisVersementFondsUC"] = this.montantFraisVersementFondsUC;
        data["montantNetVerseFondsUC"] = this.montantNetVerseFondsUC;
        return data;
    }
}

export interface IVersement {
    montantBrutVerseFondsEuro?: number | undefined;
    montantFraisVersementFondsEuro?: number | undefined;
    montantNetVerseFondsEuro?: number | undefined;
    montantBrutVerseFondsUC?: number | undefined;
    montantFraisVersementFondsUC?: number | undefined;
    montantNetVerseFondsUC?: number | undefined;
}

export class ZoneGeographique implements IZoneGeographique {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IZoneGeographique) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): ZoneGeographique {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGeographique();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IZoneGeographique {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: number | undefined;
}

export class CoordonneesBancaires implements ICoordonneesBancaires {
    rUM?: string | undefined;
    iBAN?: string | undefined;
    codeBIC?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateSignature?: string | undefined;
    numeroInterneSocietaire?: number | undefined;
    polices?: Police4[] | undefined;

    constructor(data?: ICoordonneesBancaires) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rUM = _data["RUM"];
            this.iBAN = _data["IBAN"];
            this.codeBIC = _data["codeBIC"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateSignature = _data["dateSignature"];
            this.numeroInterneSocietaire = _data["numeroInterneSocietaire"];
            if (Array.isArray(_data["polices"])) {
                this.polices = [] as any;
                for (let item of _data["polices"])
                    this.polices!.push(Police4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoordonneesBancaires {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesBancaires();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RUM"] = this.rUM;
        data["IBAN"] = this.iBAN;
        data["codeBIC"] = this.codeBIC;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateSignature"] = this.dateSignature;
        data["numeroInterneSocietaire"] = this.numeroInterneSocietaire;
        if (Array.isArray(this.polices)) {
            data["polices"] = [];
            for (let item of this.polices)
                data["polices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICoordonneesBancaires {
    rUM?: string | undefined;
    iBAN?: string | undefined;
    codeBIC?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateSignature?: string | undefined;
    numeroInterneSocietaire?: number | undefined;
    polices?: Police4[] | undefined;
}

export class CreateMandatRequest implements ICreateMandatRequest {
    mandat?: Mandat2;

    constructor(data?: ICreateMandatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandat = _data["mandat"] ? Mandat2.fromJS(_data["mandat"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMandatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMandatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandat"] = this.mandat ? this.mandat.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateMandatRequest {
    mandat?: Mandat2;
}

export class CreateMandatResponse implements ICreateMandatResponse {
    codeRetour?: number | undefined;
    message?: string | undefined;
    erreurs?: Erreur10[] | undefined;

    constructor(data?: ICreateMandatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.message = _data["message"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur10.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMandatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMandatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["message"] = this.message;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMandatResponse {
    codeRetour?: number | undefined;
    message?: string | undefined;
    erreurs?: Erreur10[] | undefined;
}

export class Debiteur implements IDebiteur {
    nom?: string | undefined;
    prenom?: string | undefined;
    iBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IDebiteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.iBAN = _data["IBAN"];
            this.codeBIC = _data["codeBIC"];
            this.adresse = _data["adresse"];
            this.adresseComp = _data["adresseComp"];
            this.adresseComp2 = _data["adresseComp2"];
            this.lieuDit = _data["lieuDit"];
            this.codePostal = _data["codePostal"];
            this.ville = _data["ville"];
            this.pays = _data["pays"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Debiteur {
        data = typeof data === 'object' ? data : {};
        let result = new Debiteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["IBAN"] = this.iBAN;
        data["codeBIC"] = this.codeBIC;
        data["adresse"] = this.adresse;
        data["adresseComp"] = this.adresseComp;
        data["adresseComp2"] = this.adresseComp2;
        data["lieuDit"] = this.lieuDit;
        data["codePostal"] = this.codePostal;
        data["ville"] = this.ville;
        data["pays"] = this.pays;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        return data;
    }
}

export interface IDebiteur {
    nom?: string | undefined;
    prenom?: string | undefined;
    iBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
}

export class Erreur10 implements IErreur10 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur10 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur10 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetBICFromIBANRequest implements IGetBICFromIBANRequest {
    iBAN?: string | undefined;

    constructor(data?: IGetBICFromIBANRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iBAN = _data["IBAN"];
        }
    }

    static fromJS(data: any): GetBICFromIBANRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBICFromIBANRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.iBAN;
        return data;
    }
}

export interface IGetBICFromIBANRequest {
    iBAN?: string | undefined;
}

export class GetBICFromIBANResponse implements IGetBICFromIBANResponse {
    bIC?: string | undefined;
    erreurs?: Erreur10[] | undefined;

    constructor(data?: IGetBICFromIBANResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bIC = _data["BIC"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur10.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBICFromIBANResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBICFromIBANResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BIC"] = this.bIC;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBICFromIBANResponse {
    bIC?: string | undefined;
    erreurs?: Erreur10[] | undefined;
}

export class Mandat2 implements IMandat2 {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    rUM?: string | undefined;
    dateSignature?: string | undefined;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    iBANSocInt?: string | undefined;
    debiteur?: Debiteur;
    polices?: Police4[] | undefined;

    constructor(data?: IMandat2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idCrediteur = _data["idCrediteur"];
            this.nomCrediteur = _data["nomCrediteur"];
            this.rUM = _data["RUM"];
            this.dateSignature = _data["dateSignature"];
            this.lieuSignature = _data["lieuSignature"];
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
            this.numeroSocietaireExterne = _data["numeroSocietaireExterne"];
            this.iBANSocInt = _data["IBANSocInt"];
            this.debiteur = _data["debiteur"] ? Debiteur.fromJS(_data["debiteur"]) : undefined as any;
            if (Array.isArray(_data["polices"])) {
                this.polices = [] as any;
                for (let item of _data["polices"])
                    this.polices!.push(Police4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Mandat2 {
        data = typeof data === 'object' ? data : {};
        let result = new Mandat2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCrediteur"] = this.idCrediteur;
        data["nomCrediteur"] = this.nomCrediteur;
        data["RUM"] = this.rUM;
        data["dateSignature"] = this.dateSignature;
        data["lieuSignature"] = this.lieuSignature;
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        data["numeroSocietaireExterne"] = this.numeroSocietaireExterne;
        data["IBANSocInt"] = this.iBANSocInt;
        data["debiteur"] = this.debiteur ? this.debiteur.toJSON() : undefined as any;
        if (Array.isArray(this.polices)) {
            data["polices"] = [];
            for (let item of this.polices)
                data["polices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMandat2 {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    rUM?: string | undefined;
    dateSignature?: string | undefined;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    iBANSocInt?: string | undefined;
    debiteur?: Debiteur;
    polices?: Police4[] | undefined;
}

export class Police4 implements IPolice4 {
    noContrat?: number;

    constructor(data?: IPolice4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): Police4 {
        data = typeof data === 'object' ? data : {};
        let result = new Police4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IPolice4 {
    noContrat?: number;
}

export class SearchMandatRequest implements ISearchMandatRequest {
    societaire?: Societaire;

    constructor(data?: ISearchMandatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchMandatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMandatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["societaire"] = this.societaire ? this.societaire.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchMandatRequest {
    societaire?: Societaire;
}

export class SearchMandatResponse implements ISearchMandatResponse {
    coordonneesBancaires?: CoordonneesBancaires[] | undefined;
    erreurs?: Erreur10[] | undefined;

    constructor(data?: ISearchMandatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesBancaires"])) {
                this.coordonneesBancaires = [] as any;
                for (let item of _data["coordonneesBancaires"])
                    this.coordonneesBancaires!.push(CoordonneesBancaires.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur10.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchMandatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMandatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesBancaires)) {
            data["coordonneesBancaires"] = [];
            for (let item of this.coordonneesBancaires)
                data["coordonneesBancaires"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchMandatResponse {
    coordonneesBancaires?: CoordonneesBancaires[] | undefined;
    erreurs?: Erreur10[] | undefined;
}

export class Societaire implements ISocietaire {
    numeroInterne?: number;
    iBAN?: string | undefined;
    tousMandats?: boolean | undefined;

    constructor(data?: ISocietaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.iBAN = _data["IBAN"];
            this.tousMandats = _data["tousMandats"];
        }
    }

    static fromJS(data: any): Societaire {
        data = typeof data === 'object' ? data : {};
        let result = new Societaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["IBAN"] = this.iBAN;
        data["tousMandats"] = this.tousMandats;
        return data;
    }
}

export interface ISocietaire {
    numeroInterne?: number;
    iBAN?: string | undefined;
    tousMandats?: boolean | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}